/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
    [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
    [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
    [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
    T extends { [key: string]: unknown },
    K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
    | T
    | {
          [P in keyof T]?: P extends ' $fragmentName' | '__typename'
              ? T[P]
              : never;
      };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
    ID: { input: string; output: string };
    String: { input: string; output: string };
    Boolean: { input: boolean; output: boolean };
    Int: { input: number; output: number };
    Float: { input: number; output: number };
    ApiResponse: { input: any; output: any };
    /** The `BigInt` scalar type represents non-fractional signed whole numeric values. */
    BigInt: { input: any; output: any };
    Date: { input: string; output: string };
    /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
    DateTime: { input: any; output: any };
    /** Arbitrary data encoded in JavaScript Object Notation. See https://www.json.org. */
    JSON: { input: string; output: string };
    JSONObject: { input: any; output: any };
    /**
     * Loose type that allows any value. Be careful when passing in large `Int` or `Float` literals,
     * as they may not be parsed correctly on the server side. Use `String` literals if you are
     * dealing with really large numbers to be on the safe side.
     */
    Mixed: { input: any; output: any };
};

export type ActualizarDatosFacturaSegunTusFacturasResp = {
    __typename?: 'ActualizarDatosFacturaSegunTusFacturasResp';
    datos?: Maybe<Scalars['JSON']['output']>;
    mensaje?: Maybe<Scalars['String']['output']>;
    ok: Scalars['Boolean']['output'];
};

export type ActualizarDatosNotaCreditoSegunTusFacturasResp = {
    __typename?: 'ActualizarDatosNotaCreditoSegunTusFacturasResp';
    datos?: Maybe<Scalars['JSON']['output']>;
    mensaje?: Maybe<Scalars['String']['output']>;
    ok: Scalars['Boolean']['output'];
};

export type AnularTrialParams = {
    comentario?: InputMaybe<Scalars['String']['input']>;
    cuenta_id: Scalars['String']['input'];
};

export type AuditLog = {
    __typename?: 'AuditLog';
    comments?: Maybe<Scalars['String']['output']>;
    created_at?: Maybe<Scalars['DateTime']['output']>;
    cuenta_id?: Maybe<Scalars['String']['output']>;
    data?: Maybe<Scalars['JSONObject']['output']>;
    es_admin: Scalars['Boolean']['output'];
    es_auto: Scalars['Boolean']['output'];
    id: Scalars['String']['output'];
    key: Scalars['String']['output'];
    user_id?: Maybe<Scalars['String']['output']>;
    usuario?: Maybe<Usuario>;
};

export type Bloqueo = {
    __typename?: 'Bloqueo';
    bloqueada_event_id?: Maybe<Scalars['String']['output']>;
    bloqueada_mail_id?: Maybe<Scalars['String']['output']>;
    cuenta?: Maybe<Cuenta>;
    cuenta_id: Scalars['String']['output'];
    desbloqueada_event_id?: Maybe<Scalars['String']['output']>;
    desbloqueada_mail_id?: Maybe<Scalars['String']['output']>;
    fecha_bloqueo: Scalars['Date']['output'];
    fecha_desbloqueo?: Maybe<Scalars['Date']['output']>;
    id: Scalars['String']['output'];
    motivo: BloqueoMotivos;
    ultimo?: Maybe<Scalars['Boolean']['output']>;
};

export type BloqueoEdge = {
    __typename?: 'BloqueoEdge';
    cursor: Scalars['String']['output'];
    node: Bloqueo;
};

export enum BloqueoMotivos {
    BloqueoManual = 'BLOQUEO_MANUAL',
    CancelacionManualDesdeAdmin = 'CANCELACION_MANUAL_DESDE_ADMIN',
    CanceladaDesdeStripe = 'CANCELADA_DESDE_STRIPE',
    CanceladaPorCliente = 'CANCELADA_POR_CLIENTE',
    CanceladaPorPagoRechazado = 'CANCELADA_POR_PAGO_RECHAZADO',
    FaltaPago = 'FALTA_PAGO',
    FinTrial = 'FIN_TRIAL',
    MigracionCanceladaPorNosotros = 'MIGRACION_CANCELADA_POR_NOSOTROS',
    PagoTransferenciaDesestimado = 'PAGO_TRANSFERENCIA_DESESTIMADO',
    SinLimite = 'SIN_LIMITE',
    SuscripcionDesestimada = 'SUSCRIPCION_DESESTIMADA',
    TrialAnulado = 'TRIAL_ANULADO',
}

export type BloqueosConnection = {
    __typename?: 'BloqueosConnection';
    edges: Array<BloqueoEdge>;
    pageInfo: PageInfo;
};

export type BloqueosConnectionParams = {
    cuenta_id?: InputMaybe<Scalars['String']['input']>;
    fecha_desde?: InputMaybe<Scalars['String']['input']>;
    fecha_hasta?: InputMaybe<Scalars['String']['input']>;
    motivo?: InputMaybe<Scalars['String']['input']>;
    text?: InputMaybe<Scalars['String']['input']>;
};

export type BonificarCuentaParams = {
    cuenta_id: Scalars['String']['input'];
    fecha?: InputMaybe<Scalars['String']['input']>;
    motivo: Scalars['String']['input'];
};

export type BuscarCuentasFiltros = {
    /**
     * Busca en:
     * legacy_id
     * tn_store_id
     * nombre
     * documento
     * razon_social
     * email_pagos
     * email_desde_legacy
     * tienda_url
     * pasarela_id de todas sus suscripciones
     */
    search: Scalars['String']['input'];
};

export type BuscarCuentasQueryParams = {
    filtros?: InputMaybe<BuscarCuentasFiltros>;
    firsts?: InputMaybe<Scalars['Int']['input']>;
};

export type CambiarDatosFacturacionParams = {
    condicion_ante_iva?: InputMaybe<Scalars['String']['input']>;
    cuenta_id: Scalars['String']['input'];
    documento?: InputMaybe<Scalars['String']['input']>;
    domicilio?: InputMaybe<Scalars['String']['input']>;
    razon_social?: InputMaybe<Scalars['String']['input']>;
    tipo_doc?: InputMaybe<Scalars['String']['input']>;
};

export type Cobro = {
    __typename?: 'Cobro';
    created_at?: Maybe<Scalars['Date']['output']>;
    cuenta?: Maybe<Cuenta>;
    cuenta_id: Scalars['String']['output'];
    devuelto?: Maybe<Scalars['Boolean']['output']>;
    devuelto_fecha?: Maybe<Scalars['String']['output']>;
    en_proceso_archivar_factura_empezado?: Maybe<Scalars['Date']['output']>;
    en_proceso_archivar_factura_error?: Maybe<Scalars['String']['output']>;
    en_proceso_archivar_factura_estado?: Maybe<EstadoJob>;
    en_proceso_archivar_nota_credito_empezado?: Maybe<
        Scalars['Date']['output']
    >;
    en_proceso_archivar_nota_credito_error?: Maybe<Scalars['String']['output']>;
    en_proceso_archivar_nota_credito_estado?: Maybe<EstadoJob>;
    en_proceso_facturar_en_afip_empezado?: Maybe<Scalars['Date']['output']>;
    en_proceso_facturar_en_afip_error?: Maybe<Scalars['String']['output']>;
    en_proceso_facturar_en_afip_estado?: Maybe<EstadoCobroApi>;
    en_proceso_facturar_en_afip_nota_credito_empezado?: Maybe<
        Scalars['Date']['output']
    >;
    en_proceso_facturar_en_afip_nota_credito_error?: Maybe<
        Scalars['String']['output']
    >;
    en_proceso_facturar_en_afip_nota_credito_estado?: Maybe<EstadoCobroApi>;
    facturado_en_afip?: Maybe<Scalars['Boolean']['output']>;
    facturado_manual?: Maybe<Scalars['Boolean']['output']>;
    fecha_cobro?: Maybe<Scalars['String']['output']>;
    fecha_estimada_acreditacion?: Maybe<Scalars['String']['output']>;
    fecha_facturado_afip?: Maybe<Scalars['String']['output']>;
    fecha_marcada_para_facturar?: Maybe<Scalars['String']['output']>;
    fecha_nota_credito_emitida_afip?: Maybe<Scalars['String']['output']>;
    id: Scalars['String']['output'];
    metodo_pago?: Maybe<Scalars['String']['output']>;
    monto?: Maybe<Scalars['Int']['output']>;
    no_facturar?: Maybe<Scalars['Boolean']['output']>;
    numero_factura_propia?: Maybe<Scalars['String']['output']>;
    numero_nota_credito_propia?: Maybe<Scalars['String']['output']>;
    pasarela?: Maybe<Scalars['String']['output']>;
    pasarela_id?: Maybe<Scalars['String']['output']>;
    pdf?: Maybe<Scalars['String']['output']>;
    pdf_factura_archivado?: Maybe<Scalars['Boolean']['output']>;
    pdf_nota_credito?: Maybe<Scalars['String']['output']>;
    pdf_nota_credito_archivado?: Maybe<Scalars['Boolean']['output']>;
    suscripcion_id?: Maybe<Scalars['String']['output']>;
    tipo_factura?: Maybe<Scalars['String']['output']>;
    tipo_nota_credito?: Maybe<Scalars['String']['output']>;
    updated_at?: Maybe<Scalars['Date']['output']>;
};

export type CobroParaFacturarInput = {
    id: Scalars['String']['input'];
    marcar: Scalars['Boolean']['input'];
};

export type Contratacion = {
    __typename?: 'Contratacion';
    created_at?: Maybe<Scalars['DateTime']['output']>;
    cuenta?: Maybe<Cuenta>;
    cuenta_id: Scalars['String']['output'];
    error_al_crear_suscriptor?: Maybe<Scalars['String']['output']>;
    estado?: Maybe<EstadoContratacionZenRise>;
    estado_full?: Maybe<Scalars['String']['output']>;
    fsm_error?: Maybe<Scalars['JSON']['output']>;
    id: Scalars['String']['output'];
    plan?: Maybe<Plan>;
    plan_id?: Maybe<Scalars['String']['output']>;
    ultima?: Maybe<Scalars['Boolean']['output']>;
    updated_at?: Maybe<Scalars['DateTime']['output']>;
    zenrise_id?: Maybe<Scalars['String']['output']>;
};

export type ContratacionesConnection = {
    __typename?: 'ContratacionesConnection';
    edges: Array<Contratacion>;
    pageInfo: PageInfo;
};

export type ContratacionesFilters = {
    cuenta_id?: InputMaybe<Scalars['String']['input']>;
    estado?: InputMaybe<EstadoContratacionZenRise>;
    estados?: InputMaybe<Array<EstadoContratacionZenRise>>;
    incluye_viejas?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContratacionesQueryParams = {
    after?: InputMaybe<Scalars['String']['input']>;
    filterConSuscripcion?: InputMaybe<Scalars['Boolean']['input']>;
    firsts?: InputMaybe<Scalars['Int']['input']>;
    ids?: InputMaybe<Array<Scalars['String']['input']>>;
    incluyeViejas?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CrearCuentaManualmenteParams = {
    cid: Scalars['String']['input'];
    cuentaId: Scalars['String']['input'];
    nombre: Scalars['String']['input'];
    pais: Scalars['String']['input'];
    udn: Scalars['String']['input'];
};

export type CrearUsuarioManualmenteParams = {
    cid: Scalars['String']['input'];
    cuentaId: Scalars['String']['input'];
    email: Scalars['String']['input'];
    password: Scalars['String']['input'];
    uid: Scalars['String']['input'];
    usuarioId: Scalars['String']['input'];
};

export type CrearUsuarioSuperAdminParams = {
    email: Scalars['String']['input'];
    password: Scalars['String']['input'];
    uid: Scalars['String']['input'];
    usuarioId?: InputMaybe<Scalars['String']['input']>;
};

export type Cuenta = {
    __typename?: 'Cuenta';
    auditLogs: Array<AuditLog>;
    bloqueada?: Maybe<Scalars['Boolean']['output']>;
    bloqueoActivo?: Maybe<Bloqueo>;
    bloqueo_fecha?: Maybe<Scalars['Date']['output']>;
    bloqueo_razon?: Maybe<BloqueoMotivos>;
    bloqueos: Array<Bloqueo>;
    bonificacion_fecha_inicio?: Maybe<Scalars['String']['output']>;
    bonificacion_motivo?: Maybe<Scalars['String']['output']>;
    cobros?: Maybe<Array<Maybe<Cobro>>>;
    condicion_ante_iva?: Maybe<Scalars['String']['output']>;
    contratacionActiva?: Maybe<Contratacion>;
    datos_desde_tn?: Maybe<Scalars['JSON']['output']>;
    datos_desde_tn_traidos?: Maybe<Scalars['Date']['output']>;
    /** @deprecated No longer supported */
    datos_desde_tn_traidos_error?: Maybe<Scalars['String']['output']>;
    datos_desde_tn_traidos_error_code?: Maybe<Scalars['String']['output']>;
    datos_desde_tn_traidos_error_desc?: Maybe<Scalars['String']['output']>;
    datos_desde_tn_traidos_error_fecha?: Maybe<Scalars['Date']['output']>;
    datos_desde_tn_traidos_error_resp?: Maybe<Scalars['JSON']['output']>;
    documento?: Maybe<Scalars['String']['output']>;
    domicilio?: Maybe<Scalars['String']['output']>;
    email_desde_legacy?: Maybe<Scalars['String']['output']>;
    email_pagos?: Maybe<Scalars['String']['output']>;
    fecha_aplicacion_limite?: Maybe<Scalars['String']['output']>;
    id: Scalars['String']['output'];
    invoices?: Maybe<Array<Maybe<InvoiceZenRise>>>;
    legacy_id?: Maybe<Scalars['String']['output']>;
    migracion?: Maybe<Migracion>;
    nombre?: Maybe<Scalars['String']['output']>;
    pais?: Maybe<Scalars['String']['output']>;
    razon_social?: Maybe<Scalars['String']['output']>;
    razon_udn: Scalars['String']['output'];
    roles?: Maybe<Array<Maybe<Rol>>>;
    sparkline?: Maybe<Array<Maybe<Scalars['BigInt']['output']>>>;
    stats?: Maybe<Stats>;
    stripe_customer_id?: Maybe<Scalars['String']['output']>;
    /** @deprecated No longer supported */
    stripe_habilitado: Scalars['Boolean']['output'];
    suscripcionActiva?: Maybe<Suscripcion>;
    suscripciones?: Maybe<Array<Maybe<Suscripcion>>>;
    tienda_url?: Maybe<Scalars['String']['output']>;
    tipo_doc?: Maybe<Scalars['String']['output']>;
    tn_store_id?: Maybe<Scalars['String']['output']>;
    trial?: Maybe<Trial>;
    trial_id?: Maybe<Scalars['String']['output']>;
    udn: Scalars['String']['output'];
    uso?: Maybe<Uso>;
};

export type CuentaStatsArgs = {
    args: StatsArgs;
};

export type CuentaConProblemas = {
    __typename?: 'CuentaConProblemas';
    cuenta_id: Scalars['String']['output'];
    nombre: Scalars['String']['output'];
    problemas?: Maybe<Scalars['JSON']['output']>;
};

export type CuentaDesbloqueadaSinMotivo = {
    __typename?: 'CuentaDesbloqueadaSinMotivo';
    cuenta?: Maybe<Cuenta>;
    /** Este es el id de la cuenta */
    id: Scalars['String']['output'];
    nombre?: Maybe<Scalars['String']['output']>;
};

export type CuentaEnAuth = {
    __typename?: 'CuentaEnAuth';
    cid?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['Date']['output']>;
    createdByUserId?: Maybe<Scalars['String']['output']>;
    fecha_creacion?: Maybe<Scalars['Date']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    nombre?: Maybe<Scalars['String']['output']>;
    pais?: Maybe<Scalars['String']['output']>;
    roles?: Maybe<Array<Maybe<Rol>>>;
    udn?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type CuentaEnDunningZenrise = {
    __typename?: 'CuentaEnDunningZenrise';
    bloqueada: Scalars['Boolean']['output'];
    cuenta_id: Scalars['String']['output'];
    datos_desde_tn_traidos?: Maybe<Scalars['Date']['output']>;
    datos_desde_tn_traidos_error_code?: Maybe<Scalars['String']['output']>;
    datos_desde_tn_traidos_error_desc?: Maybe<Scalars['String']['output']>;
    datos_desde_tn_traidos_error_fecha?: Maybe<Scalars['Date']['output']>;
    dunning_empezado?: Maybe<Scalars['String']['output']>;
    email_desde_legacy?: Maybe<Scalars['String']['output']>;
    errores_zr?: Maybe<Scalars['JSON']['output']>;
    estado_zenrise?: Maybe<Scalars['String']['output']>;
    fecha_emision: Scalars['String']['output'];
    fecha_proximo_pago: Scalars['String']['output'];
    fecha_ultimo_error?: Maybe<Scalars['String']['output']>;
    intentos?: Maybe<Scalars['Int']['output']>;
    last_task_created_at?: Maybe<Scalars['String']['output']>;
    last_task_id?: Maybe<Scalars['String']['output']>;
    last_task_nombre?: Maybe<Scalars['String']['output']>;
    last_task_resultado_ok?: Maybe<Scalars['Boolean']['output']>;
    mensaje_ultimo_error?: Maybe<Scalars['String']['output']>;
    nombre: Scalars['String']['output'];
    pais?: Maybe<Scalars['String']['output']>;
    udn?: Maybe<Scalars['String']['output']>;
};

export type CuentaEnLegacy = {
    __typename?: 'CuentaEnLegacy';
    /** El id de usuario en auth, pero como lo tiene legacy */
    auth_id?: Maybe<Scalars['String']['output']>;
    bloqueo_event_id?: Maybe<Scalars['String']['output']>;
    bloqueo_fecha?: Maybe<Scalars['String']['output']>;
    cid?: Maybe<Scalars['String']['output']>;
    datos_desde_tn?: Maybe<Scalars['String']['output']>;
    datos_desde_tn_ultimo_update?: Maybe<Scalars['String']['output']>;
    email?: Maybe<Scalars['String']['output']>;
    estado?: Maybe<Scalars['String']['output']>;
    estado_auth?: Maybe<Scalars['String']['output']>;
    estado_tn?: Maybe<Scalars['String']['output']>;
    fecha_migracion_usuario?: Maybe<Scalars['String']['output']>;
    /** El nuevo id */
    id?: Maybe<Scalars['String']['output']>;
    informativaConfig: InformativaConfig;
    legacy_id?: Maybe<Scalars['String']['output']>;
    nombre_en_legacy?: Maybe<Scalars['String']['output']>;
    pais?: Maybe<Scalars['String']['output']>;
    settings: Settings;
    /** alias de tn_store_id */
    sid: Scalars['String']['output'];
    site_name?: Maybe<Scalars['String']['output']>;
    site_url?: Maybe<Scalars['String']['output']>;
    tn_plan?: Maybe<Scalars['String']['output']>;
    tn_store_name?: Maybe<Scalars['String']['output']>;
    udn?: Maybe<Scalars['String']['output']>;
    ultimasVentasConfig: UltimasVentasConfig;
    /** El id de usuario en legacy */
    user_id?: Maybe<Scalars['String']['output']>;
};

export type CuentaFiltros = {
    /** true solo blockeadas, falso solo no blockeadas */
    bloqueadas?: InputMaybe<Scalars['Boolean']['input']>;
    /**
     * Busca en:
     * legacy_id
     * tn_store_id
     * nombre
     * documento
     * razon_social
     * email_pagos
     * email_desde_legacy
     * tienda_url
     */
    search?: InputMaybe<Scalars['String']['input']>;
};

export type CuentasConPagosConProblemas = {
    __typename?: 'CuentasConPagosConProblemas';
    cuenta?: Maybe<Cuenta>;
    cuenta_id: Scalars['String']['output'];
    email_desde_legacy?: Maybe<Scalars['String']['output']>;
    fecha_emision?: Maybe<Scalars['String']['output']>;
    fecha_error?: Maybe<Scalars['Date']['output']>;
    invoice_id: Scalars['String']['output'];
    mensaje_error?: Maybe<Scalars['String']['output']>;
    nombre?: Maybe<Scalars['String']['output']>;
    pais?: Maybe<Scalars['String']['output']>;
    zenrise_id?: Maybe<Scalars['String']['output']>;
};

export type CuentasInputParams = {
    after?: InputMaybe<Scalars['String']['input']>;
    firsts?: InputMaybe<Scalars['Int']['input']>;
    ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CuentasQueryParams = {
    after?: InputMaybe<Scalars['String']['input']>;
    filtros?: InputMaybe<CuentaFiltros>;
    firsts?: InputMaybe<Scalars['Int']['input']>;
    ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CursorPaginationParams = {
    after?: InputMaybe<Scalars['String']['input']>;
    firsts: Scalars['Int']['input'];
};

export type DashboardSuscripciones = {
    __typename?: 'DashboardSuscripciones';
    ClientesActivos?: Maybe<Scalars['String']['output']>;
    TicketPromedio?: Maybe<Scalars['String']['output']>;
    mensual?: Maybe<Scalars['String']['output']>;
    mensual_con_iva?: Maybe<Scalars['String']['output']>;
};

export type DataLoaderParams = {
    ids: Array<Scalars['String']['input']>;
};

export type DunningPreview = {
    __typename?: 'DunningPreview';
    already_executed: Scalars['Boolean']['output'];
    cuenta?: Maybe<Cuenta>;
    cuenta_id: Scalars['String']['output'];
    dunning_empezado: Scalars['String']['output'];
    task: Scalars['String']['output'];
};

export enum EstadoCobroApi {
    Emitido = 'EMITIDO',
    Empezando = 'EMPEZANDO',
    Encolado = 'ENCOLADO',
    ErrorAlEnviarAApi = 'ERROR_AL_ENVIAR_A_API',
    EsperandoWebhook = 'ESPERANDO_WEBHOOK',
}

export enum EstadoContratacionZenRise {
    CrearSuscriptorZenriseError = 'CREAR_SUSCRIPTOR_ZENRISE_ERROR',
    Desestimada = 'DESESTIMADA',
    DesestimadaPorPagoRechazado = 'DESESTIMADA_POR_PAGO_RECHAZADO',
    Desestimando = 'DESESTIMANDO',
    DesestimandoError = 'DESESTIMANDO_ERROR',
    DesestimandoPorPagoRechazado = 'DESESTIMANDO_POR_PAGO_RECHAZADO',
    DesestimandoPorPagoRechazadoError = 'DESESTIMANDO_POR_PAGO_RECHAZADO_ERROR',
    EsperandoConfirmacionPago = 'ESPERANDO_CONFIRMACION_PAGO',
    EsperandoConfirmacionPagoError = 'ESPERANDO_CONFIRMACION_PAGO_ERROR',
    FinalizarError = 'FINALIZAR_ERROR',
    Inicial = 'INICIAL',
    ProcesandoConfirmacionPagoError = 'PROCESANDO_CONFIRMACION_PAGO_ERROR',
    Terminada = 'TERMINADA',
}

export type EstadoCuentasEnAuth = {
    __typename?: 'EstadoCuentasEnAuth';
    cuentas?: Maybe<Scalars['Int']['output']>;
    cuentas_con_pais?: Maybe<Scalars['Int']['output']>;
    cuentas_con_udn?: Maybe<Scalars['Int']['output']>;
    usuarios?: Maybe<Scalars['Int']['output']>;
};

export type EstadoCuentasEnLegacy = {
    __typename?: 'EstadoCuentasEnLegacy';
    bloqueadas?: Maybe<Scalars['Int']['output']>;
    con_pais?: Maybe<Scalars['Int']['output']>;
    con_udn?: Maybe<Scalars['Int']['output']>;
    no_bloqueadas?: Maybe<Scalars['Int']['output']>;
    sin_auth?: Maybe<Scalars['Int']['output']>;
    total?: Maybe<Scalars['Int']['output']>;
};

export type EstadoCuentasEnSubs = {
    __typename?: 'EstadoCuentasEnSubs';
    bloqueadas?: Maybe<Scalars['Int']['output']>;
    con_pais?: Maybe<Scalars['Int']['output']>;
    con_udn?: Maybe<Scalars['Int']['output']>;
    en_dunning?: Maybe<Scalars['Int']['output']>;
    en_migracion?: Maybe<Scalars['Int']['output']>;
    no_bloqueadas?: Maybe<Scalars['Int']['output']>;
    suscripcion_activa?: Maybe<Scalars['Int']['output']>;
    total?: Maybe<Scalars['Int']['output']>;
    trial?: Maybe<Scalars['Int']['output']>;
};

export enum EstadoIpn {
    PendienteProcesar = 'PENDIENTE_PROCESAR',
    Procesado = 'PROCESADO',
}

export enum EstadoJob {
    Empezado = 'EMPEZADO',
    Encolado = 'ENCOLADO',
    Error = 'ERROR',
    Esperando = 'ESPERANDO',
    Terminado = 'TERMINADO',
}

export enum EstadoMigracion {
    Cancelada = 'CANCELADA',
    CancelandoError = 'CANCELANDO_ERROR',
    EnGestionManual = 'EN_GESTION_MANUAL',
    Importada = 'IMPORTADA',
    ListaParaQueContrate = 'LISTA_PARA_QUE_CONTRATE',
    PreparandoParaContratacionError = 'PREPARANDO_PARA_CONTRATACION_ERROR',
}

export enum EstadoSuscripcion {
    Activa = 'ACTIVA',
    ActivandoError = 'ACTIVANDO_ERROR',
    ActivandoPorTransferenciaError = 'ACTIVANDO_POR_TRANSFERENCIA_ERROR',
    ActivandoProvisoriamentePorTransferenciaError = 'ACTIVANDO_PROVISORIAMENTE_POR_TRANSFERENCIA_ERROR',
    CambiandoPlan = 'CAMBIANDO_PLAN',
    Cancelada = 'CANCELADA',
    CanceladaConServicioHastaFinPeriodoPagado = 'CANCELADA_CON_SERVICIO_HASTA_FIN_PERIODO_PAGADO',
    CancelandoPorWebhookDesdeStripe = 'CANCELANDO_POR_WEBHOOK_DESDE_STRIPE',
    CreandoCobroManual = 'CREANDO_COBRO_MANUAL',
    CreandoCobroManualError = 'CREANDO_COBRO_MANUAL_ERROR',
    Desestimada = 'DESESTIMADA',
    ErrorCancelandoInmediatamenteManualPorAdmin = 'ERROR_CANCELANDO_INMEDIATAMENTE_MANUAL_POR_ADMIN',
    ErrorCancelandoPorFaltaPago = 'ERROR_CANCELANDO_POR_FALTA_PAGO',
    ErrorCancelandoPorWebhookDesdeStripe = 'ERROR_CANCELANDO_POR_WEBHOOK_DESDE_STRIPE',
    ErrorCancelarEnPasarela = 'ERROR_CANCELAR_EN_PASARELA',
    ErrorTerminandoCanceladaConServicioHastaFinPeriodoPagado = 'ERROR_TERMINANDO_CANCELADA_CON_SERVICIO_HASTA_FIN_PERIODO_PAGADO',
    MigracionPendientePrimerPago = 'MIGRACION_PENDIENTE_PRIMER_PAGO',
    PendienteAcreditarTransferencia = 'PENDIENTE_ACREDITAR_TRANSFERENCIA',
    PendienteAvisarCancelacionInmediataZenrise = 'PENDIENTE_AVISAR_CANCELACION_INMEDIATA_ZENRISE',
    PendienteAvisarCancelacionInmediataZenriseError = 'PENDIENTE_AVISAR_CANCELACION_INMEDIATA_ZENRISE_ERROR',
    PendientePrimerPago = 'PENDIENTE_PRIMER_PAGO',
}

export enum EstadoTrial {
    Activo = 'ACTIVO',
    Terminado = 'TERMINADO',
}

export enum EstadoWebhook {
    Desestimado = 'DESESTIMADO',
    Duplicado = 'DUPLICADO',
    PendienteProcesar = 'PENDIENTE_PROCESAR',
    Procesado = 'PROCESADO',
}

export type Events = {
    __typename?: 'Events';
    created_at?: Maybe<Scalars['Date']['output']>;
    cuenta_id?: Maybe<Scalars['String']['output']>;
    data?: Maybe<Scalars['JSON']['output']>;
    event_type?: Maybe<Scalars['String']['output']>;
    id: Scalars['String']['output'];
    source?: Maybe<Scalars['String']['output']>;
};

export type EventsConnection = {
    __typename?: 'EventsConnection';
    edges: Array<Events>;
    pageInfo: PageInfo;
};

export type EventsFilters = {
    cuenta_id?: InputMaybe<Scalars['String']['input']>;
    event_type?: InputMaybe<Scalars['String']['input']>;
    fecha_desde?: InputMaybe<Scalars['String']['input']>;
    fecha_hasta?: InputMaybe<Scalars['String']['input']>;
};

export type ExtenderTrialParams = {
    comentario?: InputMaybe<Scalars['String']['input']>;
    cuenta_id: Scalars['String']['input'];
    nueva_fecha_fin: Scalars['String']['input'];
};

export type FixSuscripcionManualParams = {
    contratacion_id?: InputMaybe<Scalars['String']['input']>;
    es_manual?: InputMaybe<Scalars['Boolean']['input']>;
    fecha_proximo_pago?: InputMaybe<Scalars['String']['input']>;
    fecha_ultimo_pago?: InputMaybe<Scalars['String']['input']>;
    legacy_id?: InputMaybe<Scalars['String']['input']>;
    nuevo_plan_id?: InputMaybe<Scalars['String']['input']>;
    nuevo_plan_pasarela_id?: InputMaybe<Scalars['String']['input']>;
    pasarela?: InputMaybe<Pasarela>;
    pasarela_id?: InputMaybe<Scalars['String']['input']>;
    pasarela_plan_id?: InputMaybe<Scalars['String']['input']>;
    plan_id?: InputMaybe<Scalars['String']['input']>;
};

export type GenericInputParams = {
    after?: InputMaybe<Scalars['String']['input']>;
    afterr?: InputMaybe<Scalars['String']['input']>;
    firsts?: InputMaybe<Scalars['Int']['input']>;
    ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type Ipn = {
    __typename?: 'IPN';
    body: Scalars['JSON']['output'];
    created_at: Scalars['DateTime']['output'];
    cuenta?: Maybe<Cuenta>;
    estado: EstadoIpn;
    externalReference: Scalars['String']['output'];
    id: Scalars['String']['output'];
    invoice?: Maybe<InvoiceZenRise>;
    invoiceId: Scalars['Int']['output'];
    resultado_mensaje?: Maybe<Scalars['String']['output']>;
    resultado_ok?: Maybe<Scalars['Boolean']['output']>;
    transactionId: Scalars['String']['output'];
    updated_at: Scalars['DateTime']['output'];
};

export type IpnParams = {
    after?: InputMaybe<Scalars['String']['input']>;
    filterByCuentaId?: InputMaybe<Scalars['String']['input']>;
    firsts?: InputMaybe<Scalars['Int']['input']>;
    ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type InformativaConfig = {
    __typename?: 'InformativaConfig';
    active: Scalars['Boolean']['output'];
    body?: Maybe<Scalars['String']['output']>;
    clickEnabled?: Maybe<Scalars['Boolean']['output']>;
    clickOpenNewTab?: Maybe<Scalars['Boolean']['output']>;
    clickUrl?: Maybe<Scalars['String']['output']>;
    displayTime: Scalars['Int']['output'];
    mobileDisabled: Scalars['Boolean']['output'];
    mobilePosition: MobilePosition;
    position: Position;
    showTo?: Maybe<ShowTargets>;
    template?: Maybe<Scalars['String']['output']>;
    theme?: Maybe<Theme>;
    title?: Maybe<Scalars['String']['output']>;
};

export type IniciarContratacionStripeParams = {
    cuenta_id: Scalars['String']['input'];
    stripe_price_id: Scalars['String']['input'];
};

export type IniciarContratacionStripeReturn = {
    __typename?: 'IniciarContratacionStripeReturn';
    mensaje_error?: Maybe<Scalars['String']['output']>;
    ok: Scalars['Boolean']['output'];
    url?: Maybe<Scalars['String']['output']>;
};

export type IniciarContratacionZenriseParams = {
    /** Este campo es para asignarle el ID creado desde front */
    contratacion_id: Scalars['String']['input'];
    cuenta_id: Scalars['String']['input'];
    dni: Scalars['String']['input'];
    es_tarjeta_credito: Scalars['Boolean']['input'];
    nombre: Scalars['String']['input'];
    plan_id: Scalars['String']['input'];
    token: Scalars['JSON']['input'];
};

export type IniciarContratacionZenriseResponse = {
    __typename?: 'IniciarContratacionZenriseResponse';
    mensaje_error?: Maybe<Scalars['String']['output']>;
    ok: Scalars['Boolean']['output'];
};

export type IniciarContratacionZenriseReturn = {
    __typename?: 'IniciarContratacionZenriseReturn';
    mensaje_error?: Maybe<Scalars['String']['output']>;
    ok: Scalars['Boolean']['output'];
};

export type InputBorrarNotificaciones = {
    cuenta_id: Scalars['String']['input'];
    ids: Array<InputMaybe<Scalars['String']['input']>>;
};

export type InputCancelarParams = {
    cuenta_id: Scalars['String']['input'];
    motivo_codigo?: InputMaybe<Scalars['String']['input']>;
    motivo_comentarios?: InputMaybe<Scalars['String']['input']>;
    motivo_texto?: InputMaybe<Scalars['String']['input']>;
};

export type InputInformativaConfig = {
    active?: InputMaybe<Scalars['Boolean']['input']>;
    body?: InputMaybe<Scalars['String']['input']>;
    clickEnabled?: InputMaybe<Scalars['Boolean']['input']>;
    clickOpenNewTab?: InputMaybe<Scalars['Boolean']['input']>;
    clickUrl?: InputMaybe<Scalars['String']['input']>;
    displayTime?: InputMaybe<Scalars['Int']['input']>;
    mobileDisabled?: InputMaybe<Scalars['Boolean']['input']>;
    mobilePosition?: InputMaybe<MobilePosition>;
    position?: InputMaybe<Position>;
    showTo?: InputMaybe<ShowTargets>;
    template?: InputMaybe<Scalars['String']['input']>;
    theme?: InputMaybe<ThemeInput>;
    title?: InputMaybe<Scalars['String']['input']>;
};

export type InputSettings = {
    active?: InputMaybe<Scalars['Boolean']['input']>;
    delayBetween?: InputMaybe<Scalars['Int']['input']>;
    gaeeEnabled?: InputMaybe<Scalars['Boolean']['input']>;
    informativaBody?: InputMaybe<Scalars['String']['input']>;
    informativaEnabled?: InputMaybe<Scalars['Boolean']['input']>;
    informativaTitle?: InputMaybe<Scalars['String']['input']>;
    initialDelay?: InputMaybe<Scalars['Int']['input']>;
    startOnScroll?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputUltimasVentasConfig = {
    active?: InputMaybe<Scalars['Boolean']['input']>;
    clickEnabled?: InputMaybe<Scalars['Boolean']['input']>;
    clickOpenNewTab?: InputMaybe<Scalars['Boolean']['input']>;
    displayTime?: InputMaybe<Scalars['Int']['input']>;
    hideCliente?: InputMaybe<Scalars['Boolean']['input']>;
    hideClienteAlternative?: InputMaybe<Scalars['String']['input']>;
    hideTimeAgo?: InputMaybe<Scalars['Boolean']['input']>;
    /** las horas, sólo válido si hideTimeAgo es falso */
    hideTimeAgoHs?: InputMaybe<Scalars['Int']['input']>;
    mobileDisabled?: InputMaybe<Scalars['Boolean']['input']>;
    mobilePosition?: InputMaybe<MobilePosition>;
    mobileSize?: InputMaybe<MobileSize2021>;
    position?: InputMaybe<Position>;
    showTo?: InputMaybe<ShowTargets>;
    sinceDays?: InputMaybe<Scalars['Int']['input']>;
    template?: InputMaybe<Scalars['String']['input']>;
    theme?: InputMaybe<ThemeInput>;
};

export type InvoiceZenRise = {
    __typename?: 'InvoiceZenRise';
    created_at?: Maybe<Scalars['Date']['output']>;
    cuenta?: Maybe<Cuenta>;
    cuenta_id?: Maybe<Scalars['String']['output']>;
    data?: Maybe<Scalars['JSON']['output']>;
    errores_zr?: Maybe<Scalars['JSON']['output']>;
    estado_zenrise?: Maybe<Scalars['String']['output']>;
    facturada_manual?: Maybe<Scalars['Boolean']['output']>;
    facturada_manual_ruta?: Maybe<Scalars['String']['output']>;
    fecha_emision?: Maybe<Scalars['String']['output']>;
    fecha_estimado_acreditacion?: Maybe<Scalars['String']['output']>;
    fecha_pago?: Maybe<Scalars['String']['output']>;
    id: Scalars['String']['output'];
    metodo_pago?: Maybe<Scalars['String']['output']>;
    monto?: Maybe<Scalars['Int']['output']>;
    numero_factura_propia?: Maybe<Scalars['String']['output']>;
    updated_at?: Maybe<Scalars['Date']['output']>;
    zenrise_id?: Maybe<Scalars['String']['output']>;
};

export type InvoiceZenRiseConnection = {
    __typename?: 'InvoiceZenRiseConnection';
    edges: Array<InvoiceZenRiseEdge>;
    pageInfo: PageInfo;
};

export type InvoiceZenRiseConnectionFilters = {
    cuenta_id?: InputMaybe<Scalars['String']['input']>;
    estado?: InputMaybe<Scalars['String']['input']>;
    fecha_acreditacion?: InputMaybe<Scalars['String']['input']>;
    fecha_acreditacion_desde?: InputMaybe<Scalars['String']['input']>;
    fecha_acreditacion_hasta?: InputMaybe<Scalars['String']['input']>;
    fecha_emision?: InputMaybe<Scalars['String']['input']>;
    fecha_emision_desde?: InputMaybe<Scalars['String']['input']>;
    fecha_emision_hasta?: InputMaybe<Scalars['String']['input']>;
    fecha_pago_real?: InputMaybe<Scalars['String']['input']>;
    fecha_pago_real_desde?: InputMaybe<Scalars['String']['input']>;
    fecha_pago_real_hasta?: InputMaybe<Scalars['String']['input']>;
    zenrise_id?: InputMaybe<Scalars['String']['input']>;
};

export type InvoiceZenRiseEdge = {
    __typename?: 'InvoiceZenRiseEdge';
    cursor: Scalars['String']['output'];
    node: InvoiceZenRise;
};

export type InvoiceZenriseImpaga = {
    __typename?: 'InvoiceZenriseImpaga';
    ultimo_error?: Maybe<Scalars['String']['output']>;
    zenrise_id: Scalars['Int']['output'];
};

export type IpnConnection = {
    __typename?: 'IpnConnection';
    edges: Array<IpnEdge>;
    pageInfo: PageInfo;
};

export type IpnConnectionFilters = {
    cuenta_id?: InputMaybe<Scalars['String']['input']>;
    ids?: InputMaybe<Array<Scalars['String']['input']>>;
    /** formato YYYY-MM-DD */
    since?: InputMaybe<Scalars['String']['input']>;
    /** formato YYYY-MM-DD */
    until?: InputMaybe<Scalars['String']['input']>;
};

export type IpnEdge = {
    __typename?: 'IpnEdge';
    cursor: Scalars['String']['output'];
    node: Ipn;
};

export type MailOutbox = {
    __typename?: 'MailOutbox';
    bounced?: Maybe<Scalars['Date']['output']>;
    bounced_classification?: Maybe<Scalars['String']['output']>;
    bounced_reason?: Maybe<Scalars['String']['output']>;
    created_at?: Maybe<Scalars['Date']['output']>;
    cuenta_id?: Maybe<Scalars['String']['output']>;
    delivered?: Maybe<Scalars['Date']['output']>;
    dropped?: Maybe<Scalars['Date']['output']>;
    dropped_reason?: Maybe<Scalars['String']['output']>;
    dynamic_data?: Maybe<Scalars['JSON']['output']>;
    id: Scalars['String']['output'];
    opened?: Maybe<Scalars['Date']['output']>;
    send_at?: Maybe<Scalars['Int']['output']>;
    sendgrid_message_id?: Maybe<Scalars['String']['output']>;
    template_id?: Maybe<Scalars['String']['output']>;
    to?: Maybe<Scalars['String']['output']>;
};

export type MailOutboxConnection = {
    __typename?: 'MailOutboxConnection';
    edges: Array<MailOutbox>;
    pageInfo: PageInfo;
};

export type MailOutboxFilters = {
    cuenta_id?: InputMaybe<Scalars['String']['input']>;
    fecha_desde?: InputMaybe<Scalars['String']['input']>;
    fecha_hasta?: InputMaybe<Scalars['String']['input']>;
    pendientes?: InputMaybe<Scalars['Boolean']['input']>;
    sendgrid_message_id?: InputMaybe<Scalars['String']['input']>;
    template_id?: InputMaybe<Scalars['String']['input']>;
    to?: InputMaybe<Scalars['String']['input']>;
};

export type Migracion = {
    __typename?: 'Migracion';
    analisis_comentario?: Maybe<Scalars['String']['output']>;
    analisis_fecha?: Maybe<Scalars['Date']['output']>;
    analisis_problema?: Maybe<Scalars['String']['output']>;
    analisis_prox_pago?: Maybe<Scalars['Date']['output']>;
    analisis_resultado?: Maybe<Scalars['Boolean']['output']>;
    analisis_ult_pago?: Maybe<Scalars['Date']['output']>;
    analisis_ult_pago_dias?: Maybe<Scalars['Int']['output']>;
    analisis_ult_pago_monto?: Maybe<Scalars['Int']['output']>;
    creada_en_legacy?: Maybe<Scalars['Date']['output']>;
    cuenta?: Maybe<Cuenta>;
    cuenta_id: Scalars['String']['output'];
    estado?: Maybe<EstadoMigracion>;
    estado_full?: Maybe<Scalars['String']['output']>;
    id: Scalars['String']['output'];
    json_importacion?: Maybe<Scalars['JSONObject']['output']>;
    legacy_estado?: Maybe<Scalars['String']['output']>;
    legacy_estado_tn?: Maybe<Scalars['String']['output']>;
    legacy_id?: Maybe<Scalars['String']['output']>;
    legacy_plan?: Maybe<Scalars['String']['output']>;
    suscripcion_id?: Maybe<Scalars['String']['output']>;
    tn_store_id?: Maybe<Scalars['String']['output']>;
};

export type MigracionesQueryParams = {
    after?: InputMaybe<Scalars['String']['input']>;
    estados?: InputMaybe<Array<EstadoMigracion>>;
    firsts?: InputMaybe<Scalars['Int']['input']>;
    /**
     * Busca en:
     * legacy_id
     * tn_store_id
     * nombre
     * documento
     * razon_social
     * email_pagos
     * email_desde_legacy
     * tienda_url
     */
    search?: InputMaybe<Scalars['String']['input']>;
    skipActivas?: InputMaybe<Scalars['Boolean']['input']>;
    skipBloqueadas?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum MobilePosition {
    Bottom = 'bottom',
    Top = 'top',
}

export enum MobileSize {
    Big = 'big',
    Medium = 'medium',
    Small = 'small',
}

export enum MobileSize2021 {
    Minimal = 'Minimal',
    Normal = 'Normal',
}

export type Mutation = {
    __typename?: 'Mutation';
    /** Borra notificaciones por id, y devuelve la cantidad de eventos borrados */
    BorrarNotificaciones?: Maybe<Scalars['Int']['output']>;
    CambiarInformativaConfig: Scalars['Boolean']['output'];
    CambiarSettings: Scalars['Boolean']['output'];
    CambiarUltimasVentasConfig: Scalars['Boolean']['output'];
    /** Va a TN y trae las últimas 20 ventas de este cliente */
    RefreshTNOrders?: Maybe<Scalars['Boolean']['output']>;
    /**
     * Pide los datos en TN y los guarda en la base
     * @deprecated use updateInfoDesdeTnAndReturn instead
     */
    UpdateInfoDesdeTn?: Maybe<Scalars['Boolean']['output']>;
    activateGeneralHold?: Maybe<Scalars['JSON']['output']>;
    actualizarDatosFacturaSegunTusFacturas: ActualizarDatosFacturaSegunTusFacturasResp;
    actualizarDatosNotaCreditoSegunTusFacturas: ActualizarDatosNotaCreditoSegunTusFacturasResp;
    analizarProblemaCuentas: Scalars['JSON']['output'];
    anularCancelacion: Scalars['Boolean']['output'];
    anularTrial: Scalars['Boolean']['output'];
    archivarFacturaPdf?: Maybe<Scalars['JSON']['output']>;
    archivarNotaCreditoPdf?: Maybe<Scalars['JSON']['output']>;
    auth_crearUsuarioParaPruebasLocales?: Maybe<Scalars['JSON']['output']>;
    bloquearCuenta: Scalars['Boolean']['output'];
    bloquearCuentasPorFinTrial?: Maybe<Scalars['Boolean']['output']>;
    bloquearCuentasSinLimite?: Maybe<Array<Maybe<Suscripcion>>>;
    bonificarCuenta: Scalars['Boolean']['output'];
    /** Recordar que hay que hacer signOut después de llamar a esta mutation */
    cambiarClave?: Maybe<Scalars['Boolean']['output']>;
    cambiarDatosFacturacion?: Maybe<Cuenta>;
    /** Recordar que hay que hacer signOut después de llamar a esta mutation */
    cambiarEmail?: Maybe<Scalars['Boolean']['output']>;
    cambiarPlanFinPeriodo?: Maybe<Scalars['JSON']['output']>;
    cambiarUdn: Scalars['String']['output'];
    cancelacionInmediataManual: Scalars['Boolean']['output'];
    cancelacionInmediataPorFaltaDePago: Scalars['Boolean']['output'];
    cancelar: Scalars['Boolean']['output'];
    cancelarSuscripcionesPorFaltaDePago?: Maybe<Array<Maybe<Suscripcion>>>;
    cancelarTodoEnZenrise?: Maybe<Scalars['JSON']['output']>;
    comenzarDunningManualmente?: Maybe<Scalars['Boolean']['output']>;
    confirmarAcreditacionPagoPorTransferencia: Scalars['Boolean']['output'];
    confirmarPagoManual?: Maybe<Scalars['Boolean']['output']>;
    corregirEmail: Scalars['Boolean']['output'];
    crearCuentaManualmente?: Maybe<CuentaEnAuth>;
    crearSuscripcionPagoManual?: Maybe<Scalars['Boolean']['output']>;
    crearUsuarioManualmente?: Maybe<Usuario>;
    crearUsuarioSuperAdmin?: Maybe<Usuario>;
    deactivateGeneralHold?: Maybe<Scalars['JSON']['output']>;
    desbloquearCuenta: Scalars['Boolean']['output'];
    desestimarContratacion: Scalars['Boolean']['output'];
    desestimarSubscripcionesViejas?: Maybe<Array<Maybe<Suscripcion>>>;
    desestimarSuscripcion: Scalars['Boolean']['output'];
    desestimarZenriseWebhook?: Maybe<ProcesarWebhookResultado>;
    dismissWaitingEmail?: Maybe<Scalars['JSON']['output']>;
    /** Dispara el evento 'cuenta-datos-actualizados', para forzar el refresco en otros microservicios */
    dispararEventoCuentaActualizada?: Maybe<Scalars['String']['output']>;
    dispararEventoCuentaRefresh?: Maybe<Scalars['String']['output']>;
    dispararFailsSub?: Maybe<Scalars['JSON']['output']>;
    dispararProcesoActualizarDatos?: Maybe<Scalars['JSON']['output']>;
    ejecutarDevolucionZenrise?: Maybe<Scalars['JSON']['output']>;
    ejecutarReporte: Scalars['JSONObject']['output'];
    ejecutarReporteAsincronico?: Maybe<Scalars['String']['output']>;
    emitirNotaCreditoEnAfip?: Maybe<Scalars['String']['output']>;
    extenderTrial: Scalars['Boolean']['output'];
    facturarEnAfip?: Maybe<Scalars['String']['output']>;
    facturarVariosEnAfip?: Maybe<Scalars['JSON']['output']>;
    fixAuditLogMeterCobros?: Maybe<Scalars['JSON']['output']>;
    fixContratacionesContext?: Maybe<Scalars['JSON']['output']>;
    fixCuentasSinNombre?: Maybe<Scalars['JSON']['output']>;
    fixDatosDesdeLegacy?: Maybe<Scalars['Boolean']['output']>;
    fixDatosDesdeLegacySinTN?: Maybe<Scalars['JSON']['output']>;
    fixDesdeUsuarioEnSt?: Maybe<Scalars['JSON']['output']>;
    /**
     * Aplica el cambio de plan, pero sin llamar a zenrise.
     * Es para cuando el cambio ya se hizo en ZR, pero fallamos en registrarlo en local
     */
    fixManualSuscripcion?: Maybe<Scalars['JSON']['output']>;
    fixMigracionesContext?: Maybe<Scalars['JSON']['output']>;
    fixSuscripcionContext?: Maybe<Scalars['JSON']['output']>;
    fixSuscripcionesDatosPlan?: Maybe<Scalars['JSON']['output']>;
    fixTrialsContext?: Maybe<Scalars['JSON']['output']>;
    fixUserMetadata?: Maybe<Scalars['JSON']['output']>;
    fixUsuario?: Maybe<Scalars['JSON']['output']>;
    /** Esto es para cuando la suscripción queda en ERROR_CANCELAR_EN_PASARELA pero se canceló bien en zenrise, sólo hay que mover la FSM */
    forzarCancelacion: Scalars['Boolean']['output'];
    forzarClave?: Maybe<Scalars['Boolean']['output']>;
    generarNuevoReporteSuscripcionesZenrise?: Maybe<Scalars['JSON']['output']>;
    importarSuscripcionActivaDesdeZenrise?: Maybe<Scalars['JSON']['output']>;
    informarPagoPorTransferencia: Scalars['Boolean']['output'];
    iniciarContratacionStripe: IniciarContratacionStripeReturn;
    iniciarContratacionZenrise: IniciarContratacionZenriseReturn;
    mandarPlanZenRise: Scalars['String']['output'];
    marcarCobrosParaFacturar?: Maybe<Scalars['Boolean']['output']>;
    marcarComoCancelada: Scalars['Boolean']['output'];
    migracionCancelar: Scalars['Boolean']['output'];
    migracionMarcarComoLista: Scalars['Boolean']['output'];
    migracionPasarGestionManual: Scalars['Boolean']['output'];
    msEmailTestHandler?: Maybe<Scalars['JSON']['output']>;
    msEmailTestQueueEmail?: Maybe<Scalars['JSON']['output']>;
    msEmailTestSendEmail?: Maybe<Scalars['JSON']['output']>;
    msEmailTestSentry?: Maybe<Scalars['JSON']['output']>;
    nuevoTrial?: Maybe<Scalars['Boolean']['output']>;
    obtenerLinkCobroZenrise: Scalars['String']['output'];
    pedirNuevoReporteZenrise: Scalars['String']['output'];
    procesarIPN: ProcesarIpnResultado;
    procesarTusFacturasWebhook: ProcesarWebhookResultado;
    procesarZenriseWebhook: ProcesarWebhookResultado;
    putHoldOnEmail?: Maybe<Scalars['JSON']['output']>;
    reactivarSuscripcionDesestimada?: Maybe<Scalars['Boolean']['output']>;
    recordarPagoConDebito?: Maybe<Scalars['JSON']['output']>;
    recuperarSuscripcionMalCancelada: Scalars['Boolean']['output'];
    redispararEvento?: Maybe<Scalars['JSON']['output']>;
    reemplazarCuentaId: Scalars['Boolean']['output'];
    registrarRenovacionPorTransferencia: Scalars['Boolean']['output'];
    releaseHoldOnEmail?: Maybe<Scalars['JSON']['output']>;
    salirDunningManualmente?: Maybe<Scalars['Boolean']['output']>;
    sendWaitingEmail?: Maybe<Scalars['JSON']['output']>;
    sincronizarEstadisticas?: Maybe<Scalars['JSON']['output']>;
    sincronizarStripePlans?: Maybe<Scalars['JSON']['output']>;
    stripeCrearPortalSession?: Maybe<Scalars['JSONObject']['output']>;
    subs_crearUsuarioParaPruebasLocales?: Maybe<Scalars['JSON']['output']>;
    /** Esta está en pleno desarrollo, no está para usarse todavía */
    terminarInstalacion?: Maybe<Scalars['JSON']['output']>;
    terminarSuscripcionCanceladaHastaPeriodoPagado?: Maybe<
        Scalars['Boolean']['output']
    >;
    terminarSuscripcionesQueEstabanHastaFinDePeriodo?: Maybe<
        Array<Maybe<Suscripcion>>
    >;
    terminarTrials?: Maybe<Scalars['Boolean']['output']>;
    testCrearCuentaEnTrial?: Maybe<Scalars['JSON']['output']>;
    testDispararReportesDiarios?: Maybe<Scalars['JSON']['output']>;
    testEmail?: Maybe<Scalars['JSON']['output']>;
    testEmailContratacionPagoRechazado?: Maybe<Scalars['JSON']['output']>;
    testEmailContratacionPagoRechazadoConError?: Maybe<
        Scalars['JSON']['output']
    >;
    /** @deprecated No longer supported */
    testImportarPagos?: Maybe<Scalars['Boolean']['output']>;
    testNuevoEmailAlMicro?: Maybe<Scalars['JSON']['output']>;
    testSimularIPNRecibido: Scalars['Boolean']['output'];
    testSimularTusFacturasWebhookRecibido: Scalars['Boolean']['output'];
    testSlackMessage?: Maybe<Scalars['Boolean']['output']>;
    testTask?: Maybe<Scalars['JSON']['output']>;
    testUserEnAuthMutation?: Maybe<Scalars['JSON']['output']>;
    testUserEnEmailMutation?: Maybe<Scalars['JSON']['output']>;
    testUserEnEventsMutation?: Maybe<Scalars['JSON']['output']>;
    testUserEnLegacyMutation?: Maybe<Scalars['Mixed']['output']>;
    testUserEnSubsMutation?: Maybe<Scalars['JSON']['output']>;
    /** Pide los datos en TN, los guarda en la base y los devuelve */
    updateInfoDesdeTnAndReturn: RespuestaUpdateInfoDesdeTnAndReturn;
    verificarInstalacion?: Maybe<Scalars['JSON']['output']>;
    volverATirarEventoCuentaCreada?: Maybe<Scalars['JSON']['output']>;
};

export type MutationBorrarNotificacionesArgs = {
    input: InputBorrarNotificaciones;
};

export type MutationCambiarInformativaConfigArgs = {
    cuenta_id: Scalars['String']['input'];
    input: InputInformativaConfig;
};

export type MutationCambiarSettingsArgs = {
    cuenta_id: Scalars['String']['input'];
    settings: InputSettings;
};

export type MutationCambiarUltimasVentasConfigArgs = {
    cuenta_id: Scalars['String']['input'];
    input: InputUltimasVentasConfig;
};

export type MutationRefreshTnOrdersArgs = {
    cuenta_id?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateInfoDesdeTnArgs = {
    id?: InputMaybe<Scalars['String']['input']>;
};

export type MutationActivateGeneralHoldArgs = {
    reason?: InputMaybe<Scalars['String']['input']>;
};

export type MutationActualizarDatosFacturaSegunTusFacturasArgs = {
    cobro_id: Scalars['String']['input'];
};

export type MutationActualizarDatosNotaCreditoSegunTusFacturasArgs = {
    cobro_id: Scalars['String']['input'];
};

export type MutationAnularCancelacionArgs = {
    cuenta_id: Scalars['String']['input'];
};

export type MutationAnularTrialArgs = {
    params: AnularTrialParams;
};

export type MutationArchivarFacturaPdfArgs = {
    cobro_id: Scalars['String']['input'];
};

export type MutationArchivarNotaCreditoPdfArgs = {
    cobro_id: Scalars['String']['input'];
};

export type MutationAuth_CrearUsuarioParaPruebasLocalesArgs = {
    cid: Scalars['String']['input'];
    cuenta_id: Scalars['String']['input'];
    cuenta_nombre: Scalars['String']['input'];
    email: Scalars['String']['input'];
    pais: Scalars['String']['input'];
    password?: InputMaybe<Scalars['String']['input']>;
    udn: Scalars['String']['input'];
};

export type MutationBloquearCuentaArgs = {
    cuenta_id: Scalars['String']['input'];
    motivo: BloqueoMotivos;
    skipEmail: Scalars['Boolean']['input'];
};

export type MutationBloquearCuentasPorFinTrialArgs = {
    fecha: Scalars['String']['input'];
    send_email_at?: InputMaybe<Scalars['Int']['input']>;
};

export type MutationBloquearCuentasSinLimiteArgs = {
    dryRun: Scalars['Boolean']['input'];
    fecha: Scalars['String']['input'];
    limite?: InputMaybe<Scalars['Int']['input']>;
    writeLogs: Scalars['Boolean']['input'];
};

export type MutationBonificarCuentaArgs = {
    params: BonificarCuentaParams;
};

export type MutationCambiarClaveArgs = {
    new_password: Scalars['String']['input'];
    old_password: Scalars['String']['input'];
};

export type MutationCambiarDatosFacturacionArgs = {
    params: CambiarDatosFacturacionParams;
};

export type MutationCambiarEmailArgs = {
    new_email: Scalars['String']['input'];
};

export type MutationCambiarPlanFinPeriodoArgs = {
    cuenta_id: Scalars['String']['input'];
    nuevo_plan_id: Scalars['String']['input'];
};

export type MutationCambiarUdnArgs = {
    cuenta_id: Scalars['String']['input'];
    udn: Scalars['String']['input'];
};

export type MutationCancelacionInmediataManualArgs = {
    cuenta_id: Scalars['String']['input'];
};

export type MutationCancelacionInmediataPorFaltaDePagoArgs = {
    cuenta_id: Scalars['String']['input'];
    skipEmail?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCancelarArgs = {
    params: InputCancelarParams;
};

export type MutationCancelarSuscripcionesPorFaltaDePagoArgs = {
    dryRun: Scalars['Boolean']['input'];
    fecha: Scalars['String']['input'];
    limite?: InputMaybe<Scalars['Int']['input']>;
    writeLogs: Scalars['Boolean']['input'];
};

export type MutationCancelarTodoEnZenriseArgs = {
    cuenta_id: Scalars['String']['input'];
};

export type MutationComenzarDunningManualmenteArgs = {
    cuenta_id: Scalars['String']['input'];
    dunning_empezado?: InputMaybe<Scalars['String']['input']>;
};

export type MutationConfirmarAcreditacionPagoPorTransferenciaArgs = {
    cuenta_id: Scalars['String']['input'];
    fecha_proximo_pago: Scalars['String']['input'];
    fecha_ultimo_pago: Scalars['String']['input'];
    plan_id: Scalars['String']['input'];
};

export type MutationConfirmarPagoManualArgs = {
    cuenta_id: Scalars['String']['input'];
    fecha_proximo_pago: Scalars['String']['input'];
    fecha_ultimo_pago: Scalars['String']['input'];
    monto: Scalars['Int']['input'];
    pasarela_id?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCorregirEmailArgs = {
    cuenta_id: Scalars['String']['input'];
    nuevo_email?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCrearCuentaManualmenteArgs = {
    params: CrearCuentaManualmenteParams;
};

export type MutationCrearSuscripcionPagoManualArgs = {
    cuenta_id: Scalars['String']['input'];
    fecha_creacion?: InputMaybe<Scalars['String']['input']>;
    plan_id: Scalars['String']['input'];
};

export type MutationCrearUsuarioManualmenteArgs = {
    params: CrearUsuarioManualmenteParams;
};

export type MutationCrearUsuarioSuperAdminArgs = {
    params: CrearUsuarioSuperAdminParams;
};

export type MutationDesbloquearCuentaArgs = {
    cuenta_id: Scalars['String']['input'];
    motivo: BloqueoMotivos;
    skipEmail: Scalars['Boolean']['input'];
};

export type MutationDesestimarContratacionArgs = {
    cuenta_id: Scalars['String']['input'];
};

export type MutationDesestimarSubscripcionesViejasArgs = {
    fecha: Scalars['String']['input'];
};

export type MutationDesestimarSuscripcionArgs = {
    cuenta_id: Scalars['String']['input'];
};

export type MutationDesestimarZenriseWebhookArgs = {
    webhook_id: Scalars['String']['input'];
};

export type MutationDismissWaitingEmailArgs = {
    id: Scalars['String']['input'];
};

export type MutationDispararEventoCuentaActualizadaArgs = {
    cuenta_id: Scalars['String']['input'];
};

export type MutationDispararEventoCuentaRefreshArgs = {
    cuenta_id: Scalars['String']['input'];
};

export type MutationDispararFailsSubArgs = {
    cuenta_id: Scalars['String']['input'];
};

export type MutationDispararProcesoActualizarDatosArgs = {
    cantidad?: InputMaybe<Scalars['Int']['input']>;
    dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationEjecutarDevolucionZenriseArgs = {
    cuenta_id: Scalars['String']['input'];
    invoice_id: Scalars['String']['input'];
};

export type MutationEjecutarReporteArgs = {
    nombre: Scalars['String']['input'];
};

export type MutationEjecutarReporteAsincronicoArgs = {
    nombre: Scalars['String']['input'];
};

export type MutationEmitirNotaCreditoEnAfipArgs = {
    cobro_id: Scalars['String']['input'];
};

export type MutationExtenderTrialArgs = {
    params: ExtenderTrialParams;
};

export type MutationFacturarEnAfipArgs = {
    cobro_id: Scalars['String']['input'];
};

export type MutationFacturarVariosEnAfipArgs = {
    cantidad: Scalars['Int']['input'];
};

export type MutationFixAuditLogMeterCobrosArgs = {
    cuenta_id: Scalars['String']['input'];
};

export type MutationFixCuentasSinNombreArgs = {
    do_id?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationFixDatosDesdeLegacyArgs = {
    cuenta_id: Scalars['String']['input'];
};

export type MutationFixDatosDesdeLegacySinTnArgs = {
    cuenta_id: Scalars['String']['input'];
    dryrun?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationFixDesdeUsuarioEnStArgs = {
    cid: Scalars['String']['input'];
    dry_run: Scalars['Boolean']['input'];
    pais: Scalars['String']['input'];
    st_user_id: Scalars['String']['input'];
    uid: Scalars['String']['input'];
};

export type MutationFixManualSuscripcionArgs = {
    cuenta_id: Scalars['String']['input'];
    datos: FixSuscripcionManualParams;
};

export type MutationFixSuscripcionContextArgs = {
    cuenta_id: Scalars['String']['input'];
};

export type MutationFixSuscripcionesDatosPlanArgs = {
    do_it?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationFixUserMetadataArgs = {
    fix?: InputMaybe<Scalars['Boolean']['input']>;
    st_id: Scalars['String']['input'];
};

export type MutationFixUsuarioArgs = {
    do_it?: InputMaybe<Scalars['Boolean']['input']>;
    st_id: Scalars['String']['input'];
};

export type MutationForzarCancelacionArgs = {
    cuenta_id: Scalars['String']['input'];
};

export type MutationForzarClaveArgs = {
    new_password: Scalars['String']['input'];
    usuario_id: Scalars['String']['input'];
};

export type MutationImportarSuscripcionActivaDesdeZenriseArgs = {
    cuenta_id: Scalars['String']['input'];
    dry_run: Scalars['Boolean']['input'];
    zenrise_suscription_id: Scalars['String']['input'];
};

export type MutationInformarPagoPorTransferenciaArgs = {
    confirmo_pago_acreditado: Scalars['Boolean']['input'];
    cuenta_id: Scalars['String']['input'];
    fecha_proximo_pago: Scalars['String']['input'];
    fecha_ultimo_pago: Scalars['String']['input'];
    plan_id: Scalars['String']['input'];
};

export type MutationIniciarContratacionStripeArgs = {
    params: IniciarContratacionStripeParams;
};

export type MutationIniciarContratacionZenriseArgs = {
    params: IniciarContratacionZenriseParams;
};

export type MutationMandarPlanZenRiseArgs = {
    plan_id: Scalars['String']['input'];
};

export type MutationMarcarCobrosParaFacturarArgs = {
    selection: Array<CobroParaFacturarInput>;
};

export type MutationMarcarComoCanceladaArgs = {
    cuenta_id: Scalars['String']['input'];
};

export type MutationMigracionCancelarArgs = {
    comentario: Scalars['String']['input'];
    cuenta_id: Scalars['String']['input'];
};

export type MutationMigracionMarcarComoListaArgs = {
    cuenta_id: Scalars['String']['input'];
    fecha_proximo_pago: Scalars['Date']['input'];
};

export type MutationMigracionPasarGestionManualArgs = {
    cuenta_id: Scalars['String']['input'];
};

export type MutationNuevoTrialArgs = {
    cuenta_id: Scalars['String']['input'];
    dias?: InputMaybe<Scalars['Int']['input']>;
};

export type MutationObtenerLinkCobroZenriseArgs = {
    cuenta_id: Scalars['String']['input'];
    invoice_id?: InputMaybe<Scalars['Int']['input']>;
};

export type MutationProcesarIpnArgs = {
    id: Scalars['String']['input'];
};

export type MutationProcesarTusFacturasWebhookArgs = {
    id: Scalars['String']['input'];
};

export type MutationProcesarZenriseWebhookArgs = {
    id: Scalars['String']['input'];
};

export type MutationPutHoldOnEmailArgs = {
    email: Scalars['String']['input'];
    reason?: InputMaybe<Scalars['String']['input']>;
};

export type MutationReactivarSuscripcionDesestimadaArgs = {
    cuenta_id: Scalars['String']['input'];
    fecha_proximo_pago: Scalars['String']['input'];
    fecha_ultimo_pago: Scalars['String']['input'];
    suscripcion_id: Scalars['String']['input'];
};

export type MutationRecordarPagoConDebitoArgs = {
    dryRun: Scalars['Boolean']['input'];
    fecha: Scalars['String']['input'];
};

export type MutationRecuperarSuscripcionMalCanceladaArgs = {
    cuenta_id: Scalars['String']['input'];
    fecha_proximo_pago: Scalars['String']['input'];
    fecha_ultimo_pago: Scalars['String']['input'];
    pasarela_id: Scalars['String']['input'];
    plan_id: Scalars['String']['input'];
};

export type MutationRedispararEventoArgs = {
    dry_run?: InputMaybe<Scalars['Boolean']['input']>;
    event_id: Scalars['String']['input'];
};

export type MutationReemplazarCuentaIdArgs = {
    cuenta_id_nuevo: Scalars['String']['input'];
    cuenta_id_original: Scalars['String']['input'];
};

export type MutationRegistrarRenovacionPorTransferenciaArgs = {
    cuenta_id: Scalars['String']['input'];
    fecha_proximo_pago: Scalars['String']['input'];
    fecha_ultimo_pago: Scalars['String']['input'];
};

export type MutationReleaseHoldOnEmailArgs = {
    email: Scalars['String']['input'];
};

export type MutationSalirDunningManualmenteArgs = {
    cuenta_id: Scalars['String']['input'];
    fecha_proximo_pago: Scalars['String']['input'];
    fecha_ultimo_pago: Scalars['String']['input'];
};

export type MutationSendWaitingEmailArgs = {
    id: Scalars['String']['input'];
};

export type MutationSincronizarEstadisticasArgs = {
    day?: InputMaybe<Scalars['Int']['input']>;
    month?: InputMaybe<Scalars['Int']['input']>;
    year?: InputMaybe<Scalars['Int']['input']>;
};

export type MutationSincronizarStripePlansArgs = {
    dry_run: Scalars['Boolean']['input'];
};

export type MutationStripeCrearPortalSessionArgs = {
    cuenta_id: Scalars['String']['input'];
};

export type MutationSubs_CrearUsuarioParaPruebasLocalesArgs = {
    cuenta_id: Scalars['String']['input'];
};

export type MutationTerminarInstalacionArgs = {
    cid: Scalars['String']['input'];
    clave_temporal: Scalars['String']['input'];
    debe_resetear_clave: Scalars['Boolean']['input'];
    email: Scalars['String']['input'];
    pais?: InputMaybe<Scalars['String']['input']>;
    st_user_id?: InputMaybe<Scalars['String']['input']>;
    udn?: InputMaybe<Scalars['String']['input']>;
    uid: Scalars['String']['input'];
};

export type MutationTerminarSuscripcionCanceladaHastaPeriodoPagadoArgs = {
    cuenta_id: Scalars['String']['input'];
};

export type MutationTerminarSuscripcionesQueEstabanHastaFinDePeriodoArgs = {
    dryRun: Scalars['Boolean']['input'];
    fecha: Scalars['String']['input'];
};

export type MutationTerminarTrialsArgs = {
    fecha: Scalars['String']['input'];
};

export type MutationTestCrearCuentaEnTrialArgs = {
    dias: Scalars['Int']['input'];
    pais?: InputMaybe<Scalars['String']['input']>;
    stripe_habilitado?: InputMaybe<Scalars['Boolean']['input']>;
    udn?: InputMaybe<Scalars['String']['input']>;
};

export type MutationTestEmailArgs = {
    template_id: Scalars['String']['input'];
};

export type MutationTestSimularIpnRecibidoArgs = {
    content: Scalars['String']['input'];
};

export type MutationTestSimularTusFacturasWebhookRecibidoArgs = {
    content: Scalars['String']['input'];
};

export type MutationTestSlackMessageArgs = {
    canal: Scalars['String']['input'];
    message: Scalars['String']['input'];
};

export type MutationTestTaskArgs = {
    accion: Scalars['String']['input'];
    task_id?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateInfoDesdeTnAndReturnArgs = {
    cuenta_id?: InputMaybe<Scalars['String']['input']>;
};

export type MutationVerificarInstalacionArgs = {
    cid?: InputMaybe<Scalars['String']['input']>;
};

export type MutationVolverATirarEventoCuentaCreadaArgs = {
    cuenta_id: Scalars['String']['input'];
};

export type PageInfo = {
    __typename?: 'PageInfo';
    endCursor?: Maybe<Scalars['String']['output']>;
    hasNextPage: Scalars['Boolean']['output'];
    startCursor?: Maybe<Scalars['String']['output']>;
};

export enum Pasarela {
    Manual = 'MANUAL',
    Stripe = 'STRIPE',
    Transferencia = 'TRANSFERENCIA',
    Zenrise = 'ZENRISE',
}

export type Plan = {
    __typename?: 'Plan';
    cuentas_activas?: Maybe<Scalars['Int']['output']>;
    id: Scalars['String']['output'];
    limite?: Maybe<Scalars['Int']['output']>;
    mostrar_en_selector?: Maybe<Scalars['Boolean']['output']>;
    nombre_privado: Scalars['String']['output'];
    nombre_publico: Scalars['String']['output'];
    por_defecto?: Maybe<Scalars['Boolean']['output']>;
    precio: Scalars['Float']['output'];
    precio_con_iva: Scalars['Float']['output'];
    valido_desde?: Maybe<Scalars['String']['output']>;
    valido_hasta?: Maybe<Scalars['String']['output']>;
    zenrise_id?: Maybe<Scalars['String']['output']>;
};

export enum Position {
    BottomLeft = 'bottomLeft',
    BottomRight = 'bottomRight',
    TopLeft = 'topLeft',
    TopRight = 'topRight',
}

export type ProblemaConCuentas = {
    __typename?: 'ProblemaConCuentas';
    cuentas: ProblemaConCuentas_Cuentas;
    nombre: Scalars['String']['output'];
};

export type ProblemaConCuentas_Cuentas = {
    __typename?: 'ProblemaConCuentas_Cuentas';
    data?: Maybe<Scalars['JSON']['output']>;
    length: Scalars['Int']['output'];
};

export type Problemas = {
    __typename?: 'Problemas';
    tiendasSinEmailDesdeLegacy: Scalars['Int']['output'];
};

export type ProcesarIpnResultado = {
    __typename?: 'ProcesarIPNResultado';
    mensaje?: Maybe<Scalars['String']['output']>;
    ok: Scalars['Boolean']['output'];
};

export type ProcesarWebhookResultado = {
    __typename?: 'ProcesarWebhookResultado';
    mensaje?: Maybe<Scalars['String']['output']>;
    ok: Scalars['Boolean']['output'];
};

export type ProcesoDiario = {
    __typename?: 'ProcesoDiario';
    cuenta?: Maybe<Cuenta>;
    cuenta_id?: Maybe<Scalars['String']['output']>;
    error?: Maybe<Scalars['JSON']['output']>;
    fecha?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    proceso?: Maybe<Scalars['String']['output']>;
    resultado_ok?: Maybe<Scalars['Boolean']['output']>;
};

export type ProcesosDiariosConnection = {
    __typename?: 'ProcesosDiariosConnection';
    edges: Array<ProcesoDiario>;
    pageInfo: PageInfo;
};

export type ProcesosDiariosConnectionFilters = {
    cuenta_id?: InputMaybe<Scalars['String']['input']>;
    fecha_desde?: InputMaybe<Scalars['String']['input']>;
    fecha_hasta?: InputMaybe<Scalars['String']['input']>;
    resultado_ok?: InputMaybe<Scalars['Boolean']['input']>;
    texto?: InputMaybe<Scalars['String']['input']>;
};

export type Query = {
    __typename?: 'Query';
    ZenriseLogsConnection: ZenRiseApiLogConnection;
    analisisTimingZenriseWebhooksAndIPNS: Array<TimingZenriseWebhooksAndIpns>;
    apiResponse?: Maybe<Scalars['ApiResponse']['output']>;
    auditLog?: Maybe<AuditLog>;
    auditLogs: Array<AuditLog>;
    bloquearCuentasSinLimitePreview?: Maybe<Array<Maybe<Suscripcion>>>;
    /** @deprecated No longer supported */
    bloqueos: Array<Bloqueo>;
    bloqueosConnection: BloqueosConnection;
    buscarCuentas: Array<Cuenta>;
    /** Preview de la cancelación por falta de pago */
    cancelarSuscripcionesPorFaltaDePagoPreview?: Maybe<
        Array<Maybe<Suscripcion>>
    >;
    cobrosPendientesDeNotaCredito: Array<Cobro>;
    cohortSuscripcionesMonthsAlive?: Maybe<Scalars['JSON']['output']>;
    consultarStripeDatosCuenta?: Maybe<Scalars['JSON']['output']>;
    /** @deprecated No longer supported */
    contrataciones: Array<Contratacion>;
    contratacionesConnection: ContratacionesConnection;
    cuenta?: Maybe<Cuenta>;
    cuentaEnAuth?: Maybe<CuentaEnAuth>;
    cuentaEnAuthParaMigracion?: Maybe<CuentaEnAuth>;
    cuentaEnLegacy?: Maybe<CuentaEnLegacy>;
    /**
     * cuentaEnSubs, a diferencia de cuenta, trae los datos exclusivamente desde subs
     * sirve para testear inconsistencias de datos entre microservicios
     */
    cuentaEnSubs?: Maybe<Cuenta>;
    cuentaMerge?: Maybe<CuentaEnLegacy>;
    cuentaPorCid?: Maybe<Cuenta>;
    cuentas: Array<Cuenta>;
    cuentasDesbloqueadasSinMotivo: Array<CuentaDesbloqueadaSinMotivo>;
    cuentasEnAuth: Array<CuentaEnAuth>;
    cuentasMerge?: Maybe<Array<Maybe<CuentaEnLegacy>>>;
    dashboardSuscripciones?: Maybe<DashboardSuscripciones>;
    dunningPreview: Array<Maybe<DunningPreview>>;
    echo?: Maybe<Scalars['JSON']['output']>;
    estadisticasAdmin?: Maybe<Scalars['JSON']['output']>;
    estadisticasAdminPorSituacion?: Maybe<StatsPorSituacion>;
    estadoCuentasEnAuth?: Maybe<EstadoCuentasEnAuth>;
    estadoCuentasEnLegacy?: Maybe<EstadoCuentasEnLegacy>;
    estadoCuentasEnSuscripciones?: Maybe<EstadoCuentasEnSubs>;
    eventsConnection: EventsConnection;
    externalTusFacturasConsultaComprobante?: Maybe<Scalars['JSON']['output']>;
    externalTusFacturasConsultarCuit?: Maybe<Scalars['JSON']['output']>;
    facturacion_proximos_dias?: Maybe<ResultadoFacturacion>;
    facturasPendientesFacturarEnAfip: Array<Cobro>;
    features?: Maybe<Scalars['JSON']['output']>;
    getLinkParaDescargarFactura?: Maybe<Scalars['JSON']['output']>;
    getLinkParaDescargarNotaCredito?: Maybe<Scalars['JSON']['output']>;
    getPlanesParaCuenta?: Maybe<Array<Maybe<Plan>>>;
    healthCheckSubscriptions: Scalars['Boolean']['output'];
    /** Información para investigar como quedó una cuenta en su instalación, previa a poder terminarla */
    infoParaTerminarInstalacion?: Maybe<Scalars['JSON']['output']>;
    instalacionEnTn?: Maybe<Scalars['JSON']['output']>;
    invoiceZenRise?: Maybe<InvoiceZenRise>;
    /** @deprecated No longer supported */
    invoicesZenRise?: Maybe<Array<Maybe<InvoiceZenRise>>>;
    invoicesZenRiseConnection: InvoiceZenRiseConnection;
    ipnConnection: IpnConnection;
    /** @deprecated No longer supported */
    ipns: Array<Ipn>;
    isEmailOnHold: Scalars['Boolean']['output'];
    isGoblalHoldActivated: Scalars['Boolean']['output'];
    mailOutboxConnection2: MailOutboxConnection;
    migraciones: Array<Migracion>;
    now: Scalars['DateTime']['output'];
    plan?: Maybe<Plan>;
    planPorDefecto?: Maybe<Plan>;
    planes: Array<Plan>;
    /** @deprecated No longer supported */
    problemas: Problemas;
    problemasCuentas: Scalars['JSON']['output'];
    procesosDiariosConnection: ProcesosDiariosConnection;
    reporteCobrosPendientesFacturar: ReporteCobrosPendientesFacturar;
    /** @deprecated No longer supported */
    reporteCuentasActivasConPagosAtrasados?: Maybe<Scalars['JSON']['output']>;
    reporteCuentasConPagosConProblemas: Array<CuentasConPagosConProblemas>;
    reporteCuentasDunningZenrise: Array<CuentaEnDunningZenrise>;
    reporteFacturas: ReporteFacturas;
    reporteSuscripcionesZenrise?: Maybe<ResultadoReporteSuscripcionesZenrise>;
    reportesSuscripcionesZenrise: Array<ResultadoReporteSuscripcionesZenriseSinData>;
    stripeLogConnection: StripeLogConnection;
    stripePrices: Array<StripePrice>;
    stripeWebhookConnection: StripeWebhookConnection;
    /** @deprecated No longer supported */
    suscripcionesActivasConnection: SuscripcionesConnection;
    suscripcionesParaDesestimar?: Maybe<Array<Maybe<Suscripcion>>>;
    tasksConnection: TaskConnection;
    /** Preview de la cancelación que estaban esperando */
    terminarSuscripcionesQueEstabanHastaFinDePeriodoPreview?: Maybe<
        Array<Maybe<Suscripcion>>
    >;
    testAuth?: Maybe<Scalars['JSON']['output']>;
    /** TODO: Está roto, esperando este arreglo: https://gitlab.com/gran-torre/luker-commons/-/issues/4 */
    testInterService?: Maybe<Scalars['JSON']['output']>;
    testSentryError?: Maybe<Scalars['Boolean']['output']>;
    testSentryMessage?: Maybe<Scalars['Boolean']['output']>;
    today: Scalars['Date']['output'];
    trials: Array<Trial>;
    trialsActivosConnection: TrialsActivosConnection;
    trialsParaBloquear?: Maybe<Array<Maybe<Trial>>>;
    trialsParaTerminar?: Maybe<Array<Maybe<Trial>>>;
    tusFacturasWebhooks: Array<TusFacturasWebhook>;
    tusfacturasLogs: Array<TusFacturasApiLog>;
    ultimasSuscripcionesConnection: SuscripcionesConnection;
    usuario?: Maybe<Usuario>;
    usuarioByST?: Maybe<Usuario>;
    usuarios?: Maybe<Array<Maybe<Usuario>>>;
    usuariosDataLoader?: Maybe<Array<Maybe<Usuario>>>;
    /**
     * Sirve para unificar en el gateway, trae los usuarios en formato dataloader
     * usando el id en ST como key
     */
    usuariosPorSTDataLoader?: Maybe<Array<Maybe<Usuario>>>;
    zenriseSuscripcionInfo?: Maybe<Scalars['JSONObject']['output']>;
    /** @deprecated No longer supported */
    zenriseSuscripcionesInfo?: Maybe<Scalars['JSON']['output']>;
    /** @deprecated No longer supported */
    zenriseWebhooks: Array<ZenriseWebhook>;
    zenriseWebhooksConnection: ZenriseWebhooksConnection;
    /** @deprecated No longer supported */
    zenrise_logs: Array<ZenRiseApiLog>;
};

export type QueryZenriseLogsConnectionArgs = {
    filters?: InputMaybe<ZenriseLogsConnectionFilters>;
    pagination: CursorPaginationParams;
};

export type QueryApiResponseArgs = {
    cuenta_id: Scalars['String']['input'];
};

export type QueryAuditLogArgs = {
    id: Scalars['String']['input'];
};

export type QueryAuditLogsArgs = {
    params: GenericInputParams;
};

export type QueryBloquearCuentasSinLimitePreviewArgs = {
    fecha: Scalars['String']['input'];
    force?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryBloqueosArgs = {
    params: GenericInputParams;
};

export type QueryBloqueosConnectionArgs = {
    filtros?: InputMaybe<BloqueosConnectionParams>;
    incluirViejos?: InputMaybe<Scalars['Boolean']['input']>;
    pagination: CursorPaginationParams;
};

export type QueryBuscarCuentasArgs = {
    params: BuscarCuentasQueryParams;
};

export type QueryCancelarSuscripcionesPorFaltaDePagoPreviewArgs = {
    fecha: Scalars['String']['input'];
};

export type QueryConsultarStripeDatosCuentaArgs = {
    cuenta_id: Scalars['String']['input'];
};

export type QueryContratacionesArgs = {
    params: ContratacionesQueryParams;
};

export type QueryContratacionesConnectionArgs = {
    filters?: InputMaybe<ContratacionesFilters>;
    pagination: CursorPaginationParams;
};

export type QueryCuentaArgs = {
    id: Scalars['String']['input'];
};

export type QueryCuentaEnAuthArgs = {
    id: Scalars['String']['input'];
};

export type QueryCuentaEnAuthParaMigracionArgs = {
    cid: Scalars['String']['input'];
};

export type QueryCuentaEnLegacyArgs = {
    cid?: InputMaybe<Scalars['String']['input']>;
};

export type QueryCuentaEnSubsArgs = {
    id: Scalars['String']['input'];
};

export type QueryCuentaMergeArgs = {
    id: Scalars['String']['input'];
};

export type QueryCuentaPorCidArgs = {
    cid: Scalars['String']['input'];
};

export type QueryCuentasArgs = {
    params: CuentasQueryParams;
};

export type QueryCuentasEnAuthArgs = {
    params: CuentasInputParams;
};

export type QueryCuentasMergeArgs = {
    ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type QueryDunningPreviewArgs = {
    fecha_referencia?: InputMaybe<Scalars['String']['input']>;
    include_already_executed?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryEchoArgs = {
    input?: InputMaybe<Scalars['JSON']['input']>;
};

export type QueryEstadisticasAdminArgs = {
    dias?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryEstadisticasAdminPorSituacionArgs = {
    args: StatsArgs;
};

export type QueryEventsConnectionArgs = {
    filters?: InputMaybe<EventsFilters>;
    pagination: CursorPaginationParams;
};

export type QueryExternalTusFacturasConsultaComprobanteArgs = {
    external_reference: Scalars['String']['input'];
    tipo: Scalars['String']['input'];
};

export type QueryExternalTusFacturasConsultarCuitArgs = {
    documento_nro: Scalars['String']['input'];
    documento_tipo: Scalars['String']['input'];
};

export type QueryFacturacion_Proximos_DiasArgs = {
    dias?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryGetLinkParaDescargarFacturaArgs = {
    cobro_id: Scalars['String']['input'];
};

export type QueryGetLinkParaDescargarNotaCreditoArgs = {
    cobro_id: Scalars['String']['input'];
};

export type QueryGetPlanesParaCuentaArgs = {
    cuenta_id: Scalars['String']['input'];
};

export type QueryInfoParaTerminarInstalacionArgs = {
    cid: Scalars['String']['input'];
    email: Scalars['String']['input'];
};

export type QueryInstalacionEnTnArgs = {
    cid?: InputMaybe<Scalars['String']['input']>;
};

export type QueryInvoiceZenRiseArgs = {
    id: Scalars['String']['input'];
};

export type QueryInvoicesZenRiseConnectionArgs = {
    filters?: InputMaybe<InvoiceZenRiseConnectionFilters>;
    pagination: CursorPaginationParams;
};

export type QueryIpnConnectionArgs = {
    filters?: InputMaybe<IpnConnectionFilters>;
    pagination: CursorPaginationParams;
};

export type QueryIpnsArgs = {
    params: IpnParams;
};

export type QueryIsEmailOnHoldArgs = {
    email: Scalars['String']['input'];
};

export type QueryMailOutboxConnection2Args = {
    filters?: InputMaybe<MailOutboxFilters>;
    pagination: CursorPaginationParams;
};

export type QueryMigracionesArgs = {
    params: MigracionesQueryParams;
};

export type QueryPlanArgs = {
    id: Scalars['String']['input'];
};

export type QueryProblemasCuentasArgs = {
    simular?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryProcesosDiariosConnectionArgs = {
    filters?: InputMaybe<ProcesosDiariosConnectionFilters>;
    pagination: CursorPaginationParams;
};

export type QueryReporteFacturasArgs = {
    mes?: InputMaybe<Scalars['String']['input']>;
};

export type QueryReporteSuscripcionesZenriseArgs = {
    id: Scalars['String']['input'];
    refrescarLogica?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryStripeLogConnectionArgs = {
    filters?: InputMaybe<StripeLogConnectionFilters>;
    pagination: CursorPaginationParams;
};

export type QueryStripeWebhookConnectionArgs = {
    filters?: InputMaybe<StripeWebhookConnectionFilters>;
    pagination: CursorPaginationParams;
};

export type QuerySuscripcionesActivasConnectionArgs = {
    pagination: CursorPaginationParams;
};

export type QuerySuscripcionesParaDesestimarArgs = {
    fecha: Scalars['String']['input'];
};

export type QueryTasksConnectionArgs = {
    filters?: InputMaybe<TasksConnectionFilters>;
    pagination: CursorPaginationParams;
};

export type QueryTerminarSuscripcionesQueEstabanHastaFinDePeriodoPreviewArgs = {
    fecha: Scalars['String']['input'];
};

export type QueryTrialsArgs = {
    params: TrialsQueryParams;
};

export type QueryTrialsActivosConnectionArgs = {
    filters?: InputMaybe<TrialsActivosConnectionFilters>;
    pagination: CursorPaginationParams;
};

export type QueryTrialsParaBloquearArgs = {
    fecha: Scalars['String']['input'];
};

export type QueryTrialsParaTerminarArgs = {
    fecha: Scalars['String']['input'];
};

export type QueryTusFacturasWebhooksArgs = {
    params: WebhookQueryParams;
};

export type QueryTusfacturasLogsArgs = {
    params: SimplePaginationParams;
};

export type QueryUltimasSuscripcionesConnectionArgs = {
    filters?: InputMaybe<UltimasSuscripcionesConnectionFilters>;
    pagination: CursorPaginationParams;
};

export type QueryUsuarioArgs = {
    id: Scalars['String']['input'];
};

export type QueryUsuarioByStArgs = {
    stUserId: Scalars['String']['input'];
};

export type QueryUsuariosArgs = {
    params: UsuariosInputParams;
};

export type QueryUsuariosDataLoaderArgs = {
    input: DataLoaderParams;
};

export type QueryUsuariosPorStDataLoaderArgs = {
    input: DataLoaderParams;
};

export type QueryZenriseSuscripcionInfoArgs = {
    cuenta_id: Scalars['String']['input'];
    zenrise_suscription_id: Scalars['String']['input'];
};

export type QueryZenriseSuscripcionesInfoArgs = {
    cuenta_id: Scalars['String']['input'];
};

export type QueryZenriseWebhooksArgs = {
    params: WebhookQueryParams;
};

export type QueryZenriseWebhooksConnectionArgs = {
    filters?: InputMaybe<ZenriseWebhooksConnectionFilters>;
    pagination: CursorPaginationParams;
};

export type QueryZenrise_LogsArgs = {
    params: SimplePaginationParams;
};

export type ReporteCobrosPendientesFacturar = {
    __typename?: 'ReporteCobrosPendientesFacturar';
    CobrosPendientes?: Maybe<Array<Cobro>>;
    marcado_para_facturar?: Maybe<Scalars['Float']['output']>;
    ya_facturado_este_mes?: Maybe<Scalars['Float']['output']>;
};

export type ReporteFacturas = {
    __typename?: 'ReporteFacturas';
    Facturas?: Maybe<Array<Cobro>>;
};

export type RespuestaUpdateInfoDesdeTnAndReturn = {
    __typename?: 'RespuestaUpdateInfoDesdeTnAndReturn';
    datos?: Maybe<Scalars['Mixed']['output']>;
    error_code?: Maybe<Scalars['String']['output']>;
    error_message?: Maybe<Scalars['String']['output']>;
    ok: Scalars['Boolean']['output'];
};

export type ResultadoFacturacion = {
    __typename?: 'ResultadoFacturacion';
    dias: Scalars['Int']['output'];
    total: Scalars['Float']['output'];
};

export type ResultadoReporteSuscripcionesZenrise = {
    __typename?: 'ResultadoReporteSuscripcionesZenrise';
    archivo: Scalars['String']['output'];
    data?: Maybe<ResultadoReporteSuscripcionesZenriseData>;
    fecha: Scalars['Date']['output'];
    id: Scalars['String']['output'];
};

export type ResultadoReporteSuscripcionesZenriseData = {
    __typename?: 'ResultadoReporteSuscripcionesZenriseData';
    cuentas: Array<CuentaConProblemas>;
    problemas: Array<ProblemaConCuentas>;
    resumen_muertas: SumatoriaEstadosZenrise;
    resumen_vivas: SumatoriaEstadosZenrise;
};

/** Este es como ResultadoReporteSuscripcionesZenrise, pero sin data, para armar selects */
export type ResultadoReporteSuscripcionesZenriseSinData = {
    __typename?: 'ResultadoReporteSuscripcionesZenriseSinData';
    archivo: Scalars['String']['output'];
    fecha: Scalars['Date']['output'];
    id: Scalars['String']['output'];
};

export type Rol = {
    __typename?: 'Rol';
    createdAt?: Maybe<Scalars['Date']['output']>;
    cuenta?: Maybe<CuentaEnAuth>;
    cuentaId?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    rolNombre?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['Date']['output']>;
    userId?: Maybe<Scalars['String']['output']>;
    usuario?: Maybe<Usuario>;
};

export type Settings = {
    __typename?: 'Settings';
    active: Scalars['Boolean']['output'];
    delayBetween: Scalars['Int']['output'];
    gaeeEnabled: Scalars['Boolean']['output'];
    initialDelay: Scalars['Int']['output'];
    startOnScroll: Scalars['Boolean']['output'];
};

export enum ShowTargets {
    All = 'All',
    New = 'New',
    Returning = 'Returning',
}

export type SimplePaginationParams = {
    after?: InputMaybe<Scalars['String']['input']>;
    firsts: Scalars['Int']['input'];
};

export type Stats = {
    __typename?: 'Stats';
    clicks: Array<Maybe<Scalars['BigInt']['output']>>;
    dias: Array<Maybe<Scalars['String']['output']>>;
    fecha_desde: Scalars['String']['output'];
    fecha_hasta: Scalars['String']['output'];
    notificaciones: Array<Maybe<Scalars['BigInt']['output']>>;
    pageviews: Array<Maybe<Scalars['BigInt']['output']>>;
};

export type StatsArgs = {
    fecha_desde: Scalars['String']['input'];
    fecha_hasta?: InputMaybe<Scalars['String']['input']>;
};

export type StatsPorSituacion = {
    __typename?: 'StatsPorSituacion';
    activas: Array<Maybe<Scalars['BigInt']['output']>>;
    dias: Array<Maybe<Scalars['String']['output']>>;
    fecha_desde: Scalars['String']['output'];
    fecha_hasta: Scalars['String']['output'];
    otras: Array<Maybe<Scalars['BigInt']['output']>>;
    trial: Array<Maybe<Scalars['BigInt']['output']>>;
};

export type StripeApiLog = {
    __typename?: 'StripeApiLog';
    created_at: Scalars['DateTime']['output'];
    cuenta_id?: Maybe<Scalars['String']['output']>;
    id: Scalars['String']['output'];
    method: Scalars['String']['output'];
    requestBody?: Maybe<Scalars['JSON']['output']>;
    requestHeaders: Scalars['JSON']['output'];
    responseBody?: Maybe<Scalars['JSON']['output']>;
    responseHeaders: Scalars['JSON']['output'];
    responseStatus: Scalars['Int']['output'];
    updated_at: Scalars['DateTime']['output'];
    url: Scalars['String']['output'];
    user_id?: Maybe<Scalars['String']['output']>;
};

export type StripeApiLogEdge = {
    __typename?: 'StripeApiLogEdge';
    cursor: Scalars['String']['output'];
    node: StripeApiLog;
};

export type StripeInvoice = {
    __typename?: 'StripeInvoice';
    amount_due: Scalars['Int']['output'];
    amount_paid: Scalars['Int']['output'];
    created: Scalars['Int']['output'];
    currency: Scalars['String']['output'];
    number?: Maybe<Scalars['String']['output']>;
    status?: Maybe<Scalars['String']['output']>;
    total: Scalars['Int']['output'];
};

export type StripeLogConnection = {
    __typename?: 'StripeLogConnection';
    edges: Array<StripeApiLog>;
    pageInfo: PageInfo;
};

export type StripeLogConnectionFilters = {
    cuenta_id?: InputMaybe<Scalars['String']['input']>;
    fecha_desde?: InputMaybe<Scalars['String']['input']>;
    fecha_hasta?: InputMaybe<Scalars['String']['input']>;
    method?: InputMaybe<Scalars['String']['input']>;
    status?: InputMaybe<Scalars['String']['input']>;
    url?: InputMaybe<Scalars['String']['input']>;
};

export type StripePrice = {
    __typename?: 'StripePrice';
    currency: Scalars['String']['output'];
    id: Scalars['String']['output'];
    limit: Scalars['Int']['output'];
    product_id: Scalars['String']['output'];
    product_name: Scalars['String']['output'];
    unit_amount: Scalars['Int']['output'];
};

export type StripeWebhook = {
    __typename?: 'StripeWebhook';
    aws_log_group_name?: Maybe<Scalars['String']['output']>;
    aws_log_stream_name?: Maybe<Scalars['String']['output']>;
    body: Scalars['JSONObject']['output'];
    created_at: Scalars['DateTime']['output'];
    cuenta?: Maybe<Cuenta>;
    cuenta_id?: Maybe<Scalars['String']['output']>;
    estado: EstadoWebhook;
    id: Scalars['String']['output'];
    resultado_mensaje?: Maybe<Scalars['String']['output']>;
    resultado_ok?: Maybe<Scalars['Boolean']['output']>;
    stripe_event_id?: Maybe<Scalars['String']['output']>;
    type: Scalars['String']['output'];
    updated_at: Scalars['DateTime']['output'];
};

export type StripeWebhookConnection = {
    __typename?: 'StripeWebhookConnection';
    edges: Array<StripeWebhook>;
    pageInfo: PageInfo;
};

export type StripeWebhookConnectionFilters = {
    cuenta_id?: InputMaybe<Scalars['String']['input']>;
    estado?: InputMaybe<Scalars['String']['input']>;
    evento?: InputMaybe<Scalars['String']['input']>;
    fecha_desde?: InputMaybe<Scalars['String']['input']>;
    fecha_hasta?: InputMaybe<Scalars['String']['input']>;
    status?: InputMaybe<Scalars['String']['input']>;
};

export type SumatoriaEstadosZenrise = {
    __typename?: 'SumatoriaEstadosZenrise';
    ACTIVE: Scalars['Int']['output'];
    CANCELLED: Scalars['Int']['output'];
    PAST_DUE: Scalars['Int']['output'];
    UNPAID: Scalars['Int']['output'];
};

export type Suscripcion = {
    __typename?: 'Suscripcion';
    contratacion?: Maybe<Contratacion>;
    contratacion_id?: Maybe<Scalars['String']['output']>;
    cuenta?: Maybe<Cuenta>;
    cuenta_id: Scalars['String']['output'];
    dia_cobro?: Maybe<Scalars['Int']['output']>;
    dunning_empezado?: Maybe<Scalars['String']['output']>;
    es_manual?: Maybe<Scalars['Boolean']['output']>;
    estado: EstadoSuscripcion;
    estado_full?: Maybe<Scalars['String']['output']>;
    fecha_creacion: Scalars['String']['output'];
    fecha_proximo_pago?: Maybe<Scalars['String']['output']>;
    fecha_ultimo_pago?: Maybe<Scalars['String']['output']>;
    fsm_error?: Maybe<Scalars['JSON']['output']>;
    id: Scalars['String']['output'];
    /** Campo calculado, busca la última invoice desde que empezó el dunning */
    invoice_zenrise_impaga?: Maybe<InvoiceZenriseImpaga>;
    /** @deprecated sacar de cuenta */
    legacy_id?: Maybe<Scalars['String']['output']>;
    /** @deprecated No longer supported */
    migrada_desde_legacy?: Maybe<Scalars['Boolean']['output']>;
    nuevo_plan?: Maybe<Plan>;
    nuevo_plan_id?: Maybe<Scalars['String']['output']>;
    nuevo_plan_pasarela_id?: Maybe<Scalars['String']['output']>;
    pasarela?: Maybe<Scalars['String']['output']>;
    pasarela_id?: Maybe<Scalars['String']['output']>;
    pasarela_plan_id?: Maybe<Scalars['String']['output']>;
    plan?: Maybe<Plan>;
    plan_id?: Maybe<Scalars['String']['output']>;
    source_active?: Maybe<Scalars['Boolean']['output']>;
    source_link?: Maybe<Scalars['String']['output']>;
    stats?: Maybe<Stats>;
    stripeInvoices: Array<StripeInvoice>;
    stripe_plan?: Maybe<StripePrice>;
    stripe_price_amount?: Maybe<Scalars['Int']['output']>;
    stripe_price_currency?: Maybe<Scalars['String']['output']>;
    stripe_price_id?: Maybe<Scalars['String']['output']>;
    stripe_product_id?: Maybe<Scalars['String']['output']>;
    stripe_product_name?: Maybe<Scalars['String']['output']>;
    /** @deprecated use legacy_id */
    tn_store_id?: Maybe<Scalars['String']['output']>;
    udn: Scalars['String']['output'];
    uso?: Maybe<Uso>;
};

export type SuscripcionesConnection = {
    __typename?: 'SuscripcionesConnection';
    edges: Array<Suscripcion>;
    pageInfo: PageInfo;
};

export type Task = {
    __typename?: 'Task';
    aws_log_group_name?: Maybe<Scalars['String']['output']>;
    aws_log_stream_name?: Maybe<Scalars['String']['output']>;
    completed_at?: Maybe<Scalars['Date']['output']>;
    created_at?: Maybe<Scalars['Date']['output']>;
    cuenta?: Maybe<Cuenta>;
    cuenta_id: Scalars['String']['output'];
    error?: Maybe<Scalars['JSON']['output']>;
    failed_at?: Maybe<Scalars['Date']['output']>;
    id: Scalars['String']['output'];
    idem_key: Scalars['String']['output'];
    nombre: Scalars['String']['output'];
    parametros?: Maybe<Scalars['JSON']['output']>;
    resultado_ok?: Maybe<Scalars['Boolean']['output']>;
};

export type TaskConnection = {
    __typename?: 'TaskConnection';
    edges: Array<Task>;
    pageInfo: PageInfo;
};

export type TasksConnectionFilters = {
    cuenta_id?: InputMaybe<Scalars['String']['input']>;
    nombre?: InputMaybe<Scalars['String']['input']>;
    nombre_starting_with?: InputMaybe<Scalars['String']['input']>;
};

export type Theme = {
    __typename?: 'Theme';
    backgroundColor?: Maybe<Scalars['String']['output']>;
    highlightColor?: Maybe<Scalars['String']['output']>;
    smallTextColor?: Maybe<Scalars['String']['output']>;
    textColor?: Maybe<Scalars['String']['output']>;
};

export type ThemeInput = {
    backgroundColor?: InputMaybe<Scalars['String']['input']>;
    highlightColor?: InputMaybe<Scalars['String']['input']>;
    smallTextColor?: InputMaybe<Scalars['String']['input']>;
    textColor?: InputMaybe<Scalars['String']['input']>;
};

export type TimingZenriseWebhooksAndIpns = {
    __typename?: 'TimingZenriseWebhooksAndIPNS';
    cuenta?: Maybe<Cuenta>;
    cuenta_id: Scalars['String']['output'];
    days_since_last_ipn?: Maybe<Scalars['Int']['output']>;
    days_since_last_webhook?: Maybe<Scalars['Int']['output']>;
    fecha_proximo_pago?: Maybe<Scalars['String']['output']>;
    fecha_ultimo_pago?: Maybe<Scalars['String']['output']>;
    ipn?: Maybe<Ipn>;
    last_ipn_id?: Maybe<Scalars['String']['output']>;
    last_webhook_id?: Maybe<Scalars['String']['output']>;
    nombre: Scalars['String']['output'];
    webhook?: Maybe<ZenriseWebhook>;
};

export type Trial = {
    __typename?: 'Trial';
    cuenta?: Maybe<Cuenta>;
    cuenta_id: Scalars['String']['output'];
    estado: EstadoTrial;
    estado_full?: Maybe<Scalars['String']['output']>;
    fecha_creacion: Scalars['Date']['output'];
    fecha_fin: Scalars['Date']['output'];
    id: Scalars['String']['output'];
};

export type TrialsActivosConnection = {
    __typename?: 'TrialsActivosConnection';
    edges: Array<Trial>;
    pageInfo: PageInfo;
};

export type TrialsActivosConnectionFilters = {
    orderBy?: InputMaybe<TrialsActivosConnectionOrderBy>;
    pais?: InputMaybe<Scalars['String']['input']>;
    query?: InputMaybe<Scalars['String']['input']>;
    udn?: InputMaybe<Scalars['String']['input']>;
};

export enum TrialsActivosConnectionOrderBy {
    FechaFinAsc = 'FECHA_FIN_ASC',
    FechaFinDesc = 'FECHA_FIN_DESC',
}

export type TrialsQueryParams = {
    firsts?: InputMaybe<Scalars['Int']['input']>;
    ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type TusFacturasApiLog = {
    __typename?: 'TusFacturasApiLog';
    created_at: Scalars['DateTime']['output'];
    id: Scalars['String']['output'];
    method: Scalars['String']['output'];
    requestBody?: Maybe<Scalars['JSONObject']['output']>;
    requestHeaders: Scalars['JSONObject']['output'];
    responseBody?: Maybe<Scalars['JSONObject']['output']>;
    responseHeaders: Scalars['JSONObject']['output'];
    responseStatus: Scalars['Int']['output'];
    updated_at: Scalars['DateTime']['output'];
    url: Scalars['String']['output'];
    user_id?: Maybe<Scalars['String']['output']>;
};

export type TusFacturasWebhook = {
    __typename?: 'TusFacturasWebhook';
    body: Scalars['JSONObject']['output'];
    created_at: Scalars['DateTime']['output'];
    estado: EstadoWebhook;
    external_reference?: Maybe<Scalars['String']['output']>;
    id: Scalars['String']['output'];
    resultado_mensaje?: Maybe<Scalars['String']['output']>;
    resultado_ok?: Maybe<Scalars['Boolean']['output']>;
    type: Scalars['String']['output'];
    updated_at: Scalars['DateTime']['output'];
};

export type TusFacturasWebhooksEdge = {
    __typename?: 'TusFacturasWebhooksEdge';
    cursor: Scalars['String']['output'];
    node: TusFacturasWebhook;
};

export type UltimasSuscripcionesConnectionFilters = {
    estados?: InputMaybe<Array<EstadoSuscripcion>>;
    pasarelas?: InputMaybe<Array<Pasarela>>;
    udn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UltimasVentasConfig = {
    __typename?: 'UltimasVentasConfig';
    active: Scalars['Boolean']['output'];
    clickEnabled?: Maybe<Scalars['Boolean']['output']>;
    clickOpenNewTab?: Maybe<Scalars['Boolean']['output']>;
    displayTime: Scalars['Int']['output'];
    hideCliente?: Maybe<Scalars['Boolean']['output']>;
    hideClienteAlternative?: Maybe<Scalars['String']['output']>;
    hideTimeAgo: Scalars['Boolean']['output'];
    /** las horas, sólo válido si hideTimeAgo es falso */
    hideTimeAgoHs: Scalars['Int']['output'];
    mobileDisabled: Scalars['Boolean']['output'];
    mobilePosition: MobilePosition;
    mobileSize?: Maybe<MobileSize2021>;
    position: Position;
    showTo?: Maybe<ShowTargets>;
    sinceDays: Scalars['Int']['output'];
    template?: Maybe<Scalars['String']['output']>;
    theme?: Maybe<Theme>;
};

export type Uso = {
    __typename?: 'Uso';
    dias?: Maybe<Scalars['Int']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    notificaciones?: Maybe<Scalars['Int']['output']>;
    proyectado?: Maybe<Scalars['Int']['output']>;
};

export type Usuario = {
    __typename?: 'Usuario';
    cid?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['Date']['output']>;
    email?: Maybe<Scalars['String']['output']>;
    fecha_creacion_manual?: Maybe<Scalars['Date']['output']>;
    id: Scalars['String']['output'];
    isSuperAdmin?: Maybe<Scalars['Boolean']['output']>;
    password_temporal?: Maybe<Scalars['String']['output']>;
    password_temporal_pendiente_resetear?: Maybe<Scalars['Boolean']['output']>;
    roles?: Maybe<Array<Maybe<Rol>>>;
    stUserId?: Maybe<Scalars['String']['output']>;
    uid?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type UsuarioEnSt = {
    __typename?: 'UsuarioEnST';
    email?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    metadata?: Maybe<Scalars['JSON']['output']>;
    timeJoined?: Maybe<Scalars['JSON']['output']>;
};

export type UsuariosInputParams = {
    after?: InputMaybe<Scalars['String']['input']>;
    firsts?: InputMaybe<Scalars['Int']['input']>;
    ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type WebhookQueryParams = {
    after?: InputMaybe<Scalars['String']['input']>;
    cuenta_id?: InputMaybe<Scalars['String']['input']>;
    estados?: InputMaybe<Array<EstadoWebhook>>;
    firsts?: InputMaybe<Scalars['Int']['input']>;
    ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ZenRiseApiLog = {
    __typename?: 'ZenRiseApiLog';
    created_at: Scalars['DateTime']['output'];
    cuenta_id?: Maybe<Scalars['String']['output']>;
    id: Scalars['String']['output'];
    method: Scalars['String']['output'];
    requestBody?: Maybe<Scalars['JSON']['output']>;
    requestHeaders: Scalars['JSON']['output'];
    responseBody?: Maybe<Scalars['JSON']['output']>;
    responseHeaders: Scalars['JSON']['output'];
    responseStatus: Scalars['Int']['output'];
    updated_at: Scalars['DateTime']['output'];
    url: Scalars['String']['output'];
    user_id?: Maybe<Scalars['String']['output']>;
};

export type ZenRiseApiLogConnection = {
    __typename?: 'ZenRiseApiLogConnection';
    edges: Array<ZenRiseApiLogEdge>;
    pageInfo: PageInfo;
};

export type ZenRiseApiLogEdge = {
    __typename?: 'ZenRiseApiLogEdge';
    cursor: Scalars['String']['output'];
    node: ZenRiseApiLog;
};

export type ZenriseLogsConnectionFilters = {
    fecha_desde?: InputMaybe<Scalars['String']['input']>;
    fecha_hasta?: InputMaybe<Scalars['String']['input']>;
    method?: InputMaybe<Scalars['String']['input']>;
    status?: InputMaybe<Scalars['String']['input']>;
    url?: InputMaybe<Scalars['String']['input']>;
};

export type ZenriseWebhook = {
    __typename?: 'ZenriseWebhook';
    body: Scalars['JSONObject']['output'];
    created_at: Scalars['DateTime']['output'];
    cuenta?: Maybe<Cuenta>;
    cuenta_id?: Maybe<Scalars['String']['output']>;
    duplicate_of?: Maybe<Scalars['String']['output']>;
    estado: EstadoWebhook;
    hash: Scalars['String']['output'];
    id: Scalars['String']['output'];
    recepcion_aws_log_group_name?: Maybe<Scalars['String']['output']>;
    recepcion_aws_log_stream_name?: Maybe<Scalars['String']['output']>;
    resultado_mensaje?: Maybe<Scalars['String']['output']>;
    resultado_ok?: Maybe<Scalars['Boolean']['output']>;
    type: Scalars['String']['output'];
    ultimo_proceso_aws_log_group_name?: Maybe<Scalars['String']['output']>;
    ultimo_proceso_aws_log_stream_name?: Maybe<Scalars['String']['output']>;
    updated_at: Scalars['DateTime']['output'];
};

export type ZenriseWebhookEdge = {
    __typename?: 'ZenriseWebhookEdge';
    cursor: Scalars['String']['output'];
    node: ZenriseWebhook;
};

export type ZenriseWebhooksConnection = {
    __typename?: 'ZenriseWebhooksConnection';
    edges: Array<ZenriseWebhookEdge>;
    pageInfo: PageInfo;
};

export type ZenriseWebhooksConnectionFilters = {
    cuenta_id?: InputMaybe<Scalars['String']['input']>;
    estado?: InputMaybe<Scalars['String']['input']>;
    evento?: InputMaybe<Scalars['String']['input']>;
    fecha_desde?: InputMaybe<Scalars['String']['input']>;
    fecha_hasta?: InputMaybe<Scalars['String']['input']>;
    status?: InputMaybe<Scalars['String']['input']>;
};

export type GetProblemasQueryVariables = Exact<{ [key: string]: never }>;

export type GetProblemasQuery = {
    __typename?: 'Query';
    problemasCuentas: string;
};

export type CuentaNombreFragment = {
    __typename?: 'Cuenta';
    id: string;
    nombre?: string | null;
} & { ' $fragmentName'?: 'CuentaNombreFragment' };

export type GetEstadisticasAdminQueryVariables = Exact<{
    dias?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetEstadisticasAdminQuery = {
    __typename?: 'Query';
    estadisticasAdmin?: string | null;
};

export type GetEstadisticasAdminPorSituacionQueryVariables = Exact<{
    args: StatsArgs;
}>;

export type GetEstadisticasAdminPorSituacionQuery = {
    __typename?: 'Query';
    estadisticasAdminPorSituacion?: {
        __typename?: 'StatsPorSituacion';
        fecha_desde: string;
        fecha_hasta: string;
        dias: Array<string | null>;
        activas: Array<any | null>;
        trial: Array<any | null>;
        otras: Array<any | null>;
    } | null;
};

export type GetDatosAccesoQueryVariables = Exact<{
    stUserId: Scalars['String']['input'];
}>;

export type GetDatosAccesoQuery = {
    __typename?: 'Query';
    usuario?: {
        __typename?: 'Usuario';
        id: string;
        email?: string | null;
        stUserId?: string | null;
        password_temporal?: string | null;
        password_temporal_pendiente_resetear?: boolean | null;
    } | null;
};

export type CambiarClaveMutationVariables = Exact<{
    old_password: Scalars['String']['input'];
    new_password: Scalars['String']['input'];
}>;

export type CambiarClaveMutation = {
    __typename?: 'Mutation';
    cambiarClave?: boolean | null;
};

export type CambiarEmailMutationVariables = Exact<{
    new_email: Scalars['String']['input'];
}>;

export type CambiarEmailMutation = {
    __typename?: 'Mutation';
    cambiarEmail?: boolean | null;
};

export type BuscarCuentasAdminQueryVariables = Exact<{
    params: BuscarCuentasQueryParams;
}>;

export type BuscarCuentasAdminQuery = {
    __typename?: 'Query';
    buscarCuentas: Array<{
        __typename?: 'Cuenta';
        id: string;
        nombre?: string | null;
        pais?: string | null;
        email_pagos?: string | null;
        email_desde_legacy?: string | null;
        legacy_id?: string | null;
        tipo_doc?: string | null;
        documento?: string | null;
        razon_social?: string | null;
        condicion_ante_iva?: string | null;
        domicilio?: string | null;
        tn_store_id?: string | null;
        tienda_url?: string | null;
    }>;
};

export type GetAuditLogsQueryVariables = Exact<{
    params: GenericInputParams;
}>;

export type GetAuditLogsQuery = {
    __typename?: 'Query';
    auditLogs: Array<{
        __typename?: 'AuditLog';
        id: string;
        cuenta_id?: string | null;
        key: string;
        comments?: string | null;
        user_id?: string | null;
        es_admin: boolean;
        es_auto: boolean;
        created_at?: any | null;
        usuario?: {
            __typename?: 'Usuario';
            id: string;
            email?: string | null;
            isSuperAdmin?: boolean | null;
        } | null;
    }>;
};

export type GetAuditLogsPorCuentaQueryVariables = Exact<{
    cuenta_id: Scalars['String']['input'];
}>;

export type GetAuditLogsPorCuentaQuery = {
    __typename?: 'Query';
    cuenta?: {
        __typename?: 'Cuenta';
        id: string;
        auditLogs: Array<{
            __typename?: 'AuditLog';
            id: string;
            key: string;
            comments?: string | null;
            user_id?: string | null;
            es_admin: boolean;
            es_auto: boolean;
            created_at?: any | null;
            usuario?: {
                __typename?: 'Usuario';
                id: string;
                email?: string | null;
                isSuperAdmin?: boolean | null;
            } | null;
        }>;
    } | null;
};

export type GetAuditLogWithDataQueryVariables = Exact<{
    id: Scalars['String']['input'];
}>;

export type GetAuditLogWithDataQuery = {
    __typename?: 'Query';
    auditLog?: {
        __typename?: 'AuditLog';
        id: string;
        cuenta_id?: string | null;
        key: string;
        comments?: string | null;
        data?: any | null;
        user_id?: string | null;
        es_admin: boolean;
        es_auto: boolean;
        created_at?: any | null;
        usuario?: {
            __typename?: 'Usuario';
            id: string;
            email?: string | null;
            isSuperAdmin?: boolean | null;
        } | null;
    } | null;
};

export type GetBloqueosQueryVariables = Exact<{
    incluirViejos?: InputMaybe<Scalars['Boolean']['input']>;
    filtros?: InputMaybe<BloqueosConnectionParams>;
    pagination: CursorPaginationParams;
}>;

export type GetBloqueosQuery = {
    __typename?: 'Query';
    bloqueosConnection: {
        __typename?: 'BloqueosConnection';
        pageInfo: {
            __typename?: 'PageInfo';
            hasNextPage: boolean;
            endCursor?: string | null;
        };
        edges: Array<{
            __typename?: 'BloqueoEdge';
            node: {
                __typename?: 'Bloqueo';
                id: string;
                cuenta_id: string;
                motivo: BloqueoMotivos;
                ultimo?: boolean | null;
                bloqueada_event_id?: string | null;
                bloqueada_mail_id?: string | null;
                desbloqueada_event_id?: string | null;
                desbloqueada_mail_id?: string | null;
                fecha_bloqueo: string;
                fecha_desbloqueo?: string | null;
                cuenta?: {
                    __typename?: 'Cuenta';
                    id: string;
                    nombre?: string | null;
                    tn_store_id?: string | null;
                    legacy_id?: string | null;
                    bloqueada?: boolean | null;
                    bloqueo_fecha?: string | null;
                    bloqueo_razon?: BloqueoMotivos | null;
                } | null;
            };
        }>;
    };
};

export type GetCobrosPorCuentaQueryVariables = Exact<{
    id: Scalars['String']['input'];
}>;

export type GetCobrosPorCuentaQuery = {
    __typename?: 'Query';
    cuenta?: {
        __typename?: 'Cuenta';
        id: string;
        nombre?: string | null;
        tipo_doc?: string | null;
        documento?: string | null;
        condicion_ante_iva?: string | null;
        razon_social?: string | null;
        domicilio?: string | null;
        cobros?: Array<{
            __typename?: 'Cobro';
            id: string;
            monto?: number | null;
            fecha_cobro?: string | null;
            devuelto?: boolean | null;
            devuelto_fecha?: string | null;
            cuenta_id: string;
            tipo_factura?: string | null;
            pasarela?: string | null;
            pasarela_id?: string | null;
            facturado_en_afip?: boolean | null;
            facturado_manual?: boolean | null;
            numero_factura_propia?: string | null;
            pdf_factura_archivado?: boolean | null;
            pdf?: string | null;
            fecha_facturado_afip?: string | null;
            fecha_marcada_para_facturar?: string | null;
            en_proceso_facturar_en_afip_empezado?: string | null;
            en_proceso_facturar_en_afip_estado?: EstadoCobroApi | null;
            en_proceso_facturar_en_afip_error?: string | null;
            en_proceso_facturar_en_afip_nota_credito_empezado?: string | null;
            en_proceso_facturar_en_afip_nota_credito_estado?: EstadoCobroApi | null;
            en_proceso_facturar_en_afip_nota_credito_error?: string | null;
            numero_nota_credito_propia?: string | null;
            pdf_nota_credito?: string | null;
            fecha_nota_credito_emitida_afip?: string | null;
        } | null> | null;
    } | null;
};

export type GetContratacionesAdminQueryVariables = Exact<{
    filters?: InputMaybe<ContratacionesFilters>;
    params: CursorPaginationParams;
}>;

export type GetContratacionesAdminQuery = {
    __typename?: 'Query';
    connection: {
        __typename?: 'ContratacionesConnection';
        pageInfo: {
            __typename?: 'PageInfo';
            hasNextPage: boolean;
            endCursor?: string | null;
        };
        edges: Array<{
            __typename?: 'Contratacion';
            id: string;
            estado?: EstadoContratacionZenRise | null;
            plan_id?: string | null;
            updated_at?: any | null;
            created_at?: any | null;
            fsm_error?: string | null;
            cuenta_id: string;
            ultima?: boolean | null;
            error_al_crear_suscriptor?: string | null;
            plan?: {
                __typename?: 'Plan';
                id: string;
                nombre_publico: string;
                nombre_privado: string;
                precio_con_iva: number;
                zenrise_id?: string | null;
            } | null;
            cuenta?: {
                __typename?: 'Cuenta';
                id: string;
                nombre?: string | null;
                legacy_id?: string | null;
                email_desde_legacy?: string | null;
                tn_store_id?: string | null;
                tienda_url?: string | null;
                trial?: {
                    __typename?: 'Trial';
                    id: string;
                    estado: EstadoTrial;
                    fecha_fin: string;
                } | null;
                suscripcionActiva?: {
                    __typename?: 'Suscripcion';
                    id: string;
                    estado: EstadoSuscripcion;
                    pasarela?: string | null;
                    pasarela_id?: string | null;
                    plan_id?: string | null;
                } | null;
            } | null;
        }>;
    };
};

export type GetContratacionActivaQueryVariables = Exact<{
    cuenta_id: Scalars['String']['input'];
}>;

export type GetContratacionActivaQuery = {
    __typename?: 'Query';
    cuenta?: {
        __typename?: 'Cuenta';
        id: string;
        contratacionActiva?: {
            __typename?: 'Contratacion';
            id: string;
            estado?: EstadoContratacionZenRise | null;
            plan?: {
                __typename?: 'Plan';
                id: string;
                precio_con_iva: number;
            } | null;
        } | null;
    } | null;
};

export type GetCuentasQueryVariables = Exact<{ [key: string]: never }>;

export type GetCuentasQuery = {
    __typename?: 'Query';
    cuentas: Array<{
        __typename?: 'Cuenta';
        id: string;
        nombre?: string | null;
        email_pagos?: string | null;
        email_desde_legacy?: string | null;
        tn_store_id?: string | null;
        tienda_url?: string | null;
    }>;
};

export type GetCuentasAdminQueryVariables = Exact<{
    params: CuentasQueryParams;
}>;

export type GetCuentasAdminQuery = {
    __typename?: 'Query';
    cuentas: Array<{
        __typename?: 'Cuenta';
        id: string;
        nombre?: string | null;
        pais?: string | null;
        email_pagos?: string | null;
        email_desde_legacy?: string | null;
        legacy_id?: string | null;
        tipo_doc?: string | null;
        documento?: string | null;
        razon_social?: string | null;
        condicion_ante_iva?: string | null;
        domicilio?: string | null;
        tn_store_id?: string | null;
        tienda_url?: string | null;
    }>;
};

export type ReporteCuentasConPagosConProblemasQueryVariables = Exact<{
    [key: string]: never;
}>;

export type ReporteCuentasConPagosConProblemasQuery = {
    __typename?: 'Query';
    reporteCuentasConPagosConProblemas: Array<{
        __typename?: 'CuentasConPagosConProblemas';
        cuenta_id: string;
        nombre?: string | null;
        pais?: string | null;
        email_desde_legacy?: string | null;
        fecha_emision?: string | null;
        fecha_error?: string | null;
        mensaje_error?: string | null;
        invoice_id: string;
    }>;
};

export type GetCuentaDatosFacturacionQueryVariables = Exact<{
    id: Scalars['String']['input'];
}>;

export type GetCuentaDatosFacturacionQuery = {
    __typename?: 'Query';
    cuenta?: {
        __typename?: 'Cuenta';
        id: string;
        tipo_doc?: string | null;
        documento?: string | null;
        razon_social?: string | null;
        condicion_ante_iva?: string | null;
        domicilio?: string | null;
    } | null;
};

export type GetDashboardAdminQueryVariables = Exact<{ [key: string]: never }>;

export type GetDashboardAdminQuery = {
    __typename?: 'Query';
    dashboardSuscripciones?: {
        __typename?: 'DashboardSuscripciones';
        mensual?: string | null;
        mensual_con_iva?: string | null;
        ClientesActivos?: string | null;
        TicketPromedio?: string | null;
    } | null;
    estadoCuentasEnSuscripciones?: {
        __typename?: 'EstadoCuentasEnSubs';
        total?: number | null;
        bloqueadas?: number | null;
        no_bloqueadas?: number | null;
        suscripcion_activa?: number | null;
        en_dunning?: number | null;
        trial?: number | null;
        en_migracion?: number | null;
    } | null;
};

export type GetDatosDesdeTnQueryVariables = Exact<{
    id: Scalars['String']['input'];
}>;

export type GetDatosDesdeTnQuery = {
    __typename?: 'Query';
    cuenta?: {
        __typename?: 'Cuenta';
        id: string;
        datos_desde_tn?: string | null;
        datos_desde_tn_traidos?: string | null;
        datos_desde_tn_traidos_error?: string | null;
        datos_desde_tn_traidos_error_fecha?: string | null;
        datos_desde_tn_traidos_error_code?: string | null;
        datos_desde_tn_traidos_error_desc?: string | null;
        datos_desde_tn_traidos_error_resp?: string | null;
    } | null;
};

export type GetCustomerEstadisticasQueryVariables = Exact<{
    cid: Scalars['String']['input'];
    args: StatsArgs;
}>;

export type GetCustomerEstadisticasQuery = {
    __typename?: 'Query';
    cuenta?: {
        __typename?: 'Cuenta';
        id: string;
        stats?: {
            __typename?: 'Stats';
            fecha_desde: string;
            fecha_hasta: string;
            dias: Array<string | null>;
            clicks: Array<any | null>;
            notificaciones: Array<any | null>;
            pageviews: Array<any | null>;
        } | null;
    } | null;
};

export type GetCustomerEstadisticasNuevoQueryVariables = Exact<{
    cid: Scalars['String']['input'];
}>;

export type GetCustomerEstadisticasNuevoQuery = {
    __typename?: 'Query';
    cuenta?: {
        __typename?: 'Cuenta';
        id: string;
        stats?: {
            __typename?: 'Stats';
            fecha_desde: string;
            fecha_hasta: string;
            dias: Array<string | null>;
            clicks: Array<any | null>;
            pageviews: Array<any | null>;
            notificaciones: Array<any | null>;
        } | null;
    } | null;
};

export type GetEventsQueryVariables = Exact<{
    filters?: InputMaybe<EventsFilters>;
    params: CursorPaginationParams;
}>;

export type GetEventsQuery = {
    __typename?: 'Query';
    connection: {
        __typename?: 'EventsConnection';
        edges: Array<{
            __typename?: 'Events';
            id: string;
            cuenta_id?: string | null;
            event_type?: string | null;
            created_at?: string | null;
            source?: string | null;
            data?: string | null;
        }>;
        pageInfo: {
            __typename?: 'PageInfo';
            hasNextPage: boolean;
            startCursor?: string | null;
            endCursor?: string | null;
        };
    };
};

export type FacturasPendientesFacturarEnAfipQueryVariables = Exact<{
    [key: string]: never;
}>;

export type FacturasPendientesFacturarEnAfipQuery = {
    __typename?: 'Query';
    facturasPendientesFacturarEnAfip: Array<{
        __typename?: 'Cobro';
        id: string;
        monto?: number | null;
        fecha_cobro?: string | null;
        cuenta_id: string;
        pasarela?: string | null;
        pasarela_id?: string | null;
        devuelto?: boolean | null;
        devuelto_fecha?: string | null;
        numero_factura_propia?: string | null;
        numero_nota_credito_propia?: string | null;
        en_proceso_facturar_en_afip_empezado?: string | null;
        en_proceso_facturar_en_afip_estado?: EstadoCobroApi | null;
        en_proceso_facturar_en_afip_error?: string | null;
        fecha_facturado_afip?: string | null;
        cuenta?: {
            __typename?: 'Cuenta';
            id: string;
            nombre?: string | null;
            razon_social?: string | null;
            domicilio?: string | null;
            documento?: string | null;
            condicion_ante_iva?: string | null;
            tipo_doc?: string | null;
            pais?: string | null;
            suscripcionActiva?: {
                __typename?: 'Suscripcion';
                id: string;
                estado: EstadoSuscripcion;
            } | null;
        } | null;
    }>;
};

export type GetInfoCuentaQueryVariables = Exact<{
    id: Scalars['String']['input'];
}>;

export type GetInfoCuentaQuery = {
    __typename?: 'Query';
    cuenta?: {
        __typename?: 'Cuenta';
        id: string;
        nombre?: string | null;
        pais?: string | null;
        udn: string;
        email_pagos?: string | null;
        bloqueada?: boolean | null;
        bloqueo_fecha?: string | null;
        bloqueo_razon?: BloqueoMotivos | null;
        email_desde_legacy?: string | null;
        tn_store_id?: string | null;
        tienda_url?: string | null;
        legacy_id?: string | null;
        tipo_doc?: string | null;
        documento?: string | null;
        razon_social?: string | null;
        condicion_ante_iva?: string | null;
        domicilio?: string | null;
        stripe_customer_id?: string | null;
        stripe_habilitado: boolean;
        bonificacion_fecha_inicio?: string | null;
        bonificacion_motivo?: string | null;
        migracion?: {
            __typename?: 'Migracion';
            id: string;
            analisis_resultado?: boolean | null;
            analisis_problema?: string | null;
            analisis_ult_pago?: string | null;
            analisis_ult_pago_dias?: number | null;
            analisis_prox_pago?: string | null;
            estado?: EstadoMigracion | null;
            legacy_estado?: string | null;
            legacy_estado_tn?: string | null;
            legacy_plan?: string | null;
            json_importacion?: any | null;
        } | null;
        contratacionActiva?: {
            __typename?: 'Contratacion';
            id: string;
            cuenta_id: string;
            estado?: EstadoContratacionZenRise | null;
            zenrise_id?: string | null;
            plan_id?: string | null;
            fsm_error?: string | null;
            plan?: {
                __typename?: 'Plan';
                id: string;
                nombre_publico: string;
                nombre_privado: string;
                precio: number;
                precio_con_iva: number;
                zenrise_id?: string | null;
            } | null;
        } | null;
        suscripcionActiva?: {
            __typename?: 'Suscripcion';
            id: string;
            estado: EstadoSuscripcion;
            estado_full?: string | null;
            dunning_empezado?: string | null;
            source_active?: boolean | null;
            source_link?: string | null;
            pasarela?: string | null;
            pasarela_id?: string | null;
            fecha_ultimo_pago?: string | null;
            fecha_proximo_pago?: string | null;
            fsm_error?: string | null;
            udn: string;
            stripe_price_id?: string | null;
            stripe_price_amount?: number | null;
            stripe_price_currency?: string | null;
            stripe_product_id?: string | null;
            stripe_product_name?: string | null;
            stripe_plan?: {
                __typename?: 'StripePrice';
                id: string;
                currency: string;
                product_id: string;
                product_name: string;
                unit_amount: number;
                limit: number;
            } | null;
            plan?: {
                __typename?: 'Plan';
                id: string;
                precio: number;
                precio_con_iva: number;
                nombre_publico: string;
                nombre_privado: string;
                limite?: number | null;
                mostrar_en_selector?: boolean | null;
                valido_desde?: string | null;
                valido_hasta?: string | null;
                zenrise_id?: string | null;
            } | null;
            uso?: {
                __typename?: 'Uso';
                id?: string | null;
                dias?: number | null;
                proyectado?: number | null;
                notificaciones?: number | null;
            } | null;
        } | null;
        trial?: {
            __typename?: 'Trial';
            id: string;
            fecha_creacion: string;
            fecha_fin: string;
            estado: EstadoTrial;
        } | null;
    } | null;
};

export type GetInfoParaContratarQueryVariables = Exact<{
    cuenta_id: Scalars['String']['input'];
}>;

export type GetInfoParaContratarQuery = {
    __typename?: 'Query';
    cuenta?: {
        __typename?: 'Cuenta';
        id: string;
        udn: string;
        pais?: string | null;
        stripe_habilitado: boolean;
    } | null;
};

export type GetInfoParaContratarStripeQueryVariables = Exact<{
    cuenta_id: Scalars['String']['input'];
}>;

export type GetInfoParaContratarStripeQuery = {
    __typename?: 'Query';
    cuenta?: {
        __typename?: 'Cuenta';
        id: string;
        udn: string;
        pais?: string | null;
        uso?: {
            __typename?: 'Uso';
            id?: string | null;
            dias?: number | null;
            notificaciones?: number | null;
            proyectado?: number | null;
        } | null;
    } | null;
    stripePrices: Array<{
        __typename?: 'StripePrice';
        id: string;
        product_id: string;
        limit: number;
        product_name: string;
        unit_amount: number;
        currency: string;
    }>;
};

export type GetInfoParaPantallaFacturacionQueryVariables = Exact<{
    cuenta_id: Scalars['String']['input'];
}>;

export type GetInfoParaPantallaFacturacionQuery = {
    __typename?: 'Query';
    cuenta?: {
        __typename?: 'Cuenta';
        id: string;
        nombre?: string | null;
        email_pagos?: string | null;
        bloqueada?: boolean | null;
        bloqueo_fecha?: string | null;
        bloqueo_razon?: BloqueoMotivos | null;
        bonificacion_fecha_inicio?: string | null;
        bonificacion_motivo?: string | null;
        email_desde_legacy?: string | null;
        tn_store_id?: string | null;
        tienda_url?: string | null;
        legacy_id?: string | null;
        tipo_doc?: string | null;
        documento?: string | null;
        razon_social?: string | null;
        condicion_ante_iva?: string | null;
        domicilio?: string | null;
        pais?: string | null;
        udn: string;
        stripe_customer_id?: string | null;
        stripe_habilitado: boolean;
        migracion?: {
            __typename?: 'Migracion';
            id: string;
            analisis_resultado?: boolean | null;
            analisis_problema?: string | null;
            analisis_ult_pago?: string | null;
            analisis_ult_pago_dias?: number | null;
            analisis_prox_pago?: string | null;
            estado?: EstadoMigracion | null;
            legacy_estado?: string | null;
            legacy_estado_tn?: string | null;
            legacy_plan?: string | null;
            json_importacion?: any | null;
        } | null;
        contratacionActiva?: {
            __typename?: 'Contratacion';
            id: string;
            cuenta_id: string;
            estado?: EstadoContratacionZenRise | null;
            zenrise_id?: string | null;
            plan_id?: string | null;
            plan?: {
                __typename?: 'Plan';
                id: string;
                nombre_publico: string;
                nombre_privado: string;
                precio: number;
                precio_con_iva: number;
                zenrise_id?: string | null;
            } | null;
        } | null;
        uso?: {
            __typename?: 'Uso';
            id?: string | null;
            notificaciones?: number | null;
            proyectado?: number | null;
            dias?: number | null;
        } | null;
        suscripcionActiva?: {
            __typename?: 'Suscripcion';
            id: string;
            udn: string;
            estado: EstadoSuscripcion;
            estado_full?: string | null;
            dunning_empezado?: string | null;
            source_active?: boolean | null;
            source_link?: string | null;
            pasarela?: string | null;
            pasarela_id?: string | null;
            fecha_proximo_pago?: string | null;
            stripe_price_id?: string | null;
            stripe_price_amount?: number | null;
            stripe_price_currency?: string | null;
            stripe_product_id?: string | null;
            stripe_product_name?: string | null;
            invoice_zenrise_impaga?: {
                __typename?: 'InvoiceZenriseImpaga';
                zenrise_id: number;
                ultimo_error?: string | null;
            } | null;
            stripe_plan?: {
                __typename?: 'StripePrice';
                id: string;
                currency: string;
                product_id: string;
                product_name: string;
                unit_amount: number;
                limit: number;
            } | null;
            plan?: {
                __typename?: 'Plan';
                id: string;
                nombre_publico: string;
                precio: number;
                precio_con_iva: number;
                limite?: number | null;
            } | null;
            uso?: {
                __typename?: 'Uso';
                id?: string | null;
                notificaciones?: number | null;
                proyectado?: number | null;
                dias?: number | null;
            } | null;
        } | null;
        trial?: {
            __typename?: 'Trial';
            id: string;
            fecha_creacion: string;
            fecha_fin: string;
            estado: EstadoTrial;
        } | null;
    } | null;
    planPorDefecto?: {
        __typename?: 'Plan';
        id: string;
        nombre_publico: string;
        precio_con_iva: number;
        precio: number;
    } | null;
    getPlanesParaCuenta?: Array<{
        __typename?: 'Plan';
        id: string;
        nombre_publico: string;
        nombre_privado: string;
        precio: number;
        precio_con_iva: number;
        por_defecto?: boolean | null;
        zenrise_id?: string | null;
        limite?: number | null;
        valido_desde?: string | null;
        valido_hasta?: string | null;
        mostrar_en_selector?: boolean | null;
    } | null> | null;
};

export type GetInfoSuscripcionQueryVariables = Exact<{
    id: Scalars['String']['input'];
}>;

export type GetInfoSuscripcionQuery = {
    __typename?: 'Query';
    cuenta?: {
        __typename?: 'Cuenta';
        id: string;
        nombre?: string | null;
        pais?: string | null;
        email_pagos?: string | null;
        bloqueada?: boolean | null;
        bloqueo_fecha?: string | null;
        bloqueo_razon?: BloqueoMotivos | null;
        email_desde_legacy?: string | null;
        tn_store_id?: string | null;
        tienda_url?: string | null;
        legacy_id?: string | null;
        tipo_doc?: string | null;
        documento?: string | null;
        razon_social?: string | null;
        condicion_ante_iva?: string | null;
        domicilio?: string | null;
        suscripcionActiva?: {
            __typename?: 'Suscripcion';
            id: string;
            estado: EstadoSuscripcion;
            estado_full?: string | null;
            dunning_empezado?: string | null;
            source_active?: boolean | null;
            source_link?: string | null;
            pasarela?: string | null;
            pasarela_id?: string | null;
            fecha_ultimo_pago?: string | null;
            fecha_proximo_pago?: string | null;
            fsm_error?: string | null;
            plan_id?: string | null;
            pasarela_plan_id?: string | null;
            stripe_price_id?: string | null;
            stripe_price_amount?: number | null;
            stripe_price_currency?: string | null;
            stripe_product_id?: string | null;
            stripe_product_name?: string | null;
            nuevo_plan_id?: string | null;
            nuevo_plan_pasarela_id?: string | null;
            invoice_zenrise_impaga?: {
                __typename?: 'InvoiceZenriseImpaga';
                zenrise_id: number;
                ultimo_error?: string | null;
            } | null;
            stripe_plan?: {
                __typename?: 'StripePrice';
                id: string;
                currency: string;
                product_id: string;
                product_name: string;
                unit_amount: number;
                limit: number;
            } | null;
            plan?: {
                __typename?: 'Plan';
                id: string;
                precio: number;
                precio_con_iva: number;
                nombre_publico: string;
                nombre_privado: string;
                limite?: number | null;
                mostrar_en_selector?: boolean | null;
                valido_desde?: string | null;
                valido_hasta?: string | null;
                zenrise_id?: string | null;
            } | null;
            nuevo_plan?: {
                __typename?: 'Plan';
                id: string;
                precio: number;
                precio_con_iva: number;
                nombre_publico: string;
                nombre_privado: string;
                limite?: number | null;
                mostrar_en_selector?: boolean | null;
                valido_desde?: string | null;
                valido_hasta?: string | null;
                zenrise_id?: string | null;
            } | null;
            uso?: {
                __typename?: 'Uso';
                id?: string | null;
                dias?: number | null;
                proyectado?: number | null;
                notificaciones?: number | null;
            } | null;
        } | null;
    } | null;
};

export type GetInfoSuscripcionesQueryVariables = Exact<{
    id: Scalars['String']['input'];
}>;

export type GetInfoSuscripcionesQuery = {
    __typename?: 'Query';
    cuenta?: {
        __typename?: 'Cuenta';
        id: string;
        nombre?: string | null;
        suscripciones?: Array<{
            __typename?: 'Suscripcion';
            id: string;
            estado: EstadoSuscripcion;
            pasarela?: string | null;
            pasarela_id?: string | null;
            fsm_error?: string | null;
            fecha_creacion: string;
            fecha_ultimo_pago?: string | null;
            fecha_proximo_pago?: string | null;
            stripe_price_id?: string | null;
            stripe_price_amount?: number | null;
            stripe_price_currency?: string | null;
            stripe_product_id?: string | null;
            stripe_product_name?: string | null;
            plan?: {
                __typename?: 'Plan';
                id: string;
                precio: number;
                precio_con_iva: number;
                nombre_publico: string;
                nombre_privado: string;
                limite?: number | null;
                mostrar_en_selector?: boolean | null;
                valido_desde?: string | null;
                valido_hasta?: string | null;
            } | null;
        } | null> | null;
    } | null;
};

export type GetInfoSuscripcionesEnZenriseQueryVariables = Exact<{
    cuenta_id: Scalars['String']['input'];
}>;

export type GetInfoSuscripcionesEnZenriseQuery = {
    __typename?: 'Query';
    zenriseSuscripcionesInfo?: string | null;
};

export type GetInstalacionTnQueryVariables = Exact<{
    cid: Scalars['String']['input'];
}>;

export type GetInstalacionTnQuery = {
    __typename?: 'Query';
    instalacionEnTn?: string | null;
};

export type GetInvoicesAdminQueryVariables = Exact<{
    filters?: InputMaybe<InvoiceZenRiseConnectionFilters>;
    pagination: CursorPaginationParams;
}>;

export type GetInvoicesAdminQuery = {
    __typename?: 'Query';
    connection: {
        __typename?: 'InvoiceZenRiseConnection';
        pageInfo: {
            __typename?: 'PageInfo';
            hasNextPage: boolean;
            endCursor?: string | null;
        };
        edges: Array<{
            __typename?: 'InvoiceZenRiseEdge';
            node: {
                __typename?: 'InvoiceZenRise';
                id: string;
                zenrise_id?: string | null;
                cuenta_id?: string | null;
                fecha_emision?: string | null;
                fecha_pago?: string | null;
                estado_zenrise?: string | null;
                monto?: number | null;
                metodo_pago?: string | null;
                fecha_estimado_acreditacion?: string | null;
                facturada_manual?: boolean | null;
                numero_factura_propia?: string | null;
                facturada_manual_ruta?: string | null;
                created_at?: string | null;
                updated_at?: string | null;
                data?: string | null;
                errores_zr?: string | null;
                cuenta?: {
                    __typename?: 'Cuenta';
                    id: string;
                    nombre?: string | null;
                    tipo_doc?: string | null;
                    documento?: string | null;
                    condicion_ante_iva?: string | null;
                    razon_social?: string | null;
                    domicilio?: string | null;
                } | null;
            };
        }>;
    };
};

export type GetInvoiceAdminQueryVariables = Exact<{
    id: Scalars['String']['input'];
}>;

export type GetInvoiceAdminQuery = {
    __typename?: 'Query';
    invoiceZenRise?: {
        __typename?: 'InvoiceZenRise';
        id: string;
        zenrise_id?: string | null;
        cuenta_id?: string | null;
        fecha_emision?: string | null;
        fecha_pago?: string | null;
        estado_zenrise?: string | null;
        monto?: number | null;
        metodo_pago?: string | null;
        fecha_estimado_acreditacion?: string | null;
        facturada_manual?: boolean | null;
        numero_factura_propia?: string | null;
        facturada_manual_ruta?: string | null;
        created_at?: string | null;
        updated_at?: string | null;
        data?: string | null;
        errores_zr?: string | null;
        cuenta?: {
            __typename?: 'Cuenta';
            id: string;
            nombre?: string | null;
            tipo_doc?: string | null;
            documento?: string | null;
            condicion_ante_iva?: string | null;
            razon_social?: string | null;
            domicilio?: string | null;
        } | null;
    } | null;
};

export type GetIpnConnectionQueryVariables = Exact<{
    filters?: InputMaybe<IpnConnectionFilters>;
    pagination: CursorPaginationParams;
}>;

export type GetIpnConnectionQuery = {
    __typename?: 'Query';
    ipnConnection: {
        __typename?: 'IpnConnection';
        pageInfo: {
            __typename?: 'PageInfo';
            hasNextPage: boolean;
            endCursor?: string | null;
        };
        edges: Array<{
            __typename?: 'IpnEdge';
            node: {
                __typename?: 'IPN';
                id: string;
                body: string;
                externalReference: string;
                estado: EstadoIpn;
                invoiceId: number;
                resultado_mensaje?: string | null;
                resultado_ok?: boolean | null;
                transactionId: string;
                created_at: any;
                updated_at: any;
                invoice?: {
                    __typename?: 'InvoiceZenRise';
                    id: string;
                    estado_zenrise?: string | null;
                } | null;
                cuenta?: {
                    __typename?: 'Cuenta';
                    id: string;
                    nombre?: string | null;
                    suscripcionActiva?: {
                        __typename?: 'Suscripcion';
                        id: string;
                        dunning_empezado?: string | null;
                        fecha_ultimo_pago?: string | null;
                        fecha_proximo_pago?: string | null;
                        estado: EstadoSuscripcion;
                    } | null;
                } | null;
            };
        }>;
    };
};

export type IsEmailOnHoldQueryVariables = Exact<{
    email: Scalars['String']['input'];
}>;

export type IsEmailOnHoldQuery = {
    __typename?: 'Query';
    isEmailOnHold: boolean;
};

export type IsGoblalHoldActivatedQueryVariables = Exact<{
    [key: string]: never;
}>;

export type IsGoblalHoldActivatedQuery = {
    __typename?: 'Query';
    isGoblalHoldActivated: boolean;
};

export type GetLinkParaDescargarFacturaQueryVariables = Exact<{
    cobro_id: Scalars['String']['input'];
}>;

export type GetLinkParaDescargarFacturaQuery = {
    __typename?: 'Query';
    getLinkParaDescargarFactura?: string | null;
};

export type GetLinkParaDescargarNotaCreditoQueryVariables = Exact<{
    cobro_id: Scalars['String']['input'];
}>;

export type GetLinkParaDescargarNotaCreditoQuery = {
    __typename?: 'Query';
    getLinkParaDescargarNotaCredito?: string | null;
};

export type GetMailsOutboxQueryVariables = Exact<{
    filters?: InputMaybe<MailOutboxFilters>;
    params: CursorPaginationParams;
}>;

export type GetMailsOutboxQuery = {
    __typename?: 'Query';
    connection: {
        __typename?: 'MailOutboxConnection';
        edges: Array<{
            __typename?: 'MailOutbox';
            id: string;
            cuenta_id?: string | null;
            sendgrid_message_id?: string | null;
            to?: string | null;
            template_id?: string | null;
            delivered?: string | null;
            opened?: string | null;
            bounced?: string | null;
            bounced_classification?: string | null;
            bounced_reason?: string | null;
            dropped?: string | null;
            dropped_reason?: string | null;
            send_at?: number | null;
            created_at?: string | null;
        }>;
        pageInfo: {
            __typename?: 'PageInfo';
            hasNextPage: boolean;
            endCursor?: string | null;
        };
    };
};

export type GetMigracionesAdminQueryVariables = Exact<{
    params: MigracionesQueryParams;
}>;

export type GetMigracionesAdminQuery = {
    __typename?: 'Query';
    migraciones: Array<{
        __typename?: 'Migracion';
        id: string;
        estado?: EstadoMigracion | null;
        suscripcion_id?: string | null;
        tn_store_id?: string | null;
        legacy_id?: string | null;
        creada_en_legacy?: string | null;
        cuenta_id: string;
        analisis_fecha?: string | null;
        analisis_resultado?: boolean | null;
        analisis_problema?: string | null;
        analisis_comentario?: string | null;
        analisis_ult_pago?: string | null;
        analisis_prox_pago?: string | null;
        analisis_ult_pago_dias?: number | null;
        legacy_estado?: string | null;
        legacy_estado_tn?: string | null;
        legacy_plan?: string | null;
        cuenta?: {
            __typename?: 'Cuenta';
            id: string;
            nombre?: string | null;
            legacy_id?: string | null;
            email_pagos?: string | null;
            bloqueada?: boolean | null;
            bloqueo_fecha?: string | null;
            sparkline?: Array<any | null> | null;
            pais?: string | null;
            trial?: {
                __typename?: 'Trial';
                id: string;
                estado: EstadoTrial;
                fecha_fin: string;
            } | null;
            suscripcionActiva?: {
                __typename?: 'Suscripcion';
                id: string;
                estado: EstadoSuscripcion;
                fecha_proximo_pago?: string | null;
            } | null;
            uso?: {
                __typename?: 'Uso';
                id?: string | null;
                notificaciones?: number | null;
                proyectado?: number | null;
                dias?: number | null;
            } | null;
            roles?: Array<{
                __typename?: 'Rol';
                id?: string | null;
                rolNombre?: string | null;
                usuario?: {
                    __typename?: 'Usuario';
                    id: string;
                    email?: string | null;
                } | null;
            } | null> | null;
        } | null;
    }>;
};

export type CobrosPendientesDeNotaCreditoQueryVariables = Exact<{
    [key: string]: never;
}>;

export type CobrosPendientesDeNotaCreditoQuery = {
    __typename?: 'Query';
    cobrosPendientesDeNotaCredito: Array<{
        __typename?: 'Cobro';
        id: string;
        monto?: number | null;
        fecha_cobro?: string | null;
        cuenta_id: string;
        pasarela?: string | null;
        pasarela_id?: string | null;
        devuelto?: boolean | null;
        devuelto_fecha?: string | null;
        numero_factura_propia?: string | null;
        numero_nota_credito_propia?: string | null;
        en_proceso_facturar_en_afip_nota_credito_empezado?: string | null;
        en_proceso_facturar_en_afip_nota_credito_estado?: EstadoCobroApi | null;
        en_proceso_facturar_en_afip_nota_credito_error?: string | null;
        fecha_facturado_afip?: string | null;
        cuenta?: {
            __typename?: 'Cuenta';
            id: string;
            nombre?: string | null;
            razon_social?: string | null;
            domicilio?: string | null;
            documento?: string | null;
            condicion_ante_iva?: string | null;
            tipo_doc?: string | null;
            pais?: string | null;
            suscripcionActiva?: {
                __typename?: 'Suscripcion';
                id: string;
                estado: EstadoSuscripcion;
            } | null;
        } | null;
    }>;
};

export type GetPlanesAdminQueryVariables = Exact<{ [key: string]: never }>;

export type GetPlanesAdminQuery = {
    __typename?: 'Query';
    planes: Array<{
        __typename?: 'Plan';
        id: string;
        nombre_publico: string;
        nombre_privado: string;
        precio: number;
        precio_con_iva: number;
        por_defecto?: boolean | null;
        zenrise_id?: string | null;
        limite?: number | null;
        valido_desde?: string | null;
        valido_hasta?: string | null;
        mostrar_en_selector?: boolean | null;
        cuentas_activas?: number | null;
    }>;
};

export type GetPlanesStripeAdminQueryVariables = Exact<{
    [key: string]: never;
}>;

export type GetPlanesStripeAdminQuery = {
    __typename?: 'Query';
    stripePrices: Array<{
        __typename?: 'StripePrice';
        id: string;
        product_id: string;
        limit: number;
        product_name: string;
        unit_amount: number;
        currency: string;
    }>;
};

export type GetPlanDetallesQueryVariables = Exact<{
    id: Scalars['String']['input'];
}>;

export type GetPlanDetallesQuery = {
    __typename?: 'Query';
    plan?: {
        __typename?: 'Plan';
        id: string;
        nombre_publico: string;
        nombre_privado: string;
        precio: number;
        precio_con_iva: number;
        por_defecto?: boolean | null;
        zenrise_id?: string | null;
        limite?: number | null;
        valido_desde?: string | null;
        valido_hasta?: string | null;
        mostrar_en_selector?: boolean | null;
    } | null;
};

export type GetProcesosDiariosConnectionQueryVariables = Exact<{
    filters?: InputMaybe<ProcesosDiariosConnectionFilters>;
    pagination: CursorPaginationParams;
    incluirCuenta: Scalars['Boolean']['input'];
}>;

export type GetProcesosDiariosConnectionQuery = {
    __typename?: 'Query';
    connection: {
        __typename?: 'ProcesosDiariosConnection';
        pageInfo: {
            __typename?: 'PageInfo';
            endCursor?: string | null;
            hasNextPage: boolean;
        };
        edges: Array<{
            __typename?: 'ProcesoDiario';
            id?: string | null;
            cuenta_id?: string | null;
            proceso?: string | null;
            fecha?: string | null;
            resultado_ok?: boolean | null;
            error?: string | null;
            cuenta?: {
                __typename?: 'Cuenta';
                id: string;
                nombre?: string | null;
            } | null;
        }>;
    };
};

export type GetReportesSuscripcionesZenriseQueryVariables = Exact<{
    [key: string]: never;
}>;

export type GetReportesSuscripcionesZenriseQuery = {
    __typename?: 'Query';
    reportesSuscripcionesZenrise: Array<{
        __typename?: 'ResultadoReporteSuscripcionesZenriseSinData';
        id: string;
        fecha: string;
        archivo: string;
    }>;
};

export type GetReporteCobrosPendientesFacturarQueryVariables = Exact<{
    [key: string]: never;
}>;

export type GetReporteCobrosPendientesFacturarQuery = {
    __typename?: 'Query';
    reporteCobrosPendientesFacturar: {
        __typename?: 'ReporteCobrosPendientesFacturar';
        marcado_para_facturar?: number | null;
        ya_facturado_este_mes?: number | null;
        CobrosPendientes?: Array<{
            __typename?: 'Cobro';
            id: string;
            monto?: number | null;
            fecha_cobro?: string | null;
            devuelto?: boolean | null;
            cuenta_id: string;
            pasarela?: string | null;
            pasarela_id?: string | null;
            numero_factura_propia?: string | null;
            fecha_marcada_para_facturar?: string | null;
            cuenta?: {
                __typename?: 'Cuenta';
                id: string;
                nombre?: string | null;
                documento?: string | null;
                razon_social?: string | null;
                domicilio?: string | null;
                condicion_ante_iva?: string | null;
                tipo_doc?: string | null;
                pais?: string | null;
                suscripcionActiva?: {
                    __typename?: 'Suscripcion';
                    id: string;
                    estado: EstadoSuscripcion;
                } | null;
            } | null;
        }> | null;
    };
};

export type GetReporteCuentasDunningZenriseQueryVariables = Exact<{
    [key: string]: never;
}>;

export type GetReporteCuentasDunningZenriseQuery = {
    __typename?: 'Query';
    reporteCuentasDunningZenrise: Array<{
        __typename?: 'CuentaEnDunningZenrise';
        cuenta_id: string;
        udn?: string | null;
        nombre: string;
        email_desde_legacy?: string | null;
        bloqueada: boolean;
        pais?: string | null;
        fecha_proximo_pago: string;
        fecha_emision: string;
        estado_zenrise?: string | null;
        intentos?: number | null;
        fecha_ultimo_error?: string | null;
        dunning_empezado?: string | null;
        mensaje_ultimo_error?: string | null;
        errores_zr?: string | null;
        datos_desde_tn_traidos?: string | null;
        datos_desde_tn_traidos_error_code?: string | null;
        datos_desde_tn_traidos_error_desc?: string | null;
        datos_desde_tn_traidos_error_fecha?: string | null;
        last_task_id?: string | null;
        last_task_nombre?: string | null;
        last_task_created_at?: string | null;
        last_task_resultado_ok?: boolean | null;
    }>;
    dunningPreview: Array<{
        __typename?: 'DunningPreview';
        dunning_empezado: string;
        cuenta_id: string;
        task: string;
        cuenta?: {
            __typename?: 'Cuenta';
            id: string;
            nombre?: string | null;
            pais?: string | null;
        } | null;
    } | null>;
};

export type GetReporteFacturasQueryVariables = Exact<{
    mes?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetReporteFacturasQuery = {
    __typename?: 'Query';
    reporteFacturas: {
        __typename?: 'ReporteFacturas';
        Facturas?: Array<{
            __typename?: 'Cobro';
            id: string;
            monto?: number | null;
            fecha_cobro?: string | null;
            cuenta_id: string;
            pasarela?: string | null;
            pasarela_id?: string | null;
            numero_factura_propia?: string | null;
            tipo_factura?: string | null;
            pdf?: string | null;
            pdf_factura_archivado?: boolean | null;
            fecha_facturado_afip?: string | null;
            numero_nota_credito_propia?: string | null;
            pdf_nota_credito?: string | null;
            fecha_nota_credito_emitida_afip?: string | null;
            devuelto?: boolean | null;
            cuenta?: {
                __typename?: 'Cuenta';
                id: string;
                nombre?: string | null;
                documento?: string | null;
                condicion_ante_iva?: string | null;
                tipo_doc?: string | null;
                razon_social?: string | null;
                domicilio?: string | null;
                pais?: string | null;
                suscripcionActiva?: {
                    __typename?: 'Suscripcion';
                    id: string;
                    estado: EstadoSuscripcion;
                } | null;
            } | null;
        }> | null;
    };
};

export type GetReporteSuscripcionesZenriseQueryVariables = Exact<{
    id: Scalars['String']['input'];
    refrescarLogica?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type GetReporteSuscripcionesZenriseQuery = {
    __typename?: 'Query';
    reporteSuscripcionesZenrise?: {
        __typename?: 'ResultadoReporteSuscripcionesZenrise';
        id: string;
        fecha: string;
        archivo: string;
        data?: {
            __typename?: 'ResultadoReporteSuscripcionesZenriseData';
            resumen_vivas: {
                __typename?: 'SumatoriaEstadosZenrise';
                ACTIVE: number;
                CANCELLED: number;
                PAST_DUE: number;
                UNPAID: number;
            };
            resumen_muertas: {
                __typename?: 'SumatoriaEstadosZenrise';
                ACTIVE: number;
                CANCELLED: number;
                PAST_DUE: number;
                UNPAID: number;
            };
            cuentas: Array<{
                __typename?: 'CuentaConProblemas';
                cuenta_id: string;
                nombre: string;
                problemas?: string | null;
            }>;
            problemas: Array<{
                __typename?: 'ProblemaConCuentas';
                nombre: string;
                cuentas: {
                    __typename?: 'ProblemaConCuentas_Cuentas';
                    length: number;
                    data?: string | null;
                };
            }>;
        } | null;
    } | null;
};

export type GetStripePricesQueryVariables = Exact<{ [key: string]: never }>;

export type GetStripePricesQuery = {
    __typename?: 'Query';
    stripePrices: Array<{
        __typename?: 'StripePrice';
        id: string;
        product_id: string;
        limit: number;
        product_name: string;
        unit_amount: number;
        currency: string;
    }>;
};

export type GetSuscripcionesActivasQueryVariables = Exact<{
    pagination: CursorPaginationParams;
    sparkline: Scalars['Boolean']['input'];
}>;

export type GetSuscripcionesActivasQuery = {
    __typename?: 'Query';
    suscripcionesActivasConnection: {
        __typename?: 'SuscripcionesConnection';
        pageInfo: {
            __typename?: 'PageInfo';
            endCursor?: string | null;
            hasNextPage: boolean;
        };
        edges: Array<{
            __typename?: 'Suscripcion';
            id: string;
            estado: EstadoSuscripcion;
            pasarela?: string | null;
            pasarela_id?: string | null;
            es_manual?: boolean | null;
            fecha_ultimo_pago?: string | null;
            fecha_proximo_pago?: string | null;
            fecha_creacion: string;
            source_active?: boolean | null;
            plan?: {
                __typename?: 'Plan';
                id: string;
                nombre_publico: string;
                nombre_privado: string;
                precio: number;
                limite?: number | null;
            } | null;
            uso?: {
                __typename?: 'Uso';
                id?: string | null;
                notificaciones?: number | null;
                proyectado?: number | null;
                dias?: number | null;
            } | null;
            cuenta?: {
                __typename?: 'Cuenta';
                id: string;
                nombre?: string | null;
                legacy_id?: string | null;
                tn_store_id?: string | null;
                condicion_ante_iva?: string | null;
                tipo_doc?: string | null;
                documento?: string | null;
                pais?: string | null;
                sparkline?: Array<any | null> | null;
                uso?: {
                    __typename?: 'Uso';
                    id?: string | null;
                    notificaciones?: number | null;
                    proyectado?: number | null;
                    dias?: number | null;
                } | null;
            } | null;
        }>;
    };
};

export type GetSuscripcionesParaCancelarPorFaltaDePagoAdminQueryVariables =
    Exact<{
        fecha: Scalars['String']['input'];
    }>;

export type GetSuscripcionesParaCancelarPorFaltaDePagoAdminQuery = {
    __typename?: 'Query';
    cancelarSuscripcionesPorFaltaDePagoPreview?: Array<{
        __typename?: 'Suscripcion';
        id: string;
        estado: EstadoSuscripcion;
        fecha_proximo_pago?: string | null;
        cuenta?: {
            __typename?: 'Cuenta';
            id: string;
            nombre?: string | null;
            email_pagos?: string | null;
            legacy_id?: string | null;
            tn_store_id?: string | null;
            trial?: {
                __typename?: 'Trial';
                id: string;
                estado: EstadoTrial;
                fecha_fin: string;
            } | null;
        } | null;
    } | null> | null;
};

export type GetSuscripcionesParaCancelarQueEstabanEsperandoAdminQueryVariables =
    Exact<{
        fecha: Scalars['String']['input'];
    }>;

export type GetSuscripcionesParaCancelarQueEstabanEsperandoAdminQuery = {
    __typename?: 'Query';
    terminarSuscripcionesQueEstabanHastaFinDePeriodoPreview?: Array<{
        __typename?: 'Suscripcion';
        id: string;
        estado: EstadoSuscripcion;
        fecha_proximo_pago?: string | null;
        cuenta?: {
            __typename?: 'Cuenta';
            id: string;
            nombre?: string | null;
            email_pagos?: string | null;
            legacy_id?: string | null;
            tn_store_id?: string | null;
            trial?: {
                __typename?: 'Trial';
                id: string;
                estado: EstadoTrial;
                fecha_fin: string;
            } | null;
        } | null;
    } | null> | null;
};

export type GetTrialsActivosConnectionQueryVariables = Exact<{
    pagination: CursorPaginationParams;
    filters?: InputMaybe<TrialsActivosConnectionFilters>;
}>;

export type GetTrialsActivosConnectionQuery = {
    __typename?: 'Query';
    trialsActivosConnection: {
        __typename?: 'TrialsActivosConnection';
        pageInfo: {
            __typename?: 'PageInfo';
            hasNextPage: boolean;
            endCursor?: string | null;
        };
        edges: Array<{
            __typename?: 'Trial';
            id: string;
            fecha_creacion: string;
            fecha_fin: string;
            cuenta_id: string;
            cuenta?: {
                __typename?: 'Cuenta';
                id: string;
                udn: string;
                pais?: string | null;
                nombre?: string | null;
                tn_store_id?: string | null;
                legacy_id?: string | null;
                bloqueada?: boolean | null;
                bloqueo_fecha?: string | null;
                bloqueo_razon?: BloqueoMotivos | null;
            } | null;
        }>;
    };
};

export type GetTrialsAdminQueryVariables = Exact<{
    params: TrialsQueryParams;
}>;

export type GetTrialsAdminQuery = {
    __typename?: 'Query';
    trials: Array<{
        __typename?: 'Trial';
        id: string;
        estado: EstadoTrial;
        fecha_creacion: string;
        fecha_fin: string;
        cuenta?: {
            __typename?: 'Cuenta';
            id: string;
            nombre?: string | null;
            email_desde_legacy?: string | null;
            tn_store_id?: string | null;
            tienda_url?: string | null;
            contratacionActiva?: {
                __typename?: 'Contratacion';
                id: string;
                estado?: EstadoContratacionZenRise | null;
            } | null;
            uso?: {
                __typename?: 'Uso';
                id?: string | null;
                notificaciones?: number | null;
                proyectado?: number | null;
                dias?: number | null;
            } | null;
        } | null;
    }>;
};

export type GetTrialsParaTerminarQueryVariables = Exact<{
    fecha: Scalars['String']['input'];
}>;

export type GetTrialsParaTerminarQuery = {
    __typename?: 'Query';
    trialsParaTerminar?: Array<{
        __typename?: 'Trial';
        id: string;
        estado: EstadoTrial;
        fecha_fin: string;
        cuenta?: {
            __typename?: 'Cuenta';
            id: string;
            nombre?: string | null;
            pais?: string | null;
            udn: string;
            legacy_id?: string | null;
            tn_store_id?: string | null;
            tienda_url?: string | null;
            contratacionActiva?: {
                __typename?: 'Contratacion';
                id: string;
                estado?: EstadoContratacionZenRise | null;
            } | null;
            suscripcionActiva?: {
                __typename?: 'Suscripcion';
                id: string;
                estado: EstadoSuscripcion;
            } | null;
        } | null;
    } | null> | null;
};

export type GetTusFacturasLogsQueryVariables = Exact<{
    params: SimplePaginationParams;
}>;

export type GetTusFacturasLogsQuery = {
    __typename?: 'Query';
    tusfacturasLogs: Array<{
        __typename?: 'TusFacturasApiLog';
        id: string;
        url: string;
        created_at: any;
        requestBody?: any | null;
        method: string;
        requestHeaders: any;
        responseStatus: number;
        responseBody?: any | null;
        responseHeaders: any;
    }>;
};

export type GetTusFacturasWebhooksQueryVariables = Exact<{
    params: WebhookQueryParams;
}>;

export type GetTusFacturasWebhooksQuery = {
    __typename?: 'Query';
    tusFacturasWebhooks: Array<{
        __typename?: 'TusFacturasWebhook';
        id: string;
        external_reference?: string | null;
        type: string;
        body: any;
        estado: EstadoWebhook;
        resultado_ok?: boolean | null;
        resultado_mensaje?: string | null;
        created_at: any;
        updated_at: any;
    }>;
};

export type UltimasSuscripcionesQueryVariables = Exact<{
    pagination: CursorPaginationParams;
    filters: UltimasSuscripcionesConnectionFilters;
    sparkline: Scalars['Boolean']['input'];
}>;

export type UltimasSuscripcionesQuery = {
    __typename?: 'Query';
    ultimasSuscripcionesConnection: {
        __typename?: 'SuscripcionesConnection';
        pageInfo: {
            __typename?: 'PageInfo';
            endCursor?: string | null;
            hasNextPage: boolean;
        };
        edges: Array<{
            __typename?: 'Suscripcion';
            id: string;
            estado: EstadoSuscripcion;
            estado_full?: string | null;
            dunning_empezado?: string | null;
            pasarela?: string | null;
            pasarela_id?: string | null;
            es_manual?: boolean | null;
            fecha_ultimo_pago?: string | null;
            fecha_proximo_pago?: string | null;
            fecha_creacion: string;
            source_active?: boolean | null;
            plan_id?: string | null;
            udn: string;
            stripe_price_currency?: string | null;
            stripe_price_amount?: number | null;
            stripe_price_id?: string | null;
            stripe_product_id?: string | null;
            stripe_product_name?: string | null;
            cuenta_id: string;
            plan?: {
                __typename?: 'Plan';
                id: string;
                nombre_publico: string;
                nombre_privado: string;
                precio: number;
                limite?: number | null;
            } | null;
            uso?: {
                __typename?: 'Uso';
                id?: string | null;
                notificaciones?: number | null;
                proyectado?: number | null;
                dias?: number | null;
            } | null;
            cuenta?: {
                __typename?: 'Cuenta';
                id: string;
                nombre?: string | null;
                legacy_id?: string | null;
                tn_store_id?: string | null;
                condicion_ante_iva?: string | null;
                tipo_doc?: string | null;
                documento?: string | null;
                pais?: string | null;
                udn: string;
                datos_desde_tn_traidos?: string | null;
                datos_desde_tn_traidos_error_code?: string | null;
                datos_desde_tn_traidos_error_fecha?: string | null;
                datos_desde_tn_traidos_error_desc?: string | null;
                sparkline?: Array<any | null> | null;
                uso?: {
                    __typename?: 'Uso';
                    id?: string | null;
                    notificaciones?: number | null;
                    proyectado?: number | null;
                    dias?: number | null;
                } | null;
            } | null;
        }>;
    };
};

export type GetUnidadDeNegocioQueryVariables = Exact<{
    cuenta_id: Scalars['String']['input'];
}>;

export type GetUnidadDeNegocioQuery = {
    __typename?: 'Query';
    cuentaEnAuth?: {
        __typename?: 'CuentaEnAuth';
        id?: string | null;
        pais?: string | null;
        udn?: string | null;
    } | null;
    cuentaEnLegacy?: {
        __typename?: 'CuentaEnLegacy';
        id?: string | null;
        pais?: string | null;
        udn?: string | null;
    } | null;
    cuentaEnSubs?: {
        __typename?: 'Cuenta';
        id: string;
        pais?: string | null;
        udn: string;
    } | null;
};

export type GetUsuariosAdminQueryVariables = Exact<{
    params: UsuariosInputParams;
}>;

export type GetUsuariosAdminQuery = {
    __typename?: 'Query';
    usuarios?: Array<{
        __typename?: 'Usuario';
        id: string;
        email?: string | null;
        uid?: string | null;
        cid?: string | null;
        isSuperAdmin?: boolean | null;
        stUserId?: string | null;
        updatedAt?: string | null;
        createdAt?: string | null;
        fecha_creacion_manual?: string | null;
        password_temporal?: string | null;
        password_temporal_pendiente_resetear?: boolean | null;
    } | null> | null;
};

export type GetUsuariosPorCuentaAdminQueryVariables = Exact<{
    id: Scalars['String']['input'];
}>;

export type GetUsuariosPorCuentaAdminQuery = {
    __typename?: 'Query';
    cuenta?: {
        __typename?: 'Cuenta';
        id: string;
        legacy_id?: string | null;
        roles?: Array<{
            __typename?: 'Rol';
            id?: string | null;
            rolNombre?: string | null;
            usuario?: {
                __typename?: 'Usuario';
                id: string;
                email?: string | null;
                stUserId?: string | null;
                uid?: string | null;
                createdAt?: string | null;
                updatedAt?: string | null;
                fecha_creacion_manual?: string | null;
                password_temporal?: string | null;
                password_temporal_pendiente_resetear?: boolean | null;
            } | null;
        } | null> | null;
    } | null;
    cuentaMerge?: {
        __typename?: 'CuentaEnLegacy';
        id?: string | null;
        user_id?: string | null;
    } | null;
};

export type GetZenriseLogsQueryVariables = Exact<{
    filters?: InputMaybe<ZenriseLogsConnectionFilters>;
    params: CursorPaginationParams;
}>;

export type GetZenriseLogsQuery = {
    __typename?: 'Query';
    ZenriseLogsConnection: {
        __typename?: 'ZenRiseApiLogConnection';
        edges: Array<{
            __typename?: 'ZenRiseApiLogEdge';
            node: {
                __typename?: 'ZenRiseApiLog';
                id: string;
                url: string;
                cuenta_id?: string | null;
                created_at: any;
                requestBody?: string | null;
                method: string;
                requestHeaders: string;
                responseStatus: number;
                responseBody?: string | null;
                responseHeaders: string;
            };
        }>;
        pageInfo: {
            __typename?: 'PageInfo';
            hasNextPage: boolean;
            endCursor?: string | null;
        };
    };
};

export type GetZenriseWebhooksConnectionQueryVariables = Exact<{
    filters?: InputMaybe<ZenriseWebhooksConnectionFilters>;
    pagination: CursorPaginationParams;
    incluirCuenta: Scalars['Boolean']['input'];
}>;

export type GetZenriseWebhooksConnectionQuery = {
    __typename?: 'Query';
    connection: {
        __typename?: 'ZenriseWebhooksConnection';
        pageInfo: {
            __typename?: 'PageInfo';
            endCursor?: string | null;
            hasNextPage: boolean;
        };
        edges: Array<{
            __typename?: 'ZenriseWebhookEdge';
            node: {
                __typename?: 'ZenriseWebhook';
                id: string;
                cuenta_id?: string | null;
                type: string;
                body: any;
                estado: EstadoWebhook;
                resultado_ok?: boolean | null;
                resultado_mensaje?: string | null;
                created_at: any;
                updated_at: any;
                cuenta?: {
                    __typename?: 'Cuenta';
                    id: string;
                    nombre?: string | null;
                    suscripcionActiva?: {
                        __typename?: 'Suscripcion';
                        id: string;
                        estado: EstadoSuscripcion;
                    } | null;
                } | null;
            };
        }>;
    };
};

export type ActivateGeneralHoldMutationVariables = Exact<{
    reason?: InputMaybe<Scalars['String']['input']>;
}>;

export type ActivateGeneralHoldMutation = {
    __typename?: 'Mutation';
    activateGeneralHold?: string | null;
};

export type AnularCancelacionMutationVariables = Exact<{
    cuenta_id: Scalars['String']['input'];
}>;

export type AnularCancelacionMutation = {
    __typename?: 'Mutation';
    anularCancelacion: boolean;
};

export type BloquearCuentaMutationVariables = Exact<{
    cuenta_id: Scalars['String']['input'];
}>;

export type BloquearCuentaMutation = {
    __typename?: 'Mutation';
    bloquearCuenta: boolean;
};

export type CambiarDatosFacturacionMutationVariables = Exact<{
    params: CambiarDatosFacturacionParams;
}>;

export type CambiarDatosFacturacionMutation = {
    __typename?: 'Mutation';
    cambiarDatosFacturacion?: {
        __typename?: 'Cuenta';
        id: string;
        tipo_doc?: string | null;
        documento?: string | null;
        razon_social?: string | null;
        condicion_ante_iva?: string | null;
        domicilio?: string | null;
    } | null;
};

export type CancelacionConServicioHastaFinPeriodoManualAdminMutationVariables =
    Exact<{
        cuenta_id: Scalars['String']['input'];
    }>;

export type CancelacionConServicioHastaFinPeriodoManualAdminMutation = {
    __typename?: 'Mutation';
    cancelar: boolean;
};

export type CancelacionInmediataManualAdminMutationVariables = Exact<{
    cuenta_id: Scalars['String']['input'];
}>;

export type CancelacionInmediataManualAdminMutation = {
    __typename?: 'Mutation';
    cancelacionInmediataManual: boolean;
};

export type CancelacionInmediataPorFaltaDePagoMutationVariables = Exact<{
    cuenta_id: Scalars['String']['input'];
}>;

export type CancelacionInmediataPorFaltaDePagoMutation = {
    __typename?: 'Mutation';
    cancelacionInmediataPorFaltaDePago: boolean;
};

export type CancelarCuentaMutationVariables = Exact<{
    params: InputCancelarParams;
}>;

export type CancelarCuentaMutation = {
    __typename?: 'Mutation';
    cancelar: boolean;
};

export type ConfirmarAcreditacionPagoPorTransferenciaMutationVariables = Exact<{
    cuenta_id: Scalars['String']['input'];
    fecha_ultimo_pago: Scalars['String']['input'];
    fecha_proximo_pago: Scalars['String']['input'];
    plan_id: Scalars['String']['input'];
}>;

export type ConfirmarAcreditacionPagoPorTransferenciaMutation = {
    __typename?: 'Mutation';
    confirmarAcreditacionPagoPorTransferencia: boolean;
};

export type ContratarStripeMutationVariables = Exact<{
    cuenta_id: Scalars['String']['input'];
    stripe_price_id: Scalars['String']['input'];
}>;

export type ContratarStripeMutation = {
    __typename?: 'Mutation';
    contratarStripe: {
        __typename?: 'IniciarContratacionStripeReturn';
        ok: boolean;
        url?: string | null;
        mensaje_error?: string | null;
    };
};

export type ContratarZenriseMutationVariables = Exact<{
    contratacion_id: Scalars['String']['input'];
    nombre: Scalars['String']['input'];
    dni: Scalars['String']['input'];
    cuenta_id: Scalars['String']['input'];
    token: Scalars['JSON']['input'];
    es_tarjeta_credito: Scalars['Boolean']['input'];
    plan_id: Scalars['String']['input'];
}>;

export type ContratarZenriseMutation = {
    __typename?: 'Mutation';
    contratarZenrise: {
        __typename?: 'IniciarContratacionZenriseReturn';
        ok: boolean;
        mensaje_error?: string | null;
    };
};

export type CrearUsuarioManualMutationVariables = Exact<{
    params: CrearUsuarioManualmenteParams;
}>;

export type CrearUsuarioManualMutation = {
    __typename?: 'Mutation';
    crearUsuarioManualmente?: { __typename?: 'Usuario'; id: string } | null;
};

export type DeactivateGeneralHoldMutationVariables = Exact<{
    [key: string]: never;
}>;

export type DeactivateGeneralHoldMutation = {
    __typename?: 'Mutation';
    deactivateGeneralHold?: string | null;
};

export type DesbloquearCuentaMutationVariables = Exact<{
    cuenta_id: Scalars['String']['input'];
}>;

export type DesbloquearCuentaMutation = {
    __typename?: 'Mutation';
    desbloquearCuenta: boolean;
};

export type DesestimarContratacionManualAdminMutationVariables = Exact<{
    cuenta_id: Scalars['String']['input'];
}>;

export type DesestimarContratacionManualAdminMutation = {
    __typename?: 'Mutation';
    desestimarContratacion: boolean;
};

export type EmitirNotaCreditoEnAfipMutationVariables = Exact<{
    cobro_id: Scalars['String']['input'];
}>;

export type EmitirNotaCreditoEnAfipMutation = {
    __typename?: 'Mutation';
    emitirNotaCreditoEnAfip?: string | null;
};

export type FacturarEnAfipMutationVariables = Exact<{
    cobro_id: Scalars['String']['input'];
}>;

export type FacturarEnAfipMutation = {
    __typename?: 'Mutation';
    facturarEnAfip?: string | null;
};

export type FacturarVariosEnAfipMutationVariables = Exact<{
    cantidad: Scalars['Int']['input'];
}>;

export type FacturarVariosEnAfipMutation = {
    __typename?: 'Mutation';
    facturarVariosEnAfip?: string | null;
};

export type FixDatosDesdeLegacyMutationVariables = Exact<{
    cuenta_id: Scalars['String']['input'];
}>;

export type FixDatosDesdeLegacyMutation = {
    __typename?: 'Mutation';
    fixDatosDesdeLegacy?: boolean | null;
};

export type InformarPagoPorTransferenciaMutationVariables = Exact<{
    cuenta_id: Scalars['String']['input'];
    plan_id: Scalars['String']['input'];
    fecha_ultimo_pago: Scalars['String']['input'];
    fecha_proximo_pago: Scalars['String']['input'];
    confirmo_pago_acreditado: Scalars['Boolean']['input'];
}>;

export type InformarPagoPorTransferenciaMutation = {
    __typename?: 'Mutation';
    informarPagoPorTransferencia: boolean;
};

export type MandarPlanZenRiseMutationVariables = Exact<{
    plan_id: Scalars['String']['input'];
}>;

export type MandarPlanZenRiseMutation = {
    __typename?: 'Mutation';
    mandarPlanZenRise: string;
};

export type MarcarCobrosParaFacturarMutationVariables = Exact<{
    selection: Array<CobroParaFacturarInput> | CobroParaFacturarInput;
}>;

export type MarcarCobrosParaFacturarMutation = {
    __typename?: 'Mutation';
    marcarCobrosParaFacturar?: boolean | null;
};

export type MarcarComoCanceladaMutationVariables = Exact<{
    cuenta_id: Scalars['String']['input'];
}>;

export type MarcarComoCanceladaMutation = {
    __typename?: 'Mutation';
    marcarComoCancelada: boolean;
};

export type MigracionCancelarMutationVariables = Exact<{
    cuenta_id: Scalars['String']['input'];
    comentario: Scalars['String']['input'];
}>;

export type MigracionCancelarMutation = {
    __typename?: 'Mutation';
    migracionCancelar: boolean;
};

export type MigracionMarcarComoListaMutationVariables = Exact<{
    cuenta_id: Scalars['String']['input'];
    fecha_proximo_pago: Scalars['Date']['input'];
}>;

export type MigracionMarcarComoListaMutation = {
    __typename?: 'Mutation';
    migracionMarcarComoLista: boolean;
};

export type MigracionPasarGestionManualMutationVariables = Exact<{
    cuenta_id: Scalars['String']['input'];
}>;

export type MigracionPasarGestionManualMutation = {
    __typename?: 'Mutation';
    migracionPasarGestionManual: boolean;
};

export type ObtenerLinkCobroZenriseMutationVariables = Exact<{
    cuenta_id: Scalars['String']['input'];
    invoice_id?: InputMaybe<Scalars['Int']['input']>;
}>;

export type ObtenerLinkCobroZenriseMutation = {
    __typename?: 'Mutation';
    obtenerLinkCobroZenrise: string;
};

export type ProcesarIpnMutationVariables = Exact<{
    id: Scalars['String']['input'];
}>;

export type ProcesarIpnMutation = {
    __typename?: 'Mutation';
    procesarIPN: {
        __typename?: 'ProcesarIPNResultado';
        ok: boolean;
        mensaje?: string | null;
    };
};

export type ProcesarTusFacturasWebhookMutationVariables = Exact<{
    id: Scalars['String']['input'];
}>;

export type ProcesarTusFacturasWebhookMutation = {
    __typename?: 'Mutation';
    rst: {
        __typename?: 'ProcesarWebhookResultado';
        ok: boolean;
        mensaje?: string | null;
    };
};

export type ProcesarZenriseWebhookMutationVariables = Exact<{
    id: Scalars['String']['input'];
}>;

export type ProcesarZenriseWebhookMutation = {
    __typename?: 'Mutation';
    rst: {
        __typename?: 'ProcesarWebhookResultado';
        ok: boolean;
        mensaje?: string | null;
    };
};

export type PutHoldOnEmailMutationVariables = Exact<{
    email: Scalars['String']['input'];
    reason?: InputMaybe<Scalars['String']['input']>;
}>;

export type PutHoldOnEmailMutation = {
    __typename?: 'Mutation';
    putHoldOnEmail?: string | null;
};

export type RecibirIpnMutationVariables = Exact<{
    content: Scalars['String']['input'];
}>;

export type RecibirIpnMutation = {
    __typename?: 'Mutation';
    testSimularIPNRecibido: boolean;
};

export type ReleaseHoldOnEmailMutationVariables = Exact<{
    email: Scalars['String']['input'];
}>;

export type ReleaseHoldOnEmailMutation = {
    __typename?: 'Mutation';
    releaseHoldOnEmail?: string | null;
};

export type StripeCrearPortalSessionMutationVariables = Exact<{
    cuenta_id: Scalars['String']['input'];
}>;

export type StripeCrearPortalSessionMutation = {
    __typename?: 'Mutation';
    stripeCrearPortalSession?: any | null;
};

export type TestRecibirTusFacturasWebhookMutationVariables = Exact<{
    content: Scalars['String']['input'];
}>;

export type TestRecibirTusFacturasWebhookMutation = {
    __typename?: 'Mutation';
    testSimularTusFacturasWebhookRecibido: boolean;
};

export type VerificarInstalacionMutationVariables = Exact<{
    cid: Scalars['String']['input'];
}>;

export type VerificarInstalacionMutation = {
    __typename?: 'Mutation';
    verificarInstalacion?: string | null;
};

export type PedirNuevoReporteZenriseMutationVariables = Exact<{
    [key: string]: never;
}>;

export type PedirNuevoReporteZenriseMutation = {
    __typename?: 'Mutation';
    pedirNuevoReporteZenrise: string;
};

export type TestCrearTrialMutationVariables = Exact<{
    dias: Scalars['Int']['input'];
}>;

export type TestCrearTrialMutation = {
    __typename?: 'Mutation';
    testCrearCuentaEnTrial?: string | null;
};

export type AnalisisTimingZenriseWebhooksAndIpnsQueryVariables = Exact<{
    [key: string]: never;
}>;

export type AnalisisTimingZenriseWebhooksAndIpnsQuery = {
    __typename?: 'Query';
    analisisTimingZenriseWebhooksAndIPNS: Array<{
        __typename?: 'TimingZenriseWebhooksAndIPNS';
        cuenta_id: string;
        nombre: string;
        fecha_ultimo_pago?: string | null;
        fecha_proximo_pago?: string | null;
        days_since_last_webhook?: number | null;
        last_webhook_id?: string | null;
        days_since_last_ipn?: number | null;
        last_ipn_id?: string | null;
        cuenta?: {
            __typename?: 'Cuenta';
            id: string;
            suscripcionActiva?: {
                __typename?: 'Suscripcion';
                id: string;
                estado: EstadoSuscripcion;
                estado_full?: string | null;
                dunning_empezado?: string | null;
                fecha_ultimo_pago?: string | null;
                fecha_proximo_pago?: string | null;
            } | null;
        } | null;
    }>;
};

export type ApiResponseQueryVariables = Exact<{
    cuenta_id: Scalars['String']['input'];
}>;

export type ApiResponseQuery = {
    __typename?: 'Query';
    apiResponse?: any | null;
};

export type BorrarNotificacionesMutationVariables = Exact<{
    input: InputBorrarNotificaciones;
}>;

export type BorrarNotificacionesMutation = {
    __typename?: 'Mutation';
    BorrarNotificaciones?: number | null;
};

export type CargarSettingsCustomerQueryVariables = Exact<{
    id: Scalars['String']['input'];
}>;

export type CargarSettingsCustomerQuery = {
    __typename?: 'Query';
    cuenta_en_subs?: {
        __typename?: 'Cuenta';
        id: string;
        nombre?: string | null;
    } | null;
    cuenta?: {
        __typename?: 'CuentaEnLegacy';
        id?: string | null;
        settings: {
            __typename?: 'Settings';
            initialDelay: number;
            delayBetween: number;
            startOnScroll: boolean;
        };
        informativaConfig: {
            __typename?: 'InformativaConfig';
            active: boolean;
            body?: string | null;
            title?: string | null;
            displayTime: number;
            position: Position;
            mobilePosition: MobilePosition;
            showTo?: ShowTargets | null;
            mobileDisabled: boolean;
            clickUrl?: string | null;
            clickEnabled?: boolean | null;
            clickOpenNewTab?: boolean | null;
            template?: string | null;
            theme?: {
                __typename?: 'Theme';
                highlightColor?: string | null;
                textColor?: string | null;
                smallTextColor?: string | null;
                backgroundColor?: string | null;
            } | null;
        };
        ultimasVentasConfig: {
            __typename?: 'UltimasVentasConfig';
            active: boolean;
            displayTime: number;
            position: Position;
            mobilePosition: MobilePosition;
            mobileSize?: MobileSize2021 | null;
            showTo?: ShowTargets | null;
            mobileDisabled: boolean;
            hideTimeAgo: boolean;
            hideTimeAgoHs: number;
            hideCliente?: boolean | null;
            hideClienteAlternative?: string | null;
            clickEnabled?: boolean | null;
            clickOpenNewTab?: boolean | null;
            template?: string | null;
            sinceDays: number;
            theme?: {
                __typename?: 'Theme';
                highlightColor?: string | null;
                textColor?: string | null;
                smallTextColor?: string | null;
                backgroundColor?: string | null;
            } | null;
        };
    } | null;
};

export type CohortSuscripcionesMonthsAliveQueryVariables = Exact<{
    [key: string]: never;
}>;

export type CohortSuscripcionesMonthsAliveQuery = {
    __typename?: 'Query';
    cohortSuscripcionesMonthsAlive?: string | null;
};

export type CuentasDesbloqueadasSinMotivoQueryVariables = Exact<{
    [key: string]: never;
}>;

export type CuentasDesbloqueadasSinMotivoQuery = {
    __typename?: 'Query';
    cuentasDesbloqueadasSinMotivo: Array<{
        __typename?: 'CuentaDesbloqueadaSinMotivo';
        id: string;
        nombre?: string | null;
    }>;
};

export type GuardarInformativaMutationVariables = Exact<{
    cuenta_id: Scalars['String']['input'];
    input: InputInformativaConfig;
}>;

export type GuardarInformativaMutation = {
    __typename?: 'Mutation';
    resultado: boolean;
};

export type GuardarSettingsCustomerMutationVariables = Exact<{
    cuenta_id: Scalars['String']['input'];
    input: InputSettings;
}>;

export type GuardarSettingsCustomerMutation = {
    __typename?: 'Mutation';
    resultado: boolean;
};

export type GuardarUltimasVentasConfigMutationVariables = Exact<{
    cuenta_id: Scalars['String']['input'];
    input: InputUltimasVentasConfig;
}>;

export type GuardarUltimasVentasConfigMutation = {
    __typename?: 'Mutation';
    resultado: boolean;
};

export type StripeLogConnectionQueryVariables = Exact<{
    cuenta_id: Scalars['String']['input'];
}>;

export type StripeLogConnectionQuery = {
    __typename?: 'Query';
    stripeLogConnection: {
        __typename?: 'StripeLogConnection';
        pageInfo: {
            __typename?: 'PageInfo';
            endCursor?: string | null;
            hasNextPage: boolean;
        };
        edges: Array<{
            __typename?: 'StripeApiLog';
            id: string;
            updated_at: any;
            created_at: any;
            url: string;
            requestBody?: string | null;
            method: string;
            user_id?: string | null;
            responseStatus: number;
            responseBody?: string | null;
        }>;
    };
};

export type StripeWebhookConnectionQueryVariables = Exact<{
    cuenta_id: Scalars['String']['input'];
}>;

export type StripeWebhookConnectionQuery = {
    __typename?: 'Query';
    stripeWebhookConnection: {
        __typename?: 'StripeWebhookConnection';
        pageInfo: {
            __typename?: 'PageInfo';
            endCursor?: string | null;
            hasNextPage: boolean;
        };
        edges: Array<{
            __typename?: 'StripeWebhook';
            id: string;
            type: string;
            estado: EstadoWebhook;
            resultado_ok?: boolean | null;
            resultado_mensaje?: string | null;
            created_at: any;
        }>;
    };
};

export type TasksConnectionQueryVariables = Exact<{
    filters?: InputMaybe<TasksConnectionFilters>;
    pagination: CursorPaginationParams;
}>;

export type TasksConnectionQuery = {
    __typename?: 'Query';
    tasksConnection: {
        __typename?: 'TaskConnection';
        pageInfo: {
            __typename?: 'PageInfo';
            startCursor?: string | null;
            endCursor?: string | null;
            hasNextPage: boolean;
        };
        edges: Array<{
            __typename?: 'Task';
            id: string;
            cuenta_id: string;
            created_at?: string | null;
            completed_at?: string | null;
            failed_at?: string | null;
            nombre: string;
            idem_key: string;
            resultado_ok?: boolean | null;
            parametros?: string | null;
            error?: string | null;
            aws_log_group_name?: string | null;
            aws_log_stream_name?: string | null;
            cuenta?: {
                __typename?: 'Cuenta';
                id: string;
                nombre?: string | null;
                suscripcionActiva?: {
                    __typename?: 'Suscripcion';
                    id: string;
                    dunning_empezado?: string | null;
                    estado: EstadoSuscripcion;
                    fecha_ultimo_pago?: string | null;
                    fecha_proximo_pago?: string | null;
                } | null;
            } | null;
        }>;
    };
};

export type TestUserEnSubsMutationMutationVariables = Exact<{
    [key: string]: never;
}>;

export type TestUserEnSubsMutationMutation = {
    __typename?: 'Mutation';
    testUserEnSubsMutation?: string | null;
};

export type TodayQueryVariables = Exact<{ [key: string]: never }>;

export type TodayQuery = { __typename?: 'Query'; now: any };

export const CuentaNombreFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'cuentaNombre' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'Cuenta' },
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'nombre' } },
                ],
            },
        },
    ],
} as unknown as DocumentNode<CuentaNombreFragment, unknown>;
export const GetProblemasDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'getProblemas' },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'problemasCuentas' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GetProblemasQuery, GetProblemasQueryVariables>;
export const GetEstadisticasAdminDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'getEstadisticasAdmin' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'dias' },
                    },
                    type: {
                        kind: 'NamedType',
                        name: { kind: 'Name', value: 'Int' },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'estadisticasAdmin' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'dias' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'dias' },
                                },
                            },
                        ],
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    GetEstadisticasAdminQuery,
    GetEstadisticasAdminQueryVariables
>;
export const GetEstadisticasAdminPorSituacionDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'getEstadisticasAdminPorSituacion' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'args' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'StatsArgs' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: {
                            kind: 'Name',
                            value: 'estadisticasAdminPorSituacion',
                        },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'args' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'args' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'fecha_desde',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'fecha_hasta',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'dias' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'activas' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'trial' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'otras' },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    GetEstadisticasAdminPorSituacionQuery,
    GetEstadisticasAdminPorSituacionQueryVariables
>;
export const GetDatosAccesoDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'getDatosAcceso' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'stUserId' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'usuario' },
                        name: { kind: 'Name', value: 'usuarioByST' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'stUserId' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'stUserId' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'email' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'stUserId' },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'password_temporal',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'password_temporal_pendiente_resetear',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GetDatosAccesoQuery, GetDatosAccesoQueryVariables>;
export const CambiarClaveDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'cambiarClave' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'old_password' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'new_password' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cambiarClave' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'old_password' },
                                value: {
                                    kind: 'Variable',
                                    name: {
                                        kind: 'Name',
                                        value: 'old_password',
                                    },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'new_password' },
                                value: {
                                    kind: 'Variable',
                                    name: {
                                        kind: 'Name',
                                        value: 'new_password',
                                    },
                                },
                            },
                        ],
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    CambiarClaveMutation,
    CambiarClaveMutationVariables
>;
export const CambiarEmailDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'cambiarEmail' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'new_email' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cambiarEmail' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'new_email' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'new_email' },
                                },
                            },
                        ],
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    CambiarEmailMutation,
    CambiarEmailMutationVariables
>;
export const BuscarCuentasAdminDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'buscarCuentasAdmin' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'params' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: {
                                kind: 'Name',
                                value: 'BuscarCuentasQueryParams',
                            },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'buscarCuentas' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'params' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'params' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'nombre' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'pais' },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'email_pagos',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'email_desde_legacy',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'legacy_id' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'tipo_doc' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'documento' },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'razon_social',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'condicion_ante_iva',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'domicilio' },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'tn_store_id',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'tienda_url' },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    BuscarCuentasAdminQuery,
    BuscarCuentasAdminQueryVariables
>;
export const GetAuditLogsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'getAuditLogs' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'params' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'GenericInputParams' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'auditLogs' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'params' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'params' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'cuenta_id' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'key' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'comments' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'user_id' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'es_admin' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'es_auto' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'created_at' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'usuario' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'email',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'isSuperAdmin',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GetAuditLogsQuery, GetAuditLogsQueryVariables>;
export const GetAuditLogsPorCuentaDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'getAuditLogsPorCuenta' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'cuenta_id' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cuenta' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'cuenta_id' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'auditLogs' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'key',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'comments',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'user_id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'es_admin',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'es_auto',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'created_at',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'usuario',
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'id',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'email',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'isSuperAdmin',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    GetAuditLogsPorCuentaQuery,
    GetAuditLogsPorCuentaQueryVariables
>;
export const GetAuditLogWithDataDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'getAuditLogWithData' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'auditLog' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'id' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'cuenta_id' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'key' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'comments' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'user_id' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'es_admin' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'es_auto' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'created_at' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'usuario' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'email',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'isSuperAdmin',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    GetAuditLogWithDataQuery,
    GetAuditLogWithDataQueryVariables
>;
export const GetBloqueosDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'getBloqueos' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'incluirViejos' },
                    },
                    type: {
                        kind: 'NamedType',
                        name: { kind: 'Name', value: 'Boolean' },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'filtros' },
                    },
                    type: {
                        kind: 'NamedType',
                        name: {
                            kind: 'Name',
                            value: 'BloqueosConnectionParams',
                        },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'pagination' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: {
                                kind: 'Name',
                                value: 'CursorPaginationParams',
                            },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'bloqueosConnection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'incluirViejos' },
                                value: {
                                    kind: 'Variable',
                                    name: {
                                        kind: 'Name',
                                        value: 'incluirViejos',
                                    },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'filtros' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'filtros' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'pagination' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'pagination' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'pageInfo' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'hasNextPage',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'endCursor',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'edges' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'node',
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'id',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'cuenta_id',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'motivo',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'ultimo',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'bloqueada_event_id',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'bloqueada_mail_id',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'desbloqueada_event_id',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'desbloqueada_mail_id',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'fecha_bloqueo',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'fecha_desbloqueo',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'cuenta',
                                                            },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'id',
                                                                        },
                                                                    },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'nombre',
                                                                        },
                                                                    },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'tn_store_id',
                                                                        },
                                                                    },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'legacy_id',
                                                                        },
                                                                    },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'bloqueada',
                                                                        },
                                                                    },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'bloqueo_fecha',
                                                                        },
                                                                    },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'bloqueo_razon',
                                                                        },
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GetBloqueosQuery, GetBloqueosQueryVariables>;
export const GetCobrosPorCuentaDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'getCobrosPorCuenta' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cuenta' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'id' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'nombre' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'tipo_doc' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'documento' },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'condicion_ante_iva',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'razon_social',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'domicilio' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'cobros' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'monto',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'fecha_cobro',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'devuelto',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'devuelto_fecha',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'cuenta_id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'tipo_factura',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'pasarela',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'pasarela_id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'facturado_en_afip',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'facturado_manual',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'numero_factura_propia',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'pdf_factura_archivado',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'pdf',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'fecha_facturado_afip',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'fecha_marcada_para_facturar',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'en_proceso_facturar_en_afip_empezado',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'en_proceso_facturar_en_afip_estado',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'en_proceso_facturar_en_afip_error',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'en_proceso_facturar_en_afip_nota_credito_empezado',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'en_proceso_facturar_en_afip_nota_credito_estado',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'en_proceso_facturar_en_afip_nota_credito_error',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'numero_nota_credito_propia',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'pdf_nota_credito',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'fecha_nota_credito_emitida_afip',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    GetCobrosPorCuentaQuery,
    GetCobrosPorCuentaQueryVariables
>;
export const GetContratacionesAdminDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'getContratacionesAdmin' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'filters' },
                    },
                    type: {
                        kind: 'NamedType',
                        name: { kind: 'Name', value: 'ContratacionesFilters' },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'params' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: {
                                kind: 'Name',
                                value: 'CursorPaginationParams',
                            },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'connection' },
                        name: {
                            kind: 'Name',
                            value: 'contratacionesConnection',
                        },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'filters' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'filters' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'pagination' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'params' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'pageInfo' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'hasNextPage',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'endCursor',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'edges' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'estado',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'plan_id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'updated_at',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'created_at',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'fsm_error',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'cuenta_id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'ultima',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'error_al_crear_suscriptor',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'plan',
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'id',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'nombre_publico',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'nombre_privado',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'precio_con_iva',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'zenrise_id',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'cuenta',
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'id',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'nombre',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'legacy_id',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'email_desde_legacy',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'tn_store_id',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'tienda_url',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'trial',
                                                            },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'id',
                                                                        },
                                                                    },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'estado',
                                                                        },
                                                                    },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'fecha_fin',
                                                                        },
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'suscripcionActiva',
                                                            },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'id',
                                                                        },
                                                                    },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'estado',
                                                                        },
                                                                    },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'pasarela',
                                                                        },
                                                                    },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'pasarela_id',
                                                                        },
                                                                    },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'plan_id',
                                                                        },
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    GetContratacionesAdminQuery,
    GetContratacionesAdminQueryVariables
>;
export const GetContratacionActivaDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'getContratacionActiva' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'cuenta_id' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cuenta' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'cuenta_id' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'contratacionActiva',
                                    },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'estado',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'plan',
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'id',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'precio_con_iva',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    GetContratacionActivaQuery,
    GetContratacionActivaQueryVariables
>;
export const GetCuentasDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'getCuentas' },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cuentas' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'params' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: {
                                                kind: 'Name',
                                                value: 'firsts',
                                            },
                                            value: {
                                                kind: 'IntValue',
                                                value: '10',
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'nombre' },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'email_pagos',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'email_desde_legacy',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'tn_store_id',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'tienda_url' },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GetCuentasQuery, GetCuentasQueryVariables>;
export const GetCuentasAdminDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'getCuentasAdmin' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'params' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'CuentasQueryParams' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cuentas' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'params' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'params' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'nombre' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'pais' },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'email_pagos',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'email_desde_legacy',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'legacy_id' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'tipo_doc' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'documento' },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'razon_social',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'condicion_ante_iva',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'domicilio' },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'tn_store_id',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'tienda_url' },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    GetCuentasAdminQuery,
    GetCuentasAdminQueryVariables
>;
export const ReporteCuentasConPagosConProblemasDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'reporteCuentasConPagosConProblemas' },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: {
                            kind: 'Name',
                            value: 'reporteCuentasConPagosConProblemas',
                        },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'cuenta_id' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'nombre' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'pais' },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'email_desde_legacy',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'fecha_emision',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'fecha_error',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'mensaje_error',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'invoice_id' },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    ReporteCuentasConPagosConProblemasQuery,
    ReporteCuentasConPagosConProblemasQueryVariables
>;
export const GetCuentaDatosFacturacionDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'getCuentaDatosFacturacion' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cuenta' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'id' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'tipo_doc' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'documento' },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'razon_social',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'condicion_ante_iva',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'domicilio' },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    GetCuentaDatosFacturacionQuery,
    GetCuentaDatosFacturacionQueryVariables
>;
export const GetDashboardAdminDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'getDashboardAdmin' },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dashboardSuscripciones' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'mensual' },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'mensual_con_iva',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'ClientesActivos',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'TicketPromedio',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: {
                            kind: 'Name',
                            value: 'estadoCuentasEnSuscripciones',
                        },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'total' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'bloqueadas' },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'no_bloqueadas',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'suscripcion_activa',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'en_dunning' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'trial' },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'en_migracion',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    GetDashboardAdminQuery,
    GetDashboardAdminQueryVariables
>;
export const GetDatosDesdeTnDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'getDatosDesdeTN' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cuenta' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'id' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'datos_desde_tn',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'datos_desde_tn_traidos',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'datos_desde_tn_traidos_error',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'datos_desde_tn_traidos_error_fecha',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'datos_desde_tn_traidos_error_code',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'datos_desde_tn_traidos_error_desc',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'datos_desde_tn_traidos_error_resp',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    GetDatosDesdeTnQuery,
    GetDatosDesdeTnQueryVariables
>;
export const GetCustomerEstadisticasDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'getCustomerEstadisticas' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'cid' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'args' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'StatsArgs' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cuenta' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'cid' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'stats' },
                                    arguments: [
                                        {
                                            kind: 'Argument',
                                            name: {
                                                kind: 'Name',
                                                value: 'args',
                                            },
                                            value: {
                                                kind: 'Variable',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'args',
                                                },
                                            },
                                        },
                                    ],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'fecha_desde',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'fecha_hasta',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'dias',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'clicks',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'notificaciones',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'pageviews',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    GetCustomerEstadisticasQuery,
    GetCustomerEstadisticasQueryVariables
>;
export const GetCustomerEstadisticasNuevoDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'getCustomerEstadisticasNuevo' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'cid' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cuenta' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'cid' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'stats' },
                                    arguments: [
                                        {
                                            kind: 'Argument',
                                            name: {
                                                kind: 'Name',
                                                value: 'args',
                                            },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: {
                                                            kind: 'Name',
                                                            value: 'fecha_desde',
                                                        },
                                                        value: {
                                                            kind: 'StringValue',
                                                            value: '2024-10-10',
                                                            block: false,
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'fecha_desde',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'fecha_hasta',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'dias',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'clicks',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'pageviews',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'notificaciones',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    GetCustomerEstadisticasNuevoQuery,
    GetCustomerEstadisticasNuevoQueryVariables
>;
export const GetEventsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'getEvents' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'filters' },
                    },
                    type: {
                        kind: 'NamedType',
                        name: { kind: 'Name', value: 'EventsFilters' },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'params' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: {
                                kind: 'Name',
                                value: 'CursorPaginationParams',
                            },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'connection' },
                        name: { kind: 'Name', value: 'eventsConnection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'filters' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'filters' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'pagination' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'params' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'edges' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'cuenta_id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'event_type',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'created_at',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'source',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'data',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'pageInfo' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'hasNextPage',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'startCursor',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'endCursor',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GetEventsQuery, GetEventsQueryVariables>;
export const FacturasPendientesFacturarEnAfipDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'facturasPendientesFacturarEnAfip' },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: {
                            kind: 'Name',
                            value: 'facturasPendientesFacturarEnAfip',
                        },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'monto' },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'fecha_cobro',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'cuenta_id' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'pasarela' },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'pasarela_id',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'devuelto' },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'devuelto_fecha',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'numero_factura_propia',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'numero_nota_credito_propia',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'en_proceso_facturar_en_afip_empezado',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'en_proceso_facturar_en_afip_estado',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'en_proceso_facturar_en_afip_error',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'fecha_facturado_afip',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'cuenta' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'nombre',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'razon_social',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'domicilio',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'documento',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'condicion_ante_iva',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'tipo_doc',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'pais',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'suscripcionActiva',
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'id',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'estado',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    FacturasPendientesFacturarEnAfipQuery,
    FacturasPendientesFacturarEnAfipQueryVariables
>;
export const GetInfoCuentaDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'getInfoCuenta' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cuenta' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'id' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'nombre' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'pais' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'udn' },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'email_pagos',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'bloqueada' },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'bloqueo_fecha',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'bloqueo_razon',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'email_desde_legacy',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'tn_store_id',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'tienda_url' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'legacy_id' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'tipo_doc' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'documento' },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'razon_social',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'condicion_ante_iva',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'domicilio' },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'stripe_customer_id',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'stripe_habilitado',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'bonificacion_fecha_inicio',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'bonificacion_motivo',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'migracion' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'analisis_resultado',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'analisis_problema',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'analisis_ult_pago',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'analisis_ult_pago_dias',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'analisis_prox_pago',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'estado',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'legacy_estado',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'legacy_estado_tn',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'legacy_plan',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'json_importacion',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'contratacionActiva',
                                    },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'cuenta_id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'estado',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'zenrise_id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'plan_id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'fsm_error',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'plan',
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'id',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'nombre_publico',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'nombre_privado',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'precio',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'precio_con_iva',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'zenrise_id',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'suscripcionActiva',
                                    },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'estado',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'estado_full',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'dunning_empezado',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'source_active',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'source_link',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'pasarela',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'pasarela_id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'fecha_ultimo_pago',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'fecha_proximo_pago',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'fsm_error',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'udn',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'stripe_price_id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'stripe_price_amount',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'stripe_price_currency',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'stripe_product_id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'stripe_product_name',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'stripe_plan',
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'id',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'currency',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'product_id',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'product_name',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'unit_amount',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'limit',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'plan',
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'id',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'precio',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'precio_con_iva',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'nombre_publico',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'nombre_privado',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'limite',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'mostrar_en_selector',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'valido_desde',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'valido_hasta',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'zenrise_id',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'uso',
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'id',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'dias',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'proyectado',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'notificaciones',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'trial' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'fecha_creacion',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'fecha_fin',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'estado',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GetInfoCuentaQuery, GetInfoCuentaQueryVariables>;
export const GetInfoParaContratarDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'getInfoParaContratar' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'cuenta_id' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cuenta' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'cuenta_id' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'udn' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'pais' },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'stripe_habilitado',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    GetInfoParaContratarQuery,
    GetInfoParaContratarQueryVariables
>;
export const GetInfoParaContratarStripeDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'getInfoParaContratarStripe' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'cuenta_id' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cuenta' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'cuenta_id' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'udn' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'pais' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'uso' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'dias',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'notificaciones',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'proyectado',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'stripePrices' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'product_id' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'limit' },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'product_name',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'unit_amount',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'currency' },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    GetInfoParaContratarStripeQuery,
    GetInfoParaContratarStripeQueryVariables
>;
export const GetInfoParaPantallaFacturacionDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'getInfoParaPantallaFacturacion' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'cuenta_id' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cuenta' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'cuenta_id' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'nombre' },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'email_pagos',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'bloqueada' },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'bloqueo_fecha',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'bloqueo_razon',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'bonificacion_fecha_inicio',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'bonificacion_motivo',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'email_desde_legacy',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'tn_store_id',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'tienda_url' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'legacy_id' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'tipo_doc' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'documento' },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'razon_social',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'condicion_ante_iva',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'domicilio' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'pais' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'udn' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'migracion' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'analisis_resultado',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'analisis_problema',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'analisis_ult_pago',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'analisis_ult_pago_dias',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'analisis_prox_pago',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'estado',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'legacy_estado',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'legacy_estado_tn',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'legacy_plan',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'json_importacion',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'contratacionActiva',
                                    },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'cuenta_id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'estado',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'zenrise_id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'plan_id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'plan',
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'id',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'nombre_publico',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'nombre_privado',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'precio',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'precio_con_iva',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'zenrise_id',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'uso' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'notificaciones',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'proyectado',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'dias',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'suscripcionActiva',
                                    },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'udn',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'estado',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'estado_full',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'dunning_empezado',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'invoice_zenrise_impaga',
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'zenrise_id',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'ultimo_error',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'source_active',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'source_link',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'pasarela',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'pasarela_id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'fecha_proximo_pago',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'stripe_price_id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'stripe_price_amount',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'stripe_price_currency',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'stripe_product_id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'stripe_product_name',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'stripe_plan',
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'id',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'currency',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'product_id',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'product_name',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'unit_amount',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'limit',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'plan',
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'id',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'nombre_publico',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'precio',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'precio_con_iva',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'limite',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'uso',
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'id',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'notificaciones',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'proyectado',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'dias',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'trial' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'fecha_creacion',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'fecha_fin',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'estado',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'stripe_customer_id',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'stripe_habilitado',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'planPorDefecto' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'nombre_publico',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'precio_con_iva',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'precio' },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'getPlanesParaCuenta' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'cuenta_id' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'cuenta_id' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'nombre_publico',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'nombre_privado',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'precio' },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'precio_con_iva',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'por_defecto',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'zenrise_id' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'limite' },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'valido_desde',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'valido_hasta',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'mostrar_en_selector',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    GetInfoParaPantallaFacturacionQuery,
    GetInfoParaPantallaFacturacionQueryVariables
>;
export const GetInfoSuscripcionDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'getInfoSuscripcion' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cuenta' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'id' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'nombre' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'pais' },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'email_pagos',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'bloqueada' },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'bloqueo_fecha',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'bloqueo_razon',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'email_desde_legacy',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'tn_store_id',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'tienda_url' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'legacy_id' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'tipo_doc' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'documento' },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'razon_social',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'condicion_ante_iva',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'domicilio' },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'suscripcionActiva',
                                    },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'estado',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'estado_full',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'dunning_empezado',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'invoice_zenrise_impaga',
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'zenrise_id',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'ultimo_error',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'source_active',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'source_link',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'pasarela',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'pasarela_id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'fecha_ultimo_pago',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'fecha_proximo_pago',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'fsm_error',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'plan_id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'pasarela_plan_id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'stripe_price_id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'stripe_price_amount',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'stripe_price_currency',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'stripe_product_id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'stripe_product_name',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'stripe_plan',
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'id',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'currency',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'product_id',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'product_name',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'unit_amount',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'limit',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'plan',
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'id',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'precio',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'precio_con_iva',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'nombre_publico',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'nombre_privado',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'limite',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'mostrar_en_selector',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'valido_desde',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'valido_hasta',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'zenrise_id',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'nuevo_plan_id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'nuevo_plan_pasarela_id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'nuevo_plan',
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'id',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'precio',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'precio_con_iva',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'nombre_publico',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'nombre_privado',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'limite',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'mostrar_en_selector',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'valido_desde',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'valido_hasta',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'zenrise_id',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'uso',
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'id',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'dias',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'proyectado',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'notificaciones',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    GetInfoSuscripcionQuery,
    GetInfoSuscripcionQueryVariables
>;
export const GetInfoSuscripcionesDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'getInfoSuscripciones' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cuenta' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'id' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'nombre' },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'suscripciones',
                                    },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'estado',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'pasarela',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'pasarela_id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'fsm_error',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'fecha_creacion',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'fecha_ultimo_pago',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'fecha_proximo_pago',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'stripe_price_id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'stripe_price_amount',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'stripe_price_currency',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'stripe_product_id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'stripe_product_name',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'plan',
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'id',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'precio',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'precio_con_iva',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'nombre_publico',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'nombre_privado',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'limite',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'mostrar_en_selector',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'valido_desde',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'valido_hasta',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    GetInfoSuscripcionesQuery,
    GetInfoSuscripcionesQueryVariables
>;
export const GetInfoSuscripcionesEnZenriseDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'getInfoSuscripcionesEnZenrise' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'cuenta_id' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: {
                            kind: 'Name',
                            value: 'zenriseSuscripcionesInfo',
                        },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'cuenta_id' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'cuenta_id' },
                                },
                            },
                        ],
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    GetInfoSuscripcionesEnZenriseQuery,
    GetInfoSuscripcionesEnZenriseQueryVariables
>;
export const GetInstalacionTnDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'getInstalacionTN' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'cid' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'instalacionEnTn' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'cid' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'cid' },
                                },
                            },
                        ],
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    GetInstalacionTnQuery,
    GetInstalacionTnQueryVariables
>;
export const GetInvoicesAdminDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'getInvoicesAdmin' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'filters' },
                    },
                    type: {
                        kind: 'NamedType',
                        name: {
                            kind: 'Name',
                            value: 'InvoiceZenRiseConnectionFilters',
                        },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'pagination' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: {
                                kind: 'Name',
                                value: 'CursorPaginationParams',
                            },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'connection' },
                        name: {
                            kind: 'Name',
                            value: 'invoicesZenRiseConnection',
                        },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'filters' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'filters' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'pagination' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'pagination' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'pageInfo' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'hasNextPage',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'endCursor',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'edges' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'node',
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'id',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'zenrise_id',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'cuenta_id',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'cuenta',
                                                            },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'id',
                                                                        },
                                                                    },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'nombre',
                                                                        },
                                                                    },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'tipo_doc',
                                                                        },
                                                                    },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'documento',
                                                                        },
                                                                    },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'condicion_ante_iva',
                                                                        },
                                                                    },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'razon_social',
                                                                        },
                                                                    },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'domicilio',
                                                                        },
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'fecha_emision',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'fecha_pago',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'estado_zenrise',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'monto',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'metodo_pago',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'fecha_estimado_acreditacion',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'facturada_manual',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'numero_factura_propia',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'facturada_manual_ruta',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'created_at',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'updated_at',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'data',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'errores_zr',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    GetInvoicesAdminQuery,
    GetInvoicesAdminQueryVariables
>;
export const GetInvoiceAdminDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'getInvoiceAdmin' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'invoiceZenRise' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'id' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'zenrise_id' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'cuenta_id' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'cuenta' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'nombre',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'tipo_doc',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'documento',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'condicion_ante_iva',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'razon_social',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'domicilio',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'fecha_emision',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'fecha_pago' },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'estado_zenrise',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'monto' },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'metodo_pago',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'fecha_estimado_acreditacion',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'facturada_manual',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'numero_factura_propia',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'facturada_manual_ruta',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'created_at' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'updated_at' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'errores_zr' },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    GetInvoiceAdminQuery,
    GetInvoiceAdminQueryVariables
>;
export const GetIpnConnectionDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'getIPNConnection' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'filters' },
                    },
                    type: {
                        kind: 'NamedType',
                        name: { kind: 'Name', value: 'IpnConnectionFilters' },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'pagination' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: {
                                kind: 'Name',
                                value: 'CursorPaginationParams',
                            },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ipnConnection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'filters' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'filters' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'pagination' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'pagination' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'pageInfo' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'hasNextPage',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'endCursor',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'edges' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'node',
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'id',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'body',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'externalReference',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'estado',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'invoiceId',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'resultado_mensaje',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'resultado_ok',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'transactionId',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'created_at',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'updated_at',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'invoice',
                                                            },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'id',
                                                                        },
                                                                    },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'estado_zenrise',
                                                                        },
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'cuenta',
                                                            },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'id',
                                                                        },
                                                                    },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'nombre',
                                                                        },
                                                                    },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'suscripcionActiva',
                                                                        },
                                                                        selectionSet:
                                                                            {
                                                                                kind: 'SelectionSet',
                                                                                selections:
                                                                                    [
                                                                                        {
                                                                                            kind: 'Field',
                                                                                            name: {
                                                                                                kind: 'Name',
                                                                                                value: 'id',
                                                                                            },
                                                                                        },
                                                                                        {
                                                                                            kind: 'Field',
                                                                                            name: {
                                                                                                kind: 'Name',
                                                                                                value: 'dunning_empezado',
                                                                                            },
                                                                                        },
                                                                                        {
                                                                                            kind: 'Field',
                                                                                            name: {
                                                                                                kind: 'Name',
                                                                                                value: 'fecha_ultimo_pago',
                                                                                            },
                                                                                        },
                                                                                        {
                                                                                            kind: 'Field',
                                                                                            name: {
                                                                                                kind: 'Name',
                                                                                                value: 'fecha_proximo_pago',
                                                                                            },
                                                                                        },
                                                                                        {
                                                                                            kind: 'Field',
                                                                                            name: {
                                                                                                kind: 'Name',
                                                                                                value: 'estado',
                                                                                            },
                                                                                        },
                                                                                    ],
                                                                            },
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    GetIpnConnectionQuery,
    GetIpnConnectionQueryVariables
>;
export const IsEmailOnHoldDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'isEmailOnHold' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'email' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isEmailOnHold' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'email' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'email' },
                                },
                            },
                        ],
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<IsEmailOnHoldQuery, IsEmailOnHoldQueryVariables>;
export const IsGoblalHoldActivatedDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'isGoblalHoldActivated' },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isGoblalHoldActivated' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    IsGoblalHoldActivatedQuery,
    IsGoblalHoldActivatedQueryVariables
>;
export const GetLinkParaDescargarFacturaDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'getLinkParaDescargarFactura' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'cobro_id' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: {
                            kind: 'Name',
                            value: 'getLinkParaDescargarFactura',
                        },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'cobro_id' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'cobro_id' },
                                },
                            },
                        ],
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    GetLinkParaDescargarFacturaQuery,
    GetLinkParaDescargarFacturaQueryVariables
>;
export const GetLinkParaDescargarNotaCreditoDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'getLinkParaDescargarNotaCredito' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'cobro_id' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: {
                            kind: 'Name',
                            value: 'getLinkParaDescargarNotaCredito',
                        },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'cobro_id' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'cobro_id' },
                                },
                            },
                        ],
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    GetLinkParaDescargarNotaCreditoQuery,
    GetLinkParaDescargarNotaCreditoQueryVariables
>;
export const GetMailsOutboxDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'getMailsOutbox' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'filters' },
                    },
                    type: {
                        kind: 'NamedType',
                        name: { kind: 'Name', value: 'MailOutboxFilters' },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'params' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: {
                                kind: 'Name',
                                value: 'CursorPaginationParams',
                            },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'connection' },
                        name: { kind: 'Name', value: 'mailOutboxConnection2' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'filters' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'filters' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'pagination' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'params' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'edges' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'cuenta_id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'sendgrid_message_id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'to',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'template_id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'delivered',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'opened',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'bounced',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'bounced_classification',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'bounced_reason',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'dropped',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'dropped_reason',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'send_at',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'created_at',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'pageInfo' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'hasNextPage',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'endCursor',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GetMailsOutboxQuery, GetMailsOutboxQueryVariables>;
export const GetMigracionesAdminDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'getMigracionesAdmin' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'params' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: {
                                kind: 'Name',
                                value: 'MigracionesQueryParams',
                            },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'migraciones' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'params' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'params' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'estado' },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'suscripcion_id',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'tn_store_id',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'legacy_id' },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'creada_en_legacy',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'cuenta_id' },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'analisis_fecha',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'analisis_resultado',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'analisis_problema',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'analisis_comentario',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'analisis_ult_pago',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'analisis_prox_pago',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'analisis_ult_pago_dias',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'cuenta' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'nombre',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'legacy_id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'email_pagos',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'bloqueada',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'bloqueo_fecha',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'sparkline',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'pais',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'trial',
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'id',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'estado',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'fecha_fin',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'suscripcionActiva',
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'id',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'estado',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'fecha_proximo_pago',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'uso',
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'id',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'notificaciones',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'proyectado',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'dias',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'roles',
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'id',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'rolNombre',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'usuario',
                                                            },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'id',
                                                                        },
                                                                    },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'email',
                                                                        },
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'legacy_estado',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'legacy_estado_tn',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'legacy_plan',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    GetMigracionesAdminQuery,
    GetMigracionesAdminQueryVariables
>;
export const CobrosPendientesDeNotaCreditoDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'cobrosPendientesDeNotaCredito' },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: {
                            kind: 'Name',
                            value: 'cobrosPendientesDeNotaCredito',
                        },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'monto' },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'fecha_cobro',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'cuenta_id' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'pasarela' },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'pasarela_id',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'devuelto' },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'devuelto_fecha',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'numero_factura_propia',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'numero_nota_credito_propia',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'en_proceso_facturar_en_afip_nota_credito_empezado',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'en_proceso_facturar_en_afip_nota_credito_estado',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'en_proceso_facturar_en_afip_nota_credito_error',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'fecha_facturado_afip',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'cuenta' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'nombre',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'razon_social',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'domicilio',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'documento',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'condicion_ante_iva',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'tipo_doc',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'pais',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'suscripcionActiva',
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'id',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'estado',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    CobrosPendientesDeNotaCreditoQuery,
    CobrosPendientesDeNotaCreditoQueryVariables
>;
export const GetPlanesAdminDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'getPlanesAdmin' },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'planes' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'nombre_publico',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'nombre_privado',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'precio' },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'precio_con_iva',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'por_defecto',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'zenrise_id' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'limite' },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'valido_desde',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'valido_hasta',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'mostrar_en_selector',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'cuentas_activas',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GetPlanesAdminQuery, GetPlanesAdminQueryVariables>;
export const GetPlanesStripeAdminDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'getPlanesStripeAdmin' },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'stripePrices' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'product_id' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'limit' },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'product_name',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'unit_amount',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'currency' },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    GetPlanesStripeAdminQuery,
    GetPlanesStripeAdminQueryVariables
>;
export const GetPlanDetallesDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'getPlanDetalles' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'plan' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'id' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'nombre_publico',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'nombre_privado',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'precio' },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'precio_con_iva',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'por_defecto',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'zenrise_id' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'limite' },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'valido_desde',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'valido_hasta',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'mostrar_en_selector',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    GetPlanDetallesQuery,
    GetPlanDetallesQueryVariables
>;
export const GetProcesosDiariosConnectionDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'getProcesosDiariosConnection' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'filters' },
                    },
                    type: {
                        kind: 'NamedType',
                        name: {
                            kind: 'Name',
                            value: 'ProcesosDiariosConnectionFilters',
                        },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'pagination' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: {
                                kind: 'Name',
                                value: 'CursorPaginationParams',
                            },
                        },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'incluirCuenta' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'Boolean' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'connection' },
                        name: {
                            kind: 'Name',
                            value: 'procesosDiariosConnection',
                        },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'filters' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'filters' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'pagination' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'pagination' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'pageInfo' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'endCursor',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'hasNextPage',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'edges' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'cuenta_id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'proceso',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'fecha',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'resultado_ok',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'error',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'cuenta',
                                                },
                                                directives: [
                                                    {
                                                        kind: 'Directive',
                                                        name: {
                                                            kind: 'Name',
                                                            value: 'include',
                                                        },
                                                        arguments: [
                                                            {
                                                                kind: 'Argument',
                                                                name: {
                                                                    kind: 'Name',
                                                                    value: 'if',
                                                                },
                                                                value: {
                                                                    kind: 'Variable',
                                                                    name: {
                                                                        kind: 'Name',
                                                                        value: 'incluirCuenta',
                                                                    },
                                                                },
                                                            },
                                                        ],
                                                    },
                                                ],
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'id',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'nombre',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    GetProcesosDiariosConnectionQuery,
    GetProcesosDiariosConnectionQueryVariables
>;
export const GetReportesSuscripcionesZenriseDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'getReportesSuscripcionesZenrise' },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: {
                            kind: 'Name',
                            value: 'reportesSuscripcionesZenrise',
                        },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'fecha' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'archivo' },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    GetReportesSuscripcionesZenriseQuery,
    GetReportesSuscripcionesZenriseQueryVariables
>;
export const GetReporteCobrosPendientesFacturarDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'getReporteCobrosPendientesFacturar' },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: {
                            kind: 'Name',
                            value: 'reporteCobrosPendientesFacturar',
                        },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'marcado_para_facturar',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'ya_facturado_este_mes',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'CobrosPendientes',
                                    },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'monto',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'fecha_cobro',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'devuelto',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'cuenta_id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'pasarela',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'pasarela_id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'numero_factura_propia',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'fecha_marcada_para_facturar',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'cuenta',
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'id',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'nombre',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'documento',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'razon_social',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'domicilio',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'condicion_ante_iva',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'tipo_doc',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'pais',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'suscripcionActiva',
                                                            },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'id',
                                                                        },
                                                                    },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'estado',
                                                                        },
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    GetReporteCobrosPendientesFacturarQuery,
    GetReporteCobrosPendientesFacturarQueryVariables
>;
export const GetReporteCuentasDunningZenriseDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'getReporteCuentasDunningZenrise' },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: {
                            kind: 'Name',
                            value: 'reporteCuentasDunningZenrise',
                        },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'cuenta_id' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'udn' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'nombre' },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'email_desde_legacy',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'bloqueada' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'pais' },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'fecha_proximo_pago',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'fecha_emision',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'estado_zenrise',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'intentos' },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'fecha_ultimo_error',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'dunning_empezado',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'mensaje_ultimo_error',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'errores_zr' },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'datos_desde_tn_traidos',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'datos_desde_tn_traidos_error_code',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'datos_desde_tn_traidos_error_desc',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'datos_desde_tn_traidos_error_fecha',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'last_task_id',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'last_task_nombre',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'last_task_created_at',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'last_task_resultado_ok',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dunningPreview' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'dunning_empezado',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'cuenta_id' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'cuenta' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'nombre',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'pais',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'dunning_empezado',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'task' },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    GetReporteCuentasDunningZenriseQuery,
    GetReporteCuentasDunningZenriseQueryVariables
>;
export const GetReporteFacturasDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'getReporteFacturas' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'mes' },
                    },
                    type: {
                        kind: 'NamedType',
                        name: { kind: 'Name', value: 'String' },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reporteFacturas' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'mes' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'mes' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'Facturas' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'monto',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'fecha_cobro',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'cuenta_id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'pasarela',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'pasarela_id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'numero_factura_propia',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'tipo_factura',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'pdf',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'pdf_factura_archivado',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'fecha_facturado_afip',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'numero_nota_credito_propia',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'pdf_nota_credito',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'fecha_nota_credito_emitida_afip',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'devuelto',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'cuenta',
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'id',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'nombre',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'documento',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'condicion_ante_iva',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'tipo_doc',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'razon_social',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'domicilio',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'pais',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'suscripcionActiva',
                                                            },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'id',
                                                                        },
                                                                    },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'estado',
                                                                        },
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    GetReporteFacturasQuery,
    GetReporteFacturasQueryVariables
>;
export const GetReporteSuscripcionesZenriseDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'getReporteSuscripcionesZenrise' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'refrescarLogica' },
                    },
                    type: {
                        kind: 'NamedType',
                        name: { kind: 'Name', value: 'Boolean' },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: {
                            kind: 'Name',
                            value: 'reporteSuscripcionesZenrise',
                        },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'id' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: {
                                    kind: 'Name',
                                    value: 'refrescarLogica',
                                },
                                value: {
                                    kind: 'Variable',
                                    name: {
                                        kind: 'Name',
                                        value: 'refrescarLogica',
                                    },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'fecha' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'archivo' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'resumen_vivas',
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'ACTIVE',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'CANCELLED',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'PAST_DUE',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'UNPAID',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'resumen_muertas',
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'ACTIVE',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'CANCELLED',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'PAST_DUE',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'UNPAID',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'cuentas',
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'cuenta_id',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'nombre',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'problemas',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'problemas',
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'nombre',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'cuentas',
                                                            },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'length',
                                                                        },
                                                                    },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'data',
                                                                        },
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    GetReporteSuscripcionesZenriseQuery,
    GetReporteSuscripcionesZenriseQueryVariables
>;
export const GetStripePricesDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'getStripePrices' },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'stripePrices' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'product_id' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'limit' },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'product_name',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'unit_amount',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'currency' },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    GetStripePricesQuery,
    GetStripePricesQueryVariables
>;
export const GetSuscripcionesActivasDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'getSuscripcionesActivas' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'pagination' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: {
                                kind: 'Name',
                                value: 'CursorPaginationParams',
                            },
                        },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'sparkline' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'Boolean' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: {
                            kind: 'Name',
                            value: 'suscripcionesActivasConnection',
                        },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'pagination' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'pagination' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'pageInfo' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'endCursor',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'hasNextPage',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'edges' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'estado',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'pasarela',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'pasarela_id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'es_manual',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'fecha_ultimo_pago',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'fecha_proximo_pago',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'fecha_creacion',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'source_active',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'plan',
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'id',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'nombre_publico',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'nombre_privado',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'precio',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'limite',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'uso',
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'id',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'notificaciones',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'proyectado',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'dias',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'cuenta',
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'id',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'nombre',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'legacy_id',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'tn_store_id',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'condicion_ante_iva',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'tipo_doc',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'documento',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'pais',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'uso',
                                                            },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'id',
                                                                        },
                                                                    },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'notificaciones',
                                                                        },
                                                                    },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'proyectado',
                                                                        },
                                                                    },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'dias',
                                                                        },
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'sparkline',
                                                            },
                                                            directives: [
                                                                {
                                                                    kind: 'Directive',
                                                                    name: {
                                                                        kind: 'Name',
                                                                        value: 'include',
                                                                    },
                                                                    arguments: [
                                                                        {
                                                                            kind: 'Argument',
                                                                            name: {
                                                                                kind: 'Name',
                                                                                value: 'if',
                                                                            },
                                                                            value: {
                                                                                kind: 'Variable',
                                                                                name: {
                                                                                    kind: 'Name',
                                                                                    value: 'sparkline',
                                                                                },
                                                                            },
                                                                        },
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    GetSuscripcionesActivasQuery,
    GetSuscripcionesActivasQueryVariables
>;
export const GetSuscripcionesParaCancelarPorFaltaDePagoAdminDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: {
                kind: 'Name',
                value: 'getSuscripcionesParaCancelarPorFaltaDePagoAdmin',
            },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'fecha' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: {
                            kind: 'Name',
                            value: 'cancelarSuscripcionesPorFaltaDePagoPreview',
                        },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'fecha' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'fecha' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'estado' },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'fecha_proximo_pago',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'cuenta' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'nombre',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'email_pagos',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'legacy_id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'tn_store_id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'trial',
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'id',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'estado',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'fecha_fin',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    GetSuscripcionesParaCancelarPorFaltaDePagoAdminQuery,
    GetSuscripcionesParaCancelarPorFaltaDePagoAdminQueryVariables
>;
export const GetSuscripcionesParaCancelarQueEstabanEsperandoAdminDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: {
                kind: 'Name',
                value: 'getSuscripcionesParaCancelarQueEstabanEsperandoAdmin',
            },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'fecha' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: {
                            kind: 'Name',
                            value: 'terminarSuscripcionesQueEstabanHastaFinDePeriodoPreview',
                        },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'fecha' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'fecha' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'estado' },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'fecha_proximo_pago',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'cuenta' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'nombre',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'email_pagos',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'legacy_id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'tn_store_id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'trial',
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'id',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'estado',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'fecha_fin',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    GetSuscripcionesParaCancelarQueEstabanEsperandoAdminQuery,
    GetSuscripcionesParaCancelarQueEstabanEsperandoAdminQueryVariables
>;
export const GetTrialsActivosConnectionDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'getTrialsActivosConnection' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'pagination' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: {
                                kind: 'Name',
                                value: 'CursorPaginationParams',
                            },
                        },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'filters' },
                    },
                    type: {
                        kind: 'NamedType',
                        name: {
                            kind: 'Name',
                            value: 'TrialsActivosConnectionFilters',
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: {
                            kind: 'Name',
                            value: 'trialsActivosConnection',
                        },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'pagination' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'pagination' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'filters' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'filters' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'pageInfo' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'hasNextPage',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'endCursor',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'edges' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'fecha_creacion',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'fecha_fin',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'cuenta_id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'cuenta',
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'id',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'udn',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'pais',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'nombre',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'tn_store_id',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'legacy_id',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'bloqueada',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'bloqueo_fecha',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'bloqueo_razon',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    GetTrialsActivosConnectionQuery,
    GetTrialsActivosConnectionQueryVariables
>;
export const GetTrialsAdminDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'getTrialsAdmin' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'params' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'TrialsQueryParams' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'trials' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'params' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'params' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'estado' },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'fecha_creacion',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'fecha_fin' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'cuenta' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'nombre',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'email_desde_legacy',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'tn_store_id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'tienda_url',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'contratacionActiva',
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'id',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'estado',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'uso',
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'id',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'notificaciones',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'proyectado',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'dias',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GetTrialsAdminQuery, GetTrialsAdminQueryVariables>;
export const GetTrialsParaTerminarDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'getTrialsParaTerminar' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'fecha' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'trialsParaTerminar' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'fecha' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'fecha' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'estado' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'fecha_fin' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'cuenta' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'nombre',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'pais',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'udn',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'legacy_id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'tn_store_id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'tienda_url',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'contratacionActiva',
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'id',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'estado',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'suscripcionActiva',
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'id',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'estado',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    GetTrialsParaTerminarQuery,
    GetTrialsParaTerminarQueryVariables
>;
export const GetTusFacturasLogsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'getTusFacturasLogs' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'params' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: {
                                kind: 'Name',
                                value: 'SimplePaginationParams',
                            },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tusfacturasLogs' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'params' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'params' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'url' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'created_at' },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'requestBody',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'method' },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'requestHeaders',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'responseStatus',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'responseBody',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'responseHeaders',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    GetTusFacturasLogsQuery,
    GetTusFacturasLogsQueryVariables
>;
export const GetTusFacturasWebhooksDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'getTusFacturasWebhooks' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'params' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'WebhookQueryParams' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tusFacturasWebhooks' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'params' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'params' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'external_reference',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'type' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'body' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'estado' },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'resultado_ok',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'resultado_mensaje',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'created_at' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'updated_at' },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    GetTusFacturasWebhooksQuery,
    GetTusFacturasWebhooksQueryVariables
>;
export const UltimasSuscripcionesDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'ultimasSuscripciones' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'pagination' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: {
                                kind: 'Name',
                                value: 'CursorPaginationParams',
                            },
                        },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'filters' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: {
                                kind: 'Name',
                                value: 'UltimasSuscripcionesConnectionFilters',
                            },
                        },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'sparkline' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'Boolean' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: {
                            kind: 'Name',
                            value: 'ultimasSuscripcionesConnection',
                        },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'filters' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'filters' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'pagination' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'pagination' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'pageInfo' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'endCursor',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'hasNextPage',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'edges' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'estado',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'estado_full',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'dunning_empezado',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'pasarela',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'pasarela_id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'es_manual',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'fecha_ultimo_pago',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'fecha_proximo_pago',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'fecha_creacion',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'source_active',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'plan_id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'udn',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'stripe_price_currency',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'stripe_price_amount',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'stripe_price_id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'stripe_product_id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'stripe_product_name',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'plan',
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'id',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'nombre_publico',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'nombre_privado',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'precio',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'limite',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'uso',
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'id',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'notificaciones',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'proyectado',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'dias',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'cuenta_id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'cuenta',
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'id',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'nombre',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'legacy_id',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'tn_store_id',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'condicion_ante_iva',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'tipo_doc',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'documento',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'pais',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'udn',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'datos_desde_tn_traidos',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'datos_desde_tn_traidos_error_code',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'datos_desde_tn_traidos_error_fecha',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'datos_desde_tn_traidos_error_desc',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'uso',
                                                            },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'id',
                                                                        },
                                                                    },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'notificaciones',
                                                                        },
                                                                    },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'proyectado',
                                                                        },
                                                                    },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'dias',
                                                                        },
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'sparkline',
                                                            },
                                                            directives: [
                                                                {
                                                                    kind: 'Directive',
                                                                    name: {
                                                                        kind: 'Name',
                                                                        value: 'include',
                                                                    },
                                                                    arguments: [
                                                                        {
                                                                            kind: 'Argument',
                                                                            name: {
                                                                                kind: 'Name',
                                                                                value: 'if',
                                                                            },
                                                                            value: {
                                                                                kind: 'Variable',
                                                                                name: {
                                                                                    kind: 'Name',
                                                                                    value: 'sparkline',
                                                                                },
                                                                            },
                                                                        },
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    UltimasSuscripcionesQuery,
    UltimasSuscripcionesQueryVariables
>;
export const GetUnidadDeNegocioDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'getUnidadDeNegocio' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'cuenta_id' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cuentaEnAuth' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'cuenta_id' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'pais' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'udn' },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'cuentaEnLegacy' },
                        name: { kind: 'Name', value: 'cuentaMerge' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'cuenta_id' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'pais' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'udn' },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cuentaEnSubs' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'cuenta_id' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'pais' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'udn' },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    GetUnidadDeNegocioQuery,
    GetUnidadDeNegocioQueryVariables
>;
export const GetUsuariosAdminDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'getUsuariosAdmin' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'params' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: {
                                kind: 'Name',
                                value: 'UsuariosInputParams',
                            },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'usuarios' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'params' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'params' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'email' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'uid' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'cid' },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'isSuperAdmin',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'stUserId' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'updatedAt' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'createdAt' },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'fecha_creacion_manual',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'password_temporal',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'password_temporal_pendiente_resetear',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    GetUsuariosAdminQuery,
    GetUsuariosAdminQueryVariables
>;
export const GetUsuariosPorCuentaAdminDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'getUsuariosPorCuentaAdmin' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cuenta' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'id' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'legacy_id' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'roles' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'rolNombre',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'usuario',
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'id',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'email',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'stUserId',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'uid',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'createdAt',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'updatedAt',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'fecha_creacion_manual',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'password_temporal',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'password_temporal_pendiente_resetear',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cuentaMerge' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'id' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'user_id' },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    GetUsuariosPorCuentaAdminQuery,
    GetUsuariosPorCuentaAdminQueryVariables
>;
export const GetZenriseLogsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'getZenriseLogs' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'filters' },
                    },
                    type: {
                        kind: 'NamedType',
                        name: {
                            kind: 'Name',
                            value: 'ZenriseLogsConnectionFilters',
                        },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'params' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: {
                                kind: 'Name',
                                value: 'CursorPaginationParams',
                            },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ZenriseLogsConnection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'filters' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'filters' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'pagination' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'params' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'edges' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'node',
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'id',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'url',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'cuenta_id',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'created_at',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'requestBody',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'method',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'requestHeaders',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'responseStatus',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'responseBody',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'responseHeaders',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'pageInfo' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'hasNextPage',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'endCursor',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GetZenriseLogsQuery, GetZenriseLogsQueryVariables>;
export const GetZenriseWebhooksConnectionDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'getZenriseWebhooksConnection' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'filters' },
                    },
                    type: {
                        kind: 'NamedType',
                        name: {
                            kind: 'Name',
                            value: 'ZenriseWebhooksConnectionFilters',
                        },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'pagination' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: {
                                kind: 'Name',
                                value: 'CursorPaginationParams',
                            },
                        },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'incluirCuenta' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'Boolean' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'connection' },
                        name: {
                            kind: 'Name',
                            value: 'zenriseWebhooksConnection',
                        },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'filters' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'filters' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'pagination' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'pagination' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'pageInfo' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'endCursor',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'hasNextPage',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'edges' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'node',
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'id',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'cuenta_id',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'type',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'body',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'estado',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'resultado_ok',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'resultado_mensaje',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'created_at',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'updated_at',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'cuenta',
                                                            },
                                                            directives: [
                                                                {
                                                                    kind: 'Directive',
                                                                    name: {
                                                                        kind: 'Name',
                                                                        value: 'include',
                                                                    },
                                                                    arguments: [
                                                                        {
                                                                            kind: 'Argument',
                                                                            name: {
                                                                                kind: 'Name',
                                                                                value: 'if',
                                                                            },
                                                                            value: {
                                                                                kind: 'Variable',
                                                                                name: {
                                                                                    kind: 'Name',
                                                                                    value: 'incluirCuenta',
                                                                                },
                                                                            },
                                                                        },
                                                                    ],
                                                                },
                                                            ],
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'id',
                                                                        },
                                                                    },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'nombre',
                                                                        },
                                                                    },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'suscripcionActiva',
                                                                        },
                                                                        selectionSet:
                                                                            {
                                                                                kind: 'SelectionSet',
                                                                                selections:
                                                                                    [
                                                                                        {
                                                                                            kind: 'Field',
                                                                                            name: {
                                                                                                kind: 'Name',
                                                                                                value: 'id',
                                                                                            },
                                                                                        },
                                                                                        {
                                                                                            kind: 'Field',
                                                                                            name: {
                                                                                                kind: 'Name',
                                                                                                value: 'estado',
                                                                                            },
                                                                                        },
                                                                                    ],
                                                                            },
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    GetZenriseWebhooksConnectionQuery,
    GetZenriseWebhooksConnectionQueryVariables
>;
export const ActivateGeneralHoldDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'activateGeneralHold' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'reason' },
                    },
                    type: {
                        kind: 'NamedType',
                        name: { kind: 'Name', value: 'String' },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'activateGeneralHold' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'reason' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'reason' },
                                },
                            },
                        ],
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    ActivateGeneralHoldMutation,
    ActivateGeneralHoldMutationVariables
>;
export const AnularCancelacionDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'anularCancelacion' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'cuenta_id' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'anularCancelacion' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'cuenta_id' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'cuenta_id' },
                                },
                            },
                        ],
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    AnularCancelacionMutation,
    AnularCancelacionMutationVariables
>;
export const BloquearCuentaDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'bloquearCuenta' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'cuenta_id' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'bloquearCuenta' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'cuenta_id' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'cuenta_id' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'motivo' },
                                value: {
                                    kind: 'EnumValue',
                                    value: 'BLOQUEO_MANUAL',
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'skipEmail' },
                                value: { kind: 'BooleanValue', value: true },
                            },
                        ],
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    BloquearCuentaMutation,
    BloquearCuentaMutationVariables
>;
export const CambiarDatosFacturacionDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'cambiarDatosFacturacion' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'params' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: {
                                kind: 'Name',
                                value: 'CambiarDatosFacturacionParams',
                            },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: {
                            kind: 'Name',
                            value: 'cambiarDatosFacturacion',
                        },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'params' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'params' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'tipo_doc' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'documento' },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'razon_social',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'condicion_ante_iva',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'domicilio' },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    CambiarDatosFacturacionMutation,
    CambiarDatosFacturacionMutationVariables
>;
export const CancelacionConServicioHastaFinPeriodoManualAdminDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: {
                kind: 'Name',
                value: 'cancelacionConServicioHastaFinPeriodoManualAdmin',
            },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'cuenta_id' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cancelar' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'params' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: {
                                                kind: 'Name',
                                                value: 'cuenta_id',
                                            },
                                            value: {
                                                kind: 'Variable',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'cuenta_id',
                                                },
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    CancelacionConServicioHastaFinPeriodoManualAdminMutation,
    CancelacionConServicioHastaFinPeriodoManualAdminMutationVariables
>;
export const CancelacionInmediataManualAdminDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'cancelacionInmediataManualAdmin' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'cuenta_id' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: {
                            kind: 'Name',
                            value: 'cancelacionInmediataManual',
                        },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'cuenta_id' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'cuenta_id' },
                                },
                            },
                        ],
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    CancelacionInmediataManualAdminMutation,
    CancelacionInmediataManualAdminMutationVariables
>;
export const CancelacionInmediataPorFaltaDePagoDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'cancelacionInmediataPorFaltaDePago' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'cuenta_id' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: {
                            kind: 'Name',
                            value: 'cancelacionInmediataPorFaltaDePago',
                        },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'cuenta_id' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'cuenta_id' },
                                },
                            },
                        ],
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    CancelacionInmediataPorFaltaDePagoMutation,
    CancelacionInmediataPorFaltaDePagoMutationVariables
>;
export const CancelarCuentaDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'cancelarCuenta' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'params' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: {
                                kind: 'Name',
                                value: 'InputCancelarParams',
                            },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cancelar' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'params' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'params' },
                                },
                            },
                        ],
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    CancelarCuentaMutation,
    CancelarCuentaMutationVariables
>;
export const ConfirmarAcreditacionPagoPorTransferenciaDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: {
                kind: 'Name',
                value: 'confirmarAcreditacionPagoPorTransferencia',
            },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'cuenta_id' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'fecha_ultimo_pago' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'fecha_proximo_pago' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'plan_id' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: {
                            kind: 'Name',
                            value: 'confirmarAcreditacionPagoPorTransferencia',
                        },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'cuenta_id' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'cuenta_id' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'plan_id' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'plan_id' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: {
                                    kind: 'Name',
                                    value: 'fecha_ultimo_pago',
                                },
                                value: {
                                    kind: 'Variable',
                                    name: {
                                        kind: 'Name',
                                        value: 'fecha_ultimo_pago',
                                    },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: {
                                    kind: 'Name',
                                    value: 'fecha_proximo_pago',
                                },
                                value: {
                                    kind: 'Variable',
                                    name: {
                                        kind: 'Name',
                                        value: 'fecha_proximo_pago',
                                    },
                                },
                            },
                        ],
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    ConfirmarAcreditacionPagoPorTransferenciaMutation,
    ConfirmarAcreditacionPagoPorTransferenciaMutationVariables
>;
export const ContratarStripeDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'contratarStripe' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'cuenta_id' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'stripe_price_id' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'contratarStripe' },
                        name: {
                            kind: 'Name',
                            value: 'iniciarContratacionStripe',
                        },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'params' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: {
                                                kind: 'Name',
                                                value: 'cuenta_id',
                                            },
                                            value: {
                                                kind: 'Variable',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'cuenta_id',
                                                },
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: {
                                                kind: 'Name',
                                                value: 'stripe_price_id',
                                            },
                                            value: {
                                                kind: 'Variable',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'stripe_price_id',
                                                },
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'ok' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'url' },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'mensaje_error',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    ContratarStripeMutation,
    ContratarStripeMutationVariables
>;
export const ContratarZenriseDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'contratarZenrise' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'contratacion_id' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'nombre' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'dni' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'cuenta_id' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'token' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'JSON' },
                        },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'es_tarjeta_credito' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'Boolean' },
                        },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'plan_id' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'contratarZenrise' },
                        name: {
                            kind: 'Name',
                            value: 'iniciarContratacionZenrise',
                        },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'params' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: {
                                                kind: 'Name',
                                                value: 'contratacion_id',
                                            },
                                            value: {
                                                kind: 'Variable',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'contratacion_id',
                                                },
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: {
                                                kind: 'Name',
                                                value: 'nombre',
                                            },
                                            value: {
                                                kind: 'Variable',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'nombre',
                                                },
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: {
                                                kind: 'Name',
                                                value: 'dni',
                                            },
                                            value: {
                                                kind: 'Variable',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'dni',
                                                },
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: {
                                                kind: 'Name',
                                                value: 'cuenta_id',
                                            },
                                            value: {
                                                kind: 'Variable',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'cuenta_id',
                                                },
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: {
                                                kind: 'Name',
                                                value: 'token',
                                            },
                                            value: {
                                                kind: 'Variable',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'token',
                                                },
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: {
                                                kind: 'Name',
                                                value: 'es_tarjeta_credito',
                                            },
                                            value: {
                                                kind: 'Variable',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'es_tarjeta_credito',
                                                },
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: {
                                                kind: 'Name',
                                                value: 'plan_id',
                                            },
                                            value: {
                                                kind: 'Variable',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'plan_id',
                                                },
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'ok' },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'mensaje_error',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    ContratarZenriseMutation,
    ContratarZenriseMutationVariables
>;
export const CrearUsuarioManualDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'crearUsuarioManual' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'params' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: {
                                kind: 'Name',
                                value: 'CrearUsuarioManualmenteParams',
                            },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: {
                            kind: 'Name',
                            value: 'crearUsuarioManualmente',
                        },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'params' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'params' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    CrearUsuarioManualMutation,
    CrearUsuarioManualMutationVariables
>;
export const DeactivateGeneralHoldDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'deactivateGeneralHold' },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'deactivateGeneralHold' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    DeactivateGeneralHoldMutation,
    DeactivateGeneralHoldMutationVariables
>;
export const DesbloquearCuentaDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'desbloquearCuenta' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'cuenta_id' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'desbloquearCuenta' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'cuenta_id' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'cuenta_id' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'motivo' },
                                value: {
                                    kind: 'EnumValue',
                                    value: 'BLOQUEO_MANUAL',
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'skipEmail' },
                                value: { kind: 'BooleanValue', value: true },
                            },
                        ],
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    DesbloquearCuentaMutation,
    DesbloquearCuentaMutationVariables
>;
export const DesestimarContratacionManualAdminDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'desestimarContratacionManualAdmin' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'cuenta_id' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'desestimarContratacion' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'cuenta_id' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'cuenta_id' },
                                },
                            },
                        ],
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    DesestimarContratacionManualAdminMutation,
    DesestimarContratacionManualAdminMutationVariables
>;
export const EmitirNotaCreditoEnAfipDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'emitirNotaCreditoEnAfip' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'cobro_id' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: {
                            kind: 'Name',
                            value: 'emitirNotaCreditoEnAfip',
                        },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'cobro_id' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'cobro_id' },
                                },
                            },
                        ],
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    EmitirNotaCreditoEnAfipMutation,
    EmitirNotaCreditoEnAfipMutationVariables
>;
export const FacturarEnAfipDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'facturarEnAfip' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'cobro_id' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'facturarEnAfip' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'cobro_id' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'cobro_id' },
                                },
                            },
                        ],
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    FacturarEnAfipMutation,
    FacturarEnAfipMutationVariables
>;
export const FacturarVariosEnAfipDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'facturarVariosEnAfip' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'cantidad' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'Int' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'facturarVariosEnAfip' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'cantidad' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'cantidad' },
                                },
                            },
                        ],
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    FacturarVariosEnAfipMutation,
    FacturarVariosEnAfipMutationVariables
>;
export const FixDatosDesdeLegacyDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'fixDatosDesdeLegacy' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'cuenta_id' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fixDatosDesdeLegacy' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'cuenta_id' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'cuenta_id' },
                                },
                            },
                        ],
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    FixDatosDesdeLegacyMutation,
    FixDatosDesdeLegacyMutationVariables
>;
export const InformarPagoPorTransferenciaDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'informarPagoPorTransferencia' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'cuenta_id' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'plan_id' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'fecha_ultimo_pago' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'fecha_proximo_pago' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: {
                            kind: 'Name',
                            value: 'confirmo_pago_acreditado',
                        },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'Boolean' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: {
                            kind: 'Name',
                            value: 'informarPagoPorTransferencia',
                        },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'cuenta_id' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'cuenta_id' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: {
                                    kind: 'Name',
                                    value: 'fecha_ultimo_pago',
                                },
                                value: {
                                    kind: 'Variable',
                                    name: {
                                        kind: 'Name',
                                        value: 'fecha_ultimo_pago',
                                    },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: {
                                    kind: 'Name',
                                    value: 'fecha_proximo_pago',
                                },
                                value: {
                                    kind: 'Variable',
                                    name: {
                                        kind: 'Name',
                                        value: 'fecha_proximo_pago',
                                    },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'plan_id' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'plan_id' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: {
                                    kind: 'Name',
                                    value: 'confirmo_pago_acreditado',
                                },
                                value: {
                                    kind: 'Variable',
                                    name: {
                                        kind: 'Name',
                                        value: 'confirmo_pago_acreditado',
                                    },
                                },
                            },
                        ],
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    InformarPagoPorTransferenciaMutation,
    InformarPagoPorTransferenciaMutationVariables
>;
export const MandarPlanZenRiseDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'mandarPlanZenRise' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'plan_id' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'mandarPlanZenRise' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'plan_id' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'plan_id' },
                                },
                            },
                        ],
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    MandarPlanZenRiseMutation,
    MandarPlanZenRiseMutationVariables
>;
export const MarcarCobrosParaFacturarDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'marcarCobrosParaFacturar' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'selection' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'ListType',
                            type: {
                                kind: 'NonNullType',
                                type: {
                                    kind: 'NamedType',
                                    name: {
                                        kind: 'Name',
                                        value: 'CobroParaFacturarInput',
                                    },
                                },
                            },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: {
                            kind: 'Name',
                            value: 'marcarCobrosParaFacturar',
                        },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'selection' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'selection' },
                                },
                            },
                        ],
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    MarcarCobrosParaFacturarMutation,
    MarcarCobrosParaFacturarMutationVariables
>;
export const MarcarComoCanceladaDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'marcarComoCancelada' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'cuenta_id' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'marcarComoCancelada' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'cuenta_id' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'cuenta_id' },
                                },
                            },
                        ],
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    MarcarComoCanceladaMutation,
    MarcarComoCanceladaMutationVariables
>;
export const MigracionCancelarDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'migracionCancelar' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'cuenta_id' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'comentario' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'migracionCancelar' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'cuenta_id' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'cuenta_id' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'comentario' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'comentario' },
                                },
                            },
                        ],
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    MigracionCancelarMutation,
    MigracionCancelarMutationVariables
>;
export const MigracionMarcarComoListaDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'migracionMarcarComoLista' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'cuenta_id' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'fecha_proximo_pago' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'Date' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: {
                            kind: 'Name',
                            value: 'migracionMarcarComoLista',
                        },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'cuenta_id' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'cuenta_id' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: {
                                    kind: 'Name',
                                    value: 'fecha_proximo_pago',
                                },
                                value: {
                                    kind: 'Variable',
                                    name: {
                                        kind: 'Name',
                                        value: 'fecha_proximo_pago',
                                    },
                                },
                            },
                        ],
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    MigracionMarcarComoListaMutation,
    MigracionMarcarComoListaMutationVariables
>;
export const MigracionPasarGestionManualDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'migracionPasarGestionManual' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'cuenta_id' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: {
                            kind: 'Name',
                            value: 'migracionPasarGestionManual',
                        },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'cuenta_id' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'cuenta_id' },
                                },
                            },
                        ],
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    MigracionPasarGestionManualMutation,
    MigracionPasarGestionManualMutationVariables
>;
export const ObtenerLinkCobroZenriseDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'obtenerLinkCobroZenrise' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'cuenta_id' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'invoice_id' },
                    },
                    type: {
                        kind: 'NamedType',
                        name: { kind: 'Name', value: 'Int' },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: {
                            kind: 'Name',
                            value: 'obtenerLinkCobroZenrise',
                        },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'cuenta_id' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'cuenta_id' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'invoice_id' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'invoice_id' },
                                },
                            },
                        ],
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    ObtenerLinkCobroZenriseMutation,
    ObtenerLinkCobroZenriseMutationVariables
>;
export const ProcesarIpnDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'procesarIPN' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'procesarIPN' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'id' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'ok' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'mensaje' },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<ProcesarIpnMutation, ProcesarIpnMutationVariables>;
export const ProcesarTusFacturasWebhookDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'procesarTusFacturasWebhook' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'rst' },
                        name: {
                            kind: 'Name',
                            value: 'procesarTusFacturasWebhook',
                        },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'id' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'ok' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'mensaje' },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    ProcesarTusFacturasWebhookMutation,
    ProcesarTusFacturasWebhookMutationVariables
>;
export const ProcesarZenriseWebhookDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'procesarZenriseWebhook' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'rst' },
                        name: { kind: 'Name', value: 'procesarZenriseWebhook' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'id' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'ok' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'mensaje' },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    ProcesarZenriseWebhookMutation,
    ProcesarZenriseWebhookMutationVariables
>;
export const PutHoldOnEmailDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'putHoldOnEmail' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'email' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'reason' },
                    },
                    type: {
                        kind: 'NamedType',
                        name: { kind: 'Name', value: 'String' },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'putHoldOnEmail' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'email' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'email' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'reason' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'reason' },
                                },
                            },
                        ],
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    PutHoldOnEmailMutation,
    PutHoldOnEmailMutationVariables
>;
export const RecibirIpnDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'recibirIPN' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'content' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'testSimularIPNRecibido' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'content' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'content' },
                                },
                            },
                        ],
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<RecibirIpnMutation, RecibirIpnMutationVariables>;
export const ReleaseHoldOnEmailDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'releaseHoldOnEmail' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'email' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'releaseHoldOnEmail' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'email' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'email' },
                                },
                            },
                        ],
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    ReleaseHoldOnEmailMutation,
    ReleaseHoldOnEmailMutationVariables
>;
export const StripeCrearPortalSessionDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'stripeCrearPortalSession' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'cuenta_id' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: {
                            kind: 'Name',
                            value: 'stripeCrearPortalSession',
                        },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'cuenta_id' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'cuenta_id' },
                                },
                            },
                        ],
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    StripeCrearPortalSessionMutation,
    StripeCrearPortalSessionMutationVariables
>;
export const TestRecibirTusFacturasWebhookDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'testRecibirTusFacturasWebhook' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'content' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: {
                            kind: 'Name',
                            value: 'testSimularTusFacturasWebhookRecibido',
                        },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'content' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'content' },
                                },
                            },
                        ],
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    TestRecibirTusFacturasWebhookMutation,
    TestRecibirTusFacturasWebhookMutationVariables
>;
export const VerificarInstalacionDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'verificarInstalacion' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'cid' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'verificarInstalacion' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'cid' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'cid' },
                                },
                            },
                        ],
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    VerificarInstalacionMutation,
    VerificarInstalacionMutationVariables
>;
export const PedirNuevoReporteZenriseDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'pedirNuevoReporteZenrise' },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: {
                            kind: 'Name',
                            value: 'pedirNuevoReporteZenrise',
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    PedirNuevoReporteZenriseMutation,
    PedirNuevoReporteZenriseMutationVariables
>;
export const TestCrearTrialDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'testCrearTrial' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'dias' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'Int' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'testCrearCuentaEnTrial' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'dias' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'dias' },
                                },
                            },
                        ],
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    TestCrearTrialMutation,
    TestCrearTrialMutationVariables
>;
export const AnalisisTimingZenriseWebhooksAndIpnsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: {
                kind: 'Name',
                value: 'analisisTimingZenriseWebhooksAndIPNS',
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: {
                            kind: 'Name',
                            value: 'analisisTimingZenriseWebhooksAndIPNS',
                        },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'cuenta_id' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'nombre' },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'fecha_ultimo_pago',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'fecha_proximo_pago',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'days_since_last_webhook',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'last_webhook_id',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'days_since_last_ipn',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'last_ipn_id',
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'cuenta' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'suscripcionActiva',
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'id',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'estado',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'estado_full',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'dunning_empezado',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'fecha_ultimo_pago',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'fecha_proximo_pago',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    AnalisisTimingZenriseWebhooksAndIpnsQuery,
    AnalisisTimingZenriseWebhooksAndIpnsQueryVariables
>;
export const ApiResponseDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'apiResponse' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'cuenta_id' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'apiResponse' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'cuenta_id' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'cuenta_id' },
                                },
                            },
                        ],
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<ApiResponseQuery, ApiResponseQueryVariables>;
export const BorrarNotificacionesDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'borrarNotificaciones' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'input' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: {
                                kind: 'Name',
                                value: 'InputBorrarNotificaciones',
                            },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'BorrarNotificaciones' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'input' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'input' },
                                },
                            },
                        ],
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    BorrarNotificacionesMutation,
    BorrarNotificacionesMutationVariables
>;
export const CargarSettingsCustomerDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'cargarSettingsCustomer' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'cuenta_en_subs' },
                        name: { kind: 'Name', value: 'cuenta' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'id' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'nombre' },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'cuenta' },
                        name: { kind: 'Name', value: 'cuentaMerge' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'id' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'settings' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'initialDelay',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'delayBetween',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'startOnScroll',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'informativaConfig',
                                    },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'active',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'body',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'title',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'displayTime',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'position',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'mobilePosition',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'showTo',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'mobileDisabled',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'clickUrl',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'clickEnabled',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'clickOpenNewTab',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'template',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'theme',
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'highlightColor',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'textColor',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'smallTextColor',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'backgroundColor',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'ultimasVentasConfig',
                                    },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'active',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'displayTime',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'position',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'mobilePosition',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'mobileSize',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'showTo',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'mobileDisabled',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'hideTimeAgo',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'hideTimeAgoHs',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'hideCliente',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'hideClienteAlternative',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'clickEnabled',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'clickOpenNewTab',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'template',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'theme',
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'highlightColor',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'textColor',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'smallTextColor',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'backgroundColor',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'sinceDays',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    CargarSettingsCustomerQuery,
    CargarSettingsCustomerQueryVariables
>;
export const CohortSuscripcionesMonthsAliveDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'cohortSuscripcionesMonthsAlive' },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: {
                            kind: 'Name',
                            value: 'cohortSuscripcionesMonthsAlive',
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    CohortSuscripcionesMonthsAliveQuery,
    CohortSuscripcionesMonthsAliveQueryVariables
>;
export const CuentasDesbloqueadasSinMotivoDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'cuentasDesbloqueadasSinMotivo' },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: {
                            kind: 'Name',
                            value: 'cuentasDesbloqueadasSinMotivo',
                        },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'nombre' },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    CuentasDesbloqueadasSinMotivoQuery,
    CuentasDesbloqueadasSinMotivoQueryVariables
>;
export const GuardarInformativaDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'guardarInformativa' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'cuenta_id' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'input' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: {
                                kind: 'Name',
                                value: 'InputInformativaConfig',
                            },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'resultado' },
                        name: {
                            kind: 'Name',
                            value: 'CambiarInformativaConfig',
                        },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'cuenta_id' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'cuenta_id' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'input' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'input' },
                                },
                            },
                        ],
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    GuardarInformativaMutation,
    GuardarInformativaMutationVariables
>;
export const GuardarSettingsCustomerDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'guardarSettingsCustomer' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'cuenta_id' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'input' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'InputSettings' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'resultado' },
                        name: { kind: 'Name', value: 'CambiarSettings' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'cuenta_id' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'cuenta_id' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'settings' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'input' },
                                },
                            },
                        ],
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    GuardarSettingsCustomerMutation,
    GuardarSettingsCustomerMutationVariables
>;
export const GuardarUltimasVentasConfigDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'guardarUltimasVentasConfig' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'cuenta_id' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'input' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: {
                                kind: 'Name',
                                value: 'InputUltimasVentasConfig',
                            },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'resultado' },
                        name: {
                            kind: 'Name',
                            value: 'CambiarUltimasVentasConfig',
                        },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'cuenta_id' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'cuenta_id' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'input' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'input' },
                                },
                            },
                        ],
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    GuardarUltimasVentasConfigMutation,
    GuardarUltimasVentasConfigMutationVariables
>;
export const StripeLogConnectionDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'stripeLogConnection' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'cuenta_id' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'stripeLogConnection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'filters' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: {
                                                kind: 'Name',
                                                value: 'cuenta_id',
                                            },
                                            value: {
                                                kind: 'Variable',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'cuenta_id',
                                                },
                                            },
                                        },
                                    ],
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'pagination' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: {
                                                kind: 'Name',
                                                value: 'firsts',
                                            },
                                            value: {
                                                kind: 'IntValue',
                                                value: '20',
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'pageInfo' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'endCursor',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'hasNextPage',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'edges' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'updated_at',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'created_at',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'url',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'requestBody',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'method',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'user_id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'responseStatus',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'responseBody',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    StripeLogConnectionQuery,
    StripeLogConnectionQueryVariables
>;
export const StripeWebhookConnectionDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'stripeWebhookConnection' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'cuenta_id' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'String' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: {
                            kind: 'Name',
                            value: 'stripeWebhookConnection',
                        },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'filters' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: {
                                                kind: 'Name',
                                                value: 'cuenta_id',
                                            },
                                            value: {
                                                kind: 'Variable',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'cuenta_id',
                                                },
                                            },
                                        },
                                    ],
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'pagination' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: {
                                                kind: 'Name',
                                                value: 'firsts',
                                            },
                                            value: {
                                                kind: 'IntValue',
                                                value: '20',
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'pageInfo' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'endCursor',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'hasNextPage',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'edges' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'type',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'estado',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'resultado_ok',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'resultado_mensaje',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'created_at',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    StripeWebhookConnectionQuery,
    StripeWebhookConnectionQueryVariables
>;
export const TasksConnectionDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'tasksConnection' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'filters' },
                    },
                    type: {
                        kind: 'NamedType',
                        name: { kind: 'Name', value: 'TasksConnectionFilters' },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'pagination' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: {
                                kind: 'Name',
                                value: 'CursorPaginationParams',
                            },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tasksConnection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'filters' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'filters' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'pagination' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'pagination' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'pageInfo' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'startCursor',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'endCursor',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'hasNextPage',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'edges' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'cuenta_id',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'created_at',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'completed_at',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'failed_at',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'nombre',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'idem_key',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'resultado_ok',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'parametros',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'error',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'aws_log_group_name',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'aws_log_stream_name',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'cuenta',
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'id',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'nombre',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'suscripcionActiva',
                                                            },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'id',
                                                                        },
                                                                    },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'dunning_empezado',
                                                                        },
                                                                    },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'estado',
                                                                        },
                                                                    },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'fecha_ultimo_pago',
                                                                        },
                                                                    },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'fecha_proximo_pago',
                                                                        },
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    TasksConnectionQuery,
    TasksConnectionQueryVariables
>;
export const TestUserEnSubsMutationDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'testUserEnSubsMutation' },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'testUserEnSubsMutation' },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    TestUserEnSubsMutationMutation,
    TestUserEnSubsMutationMutationVariables
>;
export const TodayDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'today' },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'now' } },
                ],
            },
        },
    ],
} as unknown as DocumentNode<TodayQuery, TodayQueryVariables>;
